export default {
  '1': [
    {
      arab: 'اَللّٰهُمَّ اِنِّٓى اَسْئَلُكَ بِاَسْمَٓائِكَ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:',
      latin: 'Allâhümme innî es’elüke biesmâike',
    },
    {
      arab: 'َيَا اَللّٰهُ',
      meal: 'Ey her şeyin gerçek Mâbudu olan Allah,',
      latin: 'Ya Allah',
    },
    {
      arab: 'يَا رَحْمٰنُ',
      meal: 'Ey ayırt etmeden bütün mahlûkatı rızıklandıran Rahman,',
      latin: 'Ya Rahman',
    },
    {
      arab: 'يَا رَحِيمُ',
      meal: 'Ey itaatkar kullarına hususi rahmet eden Rahîm,',
      latin: 'Ya Rahîm',
    },
    { arab: 'يَا عَلِيمُ', meal: 'Ey her şeyi bilen Alîm,', latin: 'Ya Alîm' },
    {
      arab: 'يَا حَلِيمُ',
      meal: 'Ey yumuşak muamele eden Halîm,',
      latin: 'Ya Halîm',
    },
    {
      arab: 'يَا عَظِيمُ',
      meal: 'Ey sonsuz büyüklük ve yücelik sahibi olan Azîm,',
      latin: 'Ya Azîm',
    },
    {
      arab: 'يَا حَكِيمُ',
      meal: 'Ey her şeyi hikmetle yaratan Hakîm,',
      latin: 'Ya Hakîm',
    },
    {
      arab: 'يَا قَدِيمُ',
      meal: 'Ey varlığının başlangıcı olmayan Kadîm,',
      latin: 'Ya Kadîm',
    },
    {
      arab: 'يَا مُقِيمُ',
      meal: 'Ey her şeyi ayakta tutan Mukîm,',
      latin: 'Ya Mukîm',
    },
    {
      arab: 'يَا كَرِيمُ',
      meal: 'Ey iyilik ve ikramı bol olan Kerîm,',
      latin: 'Ya Kerîm',
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nar.',
    },
  ],
  '2': [
    {
      arab: 'يَا سَيِّدَ السَّادَاتِ',
      meal: 'Ey efendilerin efendisi,',
      latin: 'Yâ Seyyide’s-sâdât',
      no: 1,
    },
    {
      arab: 'يَا مُجِيبَ الدَّعَوَاتِ',
      meal: 'Ey dualara cevap veren,',
      latin: 'Yâ Mucîbe’d-de’avât',
      no: 2,
    },
    {
      arab: 'يَا وَلِىَّ الْحَسَنَاتِ',
      meal: 'Ey iyiliklerin sahibi,',
      latin: 'Yâ Veliyye’l-hasenât',
      no: 3,
    },
    {
      arab: 'يَا رَفِيعَ الدَّرَجَاتِ',
      meal: 'Ey dereceleri yükselten,',
      latin: 'Yâ Refıa’d-deracât',
      no: 4,
    },
    {
      arab: 'يَا عَظِيمَ الْبَرَكَاتِ',
      meal: 'Ey bereketleri büyük olan,',
      latin: 'Yâ Azîme’l-berakât',
      no: 5,
    },
    {
      arab: 'يَا غَافِرَ الْخَطِيئَاتِ',
      meal: 'Ey hataları bağışlayan,',
      latin: 'Yâ Ğafıra’l-hatîât',
      no: 6,
    },
    {
      arab: 'يَا دَافِعَ الْبَلِيَّاتِ',
      meal: 'Ey belaları def eden,',
      latin: 'Yâ Dâfî’a’l-beliyyât',
      no: 7,
    },
    {
      arab: 'يَا سَامِعَ الْاَصْوَاتِ',
      meal: 'Ey sesleri işiten,',
      latin: 'Yâ Sâmi’a’l-esvât',
      no: 8,
    },
    {
      arab: 'يَا مُعْطِىَ الْمَسْئوُلَاتِ',
      meal: 'Ey dilekleri veren,',
      latin: 'Yâ Mu’tıye’l-mesûlât',
      no: 9,
    },
    {
      arab: 'يَا عَالِمَ السِّرِّ وَ الْخَفِيَّاتِ',
      meal: 'Ey sır ve gizlilikleri bilen,',
      latin: 'Yâ ‘Alime’s-sirri ve’l-hafiyyât',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nar.',
    },
  ],
  '3': [
    {
      arab: 'يَا خَيْرَ الْغَافِرِينَ',
      meal: 'Ey bağışlayanların en hayırlısı,',
      latin: 'Ya Hayra’l-ğâfirîn',
      no: 1,
    },
    {
      arab: 'يَا خَيْرَ النَّاصِرِينَ',
      meal: 'Ey yardım edenlerin en hayırlısı,',
      latin: 'Ya Hayra’n-nâsırîn',
      no: 2,
    },
    {
      arab: 'يَا خَيْرَ الْحَاكِمِينَ',
      meal: 'Ey hükmedenlerin en hayırlısı,',
      latin: 'Ya Hayra’l-hâkimîn',
      no: 3,
    },
    {
      arab: 'يَا خَيْرَ الْفَاتِحِينَ',
      meal: 'Ey her şeyi açan ve fethedenlerin en hayırlısı,',
      latin: 'Ya Hayra’l-fatihîn',
      no: 4,
    },
    {
      arab: 'يَا خَيْرَ الذَّاكِرِينَ',
      meal: 'Ey zikredenlerin ve zikredenleri mükafatlandıranların en hayırlısı,',
      latin: 'Yâ Hayra’z-zâkirîn',
      no: 5,
    },
    {
      arab: 'يَا خَيْرَ الْوَارِثِينَ',
      meal: 'Ey vârislerin en hayırlısı,',
      latin: 'Yâ Hayra’l-vârişîn',
      no: 6,
    },
    {
      arab: 'يَا خَيْرَ الْحَامِدِينَ',
      meal: 'Ey övenlerin ve övenleri mükafatlandıranların en hayırlısı,',
      latin: 'Yâ Hayra’l-hâmidîn',
      no: 7,
    },
    {
      arab: 'يَا خَيْرَ الرَّازِقِينَ',
      meal: 'Ey rızık verenlerin en hayırlısı,',
      latin: 'Yâ Hayra’r-râzikîn',
      no: 8,
    },
    {
      arab: 'يَا خَيْرَ الْفَاصِلِينَ',
      meal: 'Ey zor işleri halledenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-fâsilîn',
      no: 9,
    },
    {
      arab: 'يَا خَيْرَ الْمُحْسِنِينَ',
      meal: 'Ey ihsan edenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-muhsinîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '4': [
    {
      arab: 'يَا مَنْ لَهُ الْعِزُّ وَ الْجَمَالُ',
      meal: 'Ey izzet ve güzelliğin gerçek sahibi,',
      latin: 'Yâ Men lehü’l-‘izzü ve’l-cemâl',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَهُ الْمُلْكُ وَ الْجَلَالُ',
      meal: 'Ey mülk ve celâlin gerçek sahibi,',
      latin: 'Yâ Men lehü’l-mülkü ve’l-celâl',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَهُ الْقُدْرَةُ وَ الْكَمَالُ',
      meal: 'Ey kudret ve kemâlin gerçek sahibi,',
      latin: 'Yâ Men lehü’l-kudretü ve’l-kemâl',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ الْكَبِيرُ الْمُتَعَالِ',
      meal: 'Ey büyük ve yüce olan,',
      latin: 'Yâ Men hüve’l-kebîru’l-müte’âl',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ شَدِيدُ الْمِحَالِ',
      meal: 'Ey şiddetli azap sahibi olan,',
      latin: 'Yâ Men hüve şedîdü’l-mihâl',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ شَدِيدُ الْعِقَابِ',
      meal: 'Ey ikâbı şiddetli olan,',
      latin: 'Yâ Men hüve şedîdü’l-‘ikâb',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ سَرِيعُ الْحِسَابِ',
      meal: 'Ey hesâbı süratli gören,',
      latin: 'Yâ Men hüve serî’u’l-hisâb',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ عِنْدَهُ حُسْنُ الثَّوَابِ',
      meal: 'Ey katında güzel mükafatı bulunan,',
      latin: 'Yâ Men hüve ‘indehû hüsnü’s-şevâb',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ عِنْدَهُٓ اُمُّ الْكِتَابِ',
      meal: 'Ey katında Ümmül-Kitap bulunan,',
      latin: 'Yâ Men hüve ‘indehû ümmü’l-kitâb',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ يُنْشِىُٔ السَّحَابَ الثِّقَالَ',
      meal: 'Ey rahmet yüklü bulutları yaratan,',
      latin: 'Yâ Men hüve yünşiü’s-sehâbe’s-sikâl',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '5': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا حَنَّانُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum: Ey sonsuz merhamet sahibi olan Hannân,',
      latin: 'Ve es’elüke biesmâike Yâ Hannân',
      no: 1,
    },
    {
      arab: 'يَا مَنَّانُ',
      meal: 'Ey hakiki iyilik ve ihsan sahibi Mennân,',
      latin: 'Yâ Mennân',
      no: 2,
    },
    {
      arab: 'يَا دَيَّانُ',
      meal: 'Ey kullarının amellerine karşılık veren Deyyân,',
      latin: 'Yâ Deyyân',
      no: 3,
    },
    {
      arab: 'يَا غُفْرَانُ',
      meal: 'Ey bağışlaması bol olan Ğufrân,',
      latin: 'Yâ Gufran',
      no: 4,
    },
    {
      arab: 'يَا بُرْهَانُ',
      meal: 'Ey kullarına yol gösteren Burhân,',
      latin: 'Yâ Burhan',
      no: 5,
    },
    {
      arab: 'يَا سُلْطَانُ',
      meal: 'Ey gerçek saltanat sahibi Sultân,',
      latin: 'Yâ Sultân',
      no: 6,
    },
    {
      arab: 'يَا سُبْحَانُ',
      meal: 'Ey bütün kusur ve noksanlardan uzak olan Sübhân,',
      latin: 'Yâ Subhân',
      no: 7,
    },
    {
      arab: 'يَا مُسْتَعَانُ',
      meal: 'Ey kendinden yardım istenen Müsteân,',
      latin: 'Yâ Muste’ân',
      no: 8,
    },
    {
      arab: 'يَا ذَا الْمَنِّ وَ الْبَيَانِ',
      meal: 'Ey nîmet ve beyân sahibi,',
      latin: 'Yâ Ze’l-menni ve’l-beyân',
      no: 9,
    },
    {
      arab: 'يَا ذَا الْاَمَانِ',
      meal: 'Ey emniyet ve emân sahibi,',
      latin: 'Yâ Ze’l-emâne',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '6': [
    {
      arab: 'يَا مَنْ تَوَاضَعَ كُلُّ شَىْءٍ لِعَظَمَتِهِ',
      meal: 'Ey azametine her şeyin boyun eğdiği,',
      latin: 'Yâ Men tevâda’a küllü şey’in li’azametih',
      no: 1,
    },
    {
      arab: 'يَا مَنِ اسْتَسْلَمَ كُلُّ شَىْءٍ لِقُدْرَتِهِ',
      meal: 'Ey kudretine her şeyin teslim olduğu,',
      latin: 'Yâ Meni’stesleme küllü şey’in likudratih',
      no: 2,
    },
    {
      arab: 'يَا مَنْ ذَلَّ كُلُّ شَىْءٍ لِعِزَّتِهِ',
      meal: 'Ey izzetine karşı her şeyin zelîl olduğu,',
      latin: 'Yâ Men zelle küllü şey’in li’izzetih',
      no: 3,
    },
    {
      arab: 'يَا مَنْ خَضَعَ كُلُّ شَىْءٍ لِهَيْبَتِهِ',
      meal: 'Ey heybetine her şeyin itaat ettiği,',
      latin: 'Yâ Men hada’a küllü şey’in liheybetih',
      no: 4,
    },
    {
      arab: 'يَا مَنِ انْقَادَ كُلُّ شَىْءٍ لِمُلْكَتِهِ',
      meal: 'Ey saltanatına karşı her şeyin inkıyat ettiği,',
      latin: 'Yâ Meni’nkâde küllü şey’in limülketih',
      no: 5,
    },
    {
      arab: 'يَا مَنْ دَانَ كُلُّ شَىْءٍ مِنْ مَخَافَتِهِ',
      meal: 'Ey korkusundan her şeyin kendisine boyun eğdiği,',
      latin: 'Yâ Men dâne küllü şey’in min mehâfetih',
      no: 6,
    },
    {
      arab: 'يَا مَنِ انْشَقَّتِ الْجِبَالُ مِنْ خَشْيَتِهِ',
      meal: 'Ey korkusundan dağların yarıldığı ve parçalandığı,',
      latin: 'Yâ Meni’nşakkati’l-cibâlü min haşyetin',
      no: 7,
    },
    {
      arab: 'يَا مَنْ قَامَتِ السَّمٰوَاتُ بِاَمْرِهِ',
      meal: 'Ey emriyle göklerin ayakta durduğu,',
      latin: 'Yâ Men kâmeti’s-semâvâtü bi emrih',
      no: 8,
    },
    {
      arab: 'يَا مَنِ اسْتَقَرَّتِ الْاَرْضُ بِاِذْنِهِ',
      meal: 'Ey izniyle yerin karar kıldığı,',
      latin: 'Yâ Meni’stekarrati’l-ardu bi iznih',
      no: 9,
    },
    {
      arab: 'َيَا مَنْ لَا يَعْتَدِى عَلىٰٓ اَهْلِ مَمْلَكَتِهِ',
      meal: 'Ey memleketinin ahâlisine zulmetmeyen,',
      latin: 'Yâ Men lâ yâ’tedî ‘alâ ehli memleketih',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '7': [
    {
      arab: 'يَا غَافِرَ الْخَطَايَا',
      meal: 'Ey hataları mağfiret eden,',
      latin: 'Yâ Ğâfıra’l-hatâyâ',
      no: 1,
    },
    {
      arab: 'يَا كَاشِفَ الْبَلَايَا',
      meal: 'Ey belaları kaldıran,',
      latin: 'Yâ Kâşife’l-belâyâ',
      no: 2,
    },
    {
      arab: 'يَا مُنْتَهَى الرَّجَايَا',
      meal: 'Ey ümitler kendisinde son bulan,',
      latin: 'Yâ Muntehe’r-racâyâ',
      no: 3,
    },
    {
      arab: 'يَا مُجْزِلَ الْعَطَايَا',
      meal: 'Ey ihsanı bol veren,',
      latin: 'Yâ Muczile’l-‘atâyâ',
      no: 4,
    },
    {
      arab: 'يَا وَاسِعَ الْهَدَايَا',
      meal: 'Ey hediyeleri geniş olan,',
      latin: 'Yâ Vâsi’a’l-hedâyâ',
      no: 5,
    },
    {
      arab: 'يَا رَازِقَ الْبَرَايَا',
      meal: 'Ey mahlûkata rızık veren,',
      latin: 'Yâ Râzika’l-berâyâ',
      no: 6,
    },
    {
      arab: 'يَا قَاضِىَ الْمُنَايَا',
      meal: 'Ey ölümlere karar veren,',
      latin: 'Yâ Kâdiya’l-münâyâ',
      no: 7,
    },
    {
      arab: 'يَا سَامِعَ الشَّكَايَا',
      meal: 'Ey şikâyetleri işiten,',
      latin: 'Yâ Sâmi’a’ş-şekâyâ',
      no: 8,
    },
    {
      arab: 'يَا بَاعِثَ السَّرَايَا',
      meal: 'Ey askerler gönderen,',
      latin: 'Yâ Bâ’ise’s-serâyâ',
      no: 9,
    },
    {
      arab: 'يَا مُطْلِقَ اْلاُسَارٰى',
      meal: '10‪-‬ ‪Ey esirleri salıveren,‬',
      latin: 'Yâ Mutlika’l-üsârâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '8': [
    {
      arab: 'يَا ذَا الْحَمْدِ وَ الثَّنَٓاءِ',
      meal: 'Ey hamd ve senâ sahibi,',
      latin: 'Yâ Ze’l-hamdi ve’s-senâ',
      no: 1,
    },
    {
      arab: 'يَا ذَا الْمَجْدِ وَ السَّنَٓاءِ',
      meal: '2‪-‬ Ey şeref ve yücelik sahibi,',
      latin: 'Yâ Ze’l-mecdi ve’s-senâ',
      no: 2,
    },
    {
      arab: 'يَا ذَا الْفَخْرِ وَ الْبَهَٓاءِ',
      meal: 'Ey fahir ve bahâ sahibi,',
      latin: 'Yâ Ze’l-fahri ve’l-behâ',
      no: 3,
    },
    {
      arab: 'يَا ذَا الْعَهْدِ وَ الْوَفَٓاءِ',
      meal: 'Ey ahd ve vefâ sahibi,',
      latin: 'Yâ Ze’l-‘ahdi ve’l-vefâ',
      no: 4,
    },
    {
      arab: 'يَا ذَا الْعَفْوِ وَ الرِّضَٓاءِ',
      meal: 'Ey af ve rızâ sahibi,',
      latin: 'Yâ Ze’l-‘afvi ve’r-ridâ',
      no: 5,
    },
    {
      arab: 'يَا ذَا الْمَنِّ وَ الْعَطَٓاءِ',
      meal: 'Ey iyilik ve bağış sahibi,',
      latin: 'Yâ Ze’l-menni ve’l-‘atâ',
      no: 6,
    },
    {
      arab: 'يَا ذَا الْفَصْلِ وَ الْقَضَٓاءِ',
      meal: 'Ey kesin söz ve hüküm sahibi,',
      latin: 'Yâ Ze’l-fasli ve’l-kadâ',
      no: 7,
    },
    {
      arab: 'يَا ذَا الْعِزَّةِ وَ الْبَقَٓاءِ',
      meal: 'Ey izzet ve sonsuzluk sahibi,',
      latin: 'Yâ Ze’l-‘izzeti ve’l-bekâ',
      no: 8,
    },
    {
      arab: 'يَا ذَا الْجُودِ وَ النَّعْمَٓاءِ',
      meal: 'Ey cömertlik ve nimetler sahibi,',
      latin: 'Yâ Ze’l-cûdi ve’n-na’mâ',
      no: 9,
    },
    {
      arab: 'يَا ذَا الْفَضْلِ وَ اْلاٰلَٓاءِ',
      meal: '10‪-‬ Ey karşılıksız iyilik ve gizli nimetler sahibi,',
      latin: 'Yâ Ze’l-fadli ve’l-‘âlâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '9': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:',
      latin: 'Ve es’elüke biesmâike',
      no: 1,
    },
    {
      arab: 'يَا مَانِعُ',
      meal: 'Ey olmamasını istediği şeyin meydana gelmesine engel olan Mâni’,',
      latin: 'Yâ Mâni’',
      no: 2,
    },
    {
      arab: 'يَا دَافِعُ',
      meal: 'Ey zararlı şeyleri ve mânileri defeden Dâfi’,',
      latin: 'Yâ Dâfi’',
      no: 3,
    },
    {
      arab: 'يَا نَافِعُ',
      meal: 'Ey faydalı şeyleri yaratan Nâfi’,',
      latin: 'Yâ Nâfi’',
      no: 4,
    },
    {
      arab: 'يَا سَامِعُ',
      meal: 'Ey bütün sesleri işiten Sâmi’,',
      latin: 'Yâ Sami’',
      no: 5,
    },
    {
      arab: 'يَا رَافِعُ',
      meal: 'Ey dilediklerinin mertebesini yükselten Râfi’,',
      latin: 'Yâ Râfi’',
      no: 6,
    },
    {
      arab: 'يَا صَانِعُ',
      meal: 'Ey her şeyi sanatla yaratan Sâni’,',
      latin: 'Yâ Sâni’',
      no: 7,
    },
    {
      arab: 'يَا شَافِعُ',
      meal: 'Ey kullarına şefaat eden Şâfi’,',
      latin: 'Yâ Şâfi’',
      no: 8,
    },
    {
      arab: 'يَا جَامِعُ',
      meal: 'Ey istediğini istediği şekilde toplayan Câmi’,',
      latin: 'Yâ Cami’',
      no: 9,
    },
    {
      arab: 'يَا وَاسِعُ',
      meal: 'Ey ilim ve ihsânı her şeyi içine alan Vâsi’,',
      latin: 'Yâ Vâsi’',
      no: 10,
    },
    {
      arab: 'يَا مُوسِعُ',
      meal: 'Ey istediği şeyi istediği şekilde genişletip bollaştıran Mûsi’,',
      latin: 'Yâ Mûsi’',
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
      no: 12,
    },
  ],
  '10': [
    {
      arab: 'يَا صَانِعَ كُلِّ مَصْنُوعٍ',
      meal: 'Ey bütün sanatların sanatkârı,',
      latin: 'Yâ Sâni’a külli masnû’',
      no: 1,
    },
    {
      arab: 'يَا خَالِقَ كُلِّ مَخْلُوقٍ',
      meal: 'Ey bütün mahlûkâtın yaratıcısı,',
      latin: 'Yâ Halika külli mahlûk',
      no: 2,
    },
    {
      arab: 'يَا رَازِقَ كُلِّ مَرْزُوقٍٍ',
      meal: 'Ey bütün rızıklananların rızık vericisi,',
      latin: 'Yâ Râzika külli merzûk',
      no: 3,
    },
    {
      arab: 'يَا مَالِكَ كُلِّ مَمْلُوكٍ',
      meal: 'Ey bütün sahip olunanların sahibi,',
      latin: 'Yâ Mâlike külli memlûk',
      no: 4,
    },
    {
      arab: 'يَا كَاشِفَ كُلِّ مَكْرُوبٍ',
      meal: 'Ey bütün sıkıntıya düşenlerin ferahlatıcısı,',
      latin: 'Yâ Kâşife külli mekrûb',
      no: 5,
    },
    {
      arab: 'يَا فَارِجَ كُلِّ مَغْمُومٍ',
      meal: 'Ey bütün üzüntüye düşenlerin sevindiricisi,',
      latin: 'Yâ Fârice külli mağmum',
      no: 6,
    },
    {
      arab: 'يَا رَاحِمَ كُلِّ مَرْحُومٍ',
      meal: 'Ey bütün merhamet olunanların merhamet edicisi,',
      latin: 'Yâ Râhime külli merhum',
      no: 7,
    },
    {
      arab: 'يَا نَاصِرَ كُلِّ مَخْذُولٍ',
      meal: 'Ey bütün yardımsız kalanların yardımcısı,',
      latin: 'Yâ Nasıra külli mahzûl',
      no: 8,
    },
    {
      arab: 'يَا سَاتِرَ كُلِّ مَعْيُوبٍ',
      meal: 'Ey bütün ayıplıların ayıplarını örten,',
      latin: 'Yâ Sâtira külli mâ’yûb',
      no: 9,
    },
    {
      arab: 'يَا مَلْجَاءَ كُلِّ مَظْلوُمٍ',
      meal: 'Ey bütün zulme uğrayanların sığınağı,',
      latin: 'Yâ Melcee külli mazlum',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '11': [
    {
      arab: 'يَا عُدَّتِى عِنْدَ شِدَّتِى',
      meal: 'Ey sıkıntım ânında hazırlığım,',
      latin: 'Yâ ‘Uddetî ‘inde şiddeti',
      no: 1,
    },
    {
      arab: 'يَا رَجَٓائِى عِنْدَ مُصِيبَتِى',
      meal: 'Ey musîbetim ânında ümidim,',
      latin: 'Yâ Recâî ‘inde müsîbeti',
      no: 2,
    },
    {
      arab: 'يَا مُونِسِى عِنْدَ وَحْشَتِى',
      meal: 'Ey yalnızlığım ânında arkadaşım,',
      latin: 'Yâ Mûnisî ‘inde vahşeti',
      no: 3,
    },
    {
      arab: 'يَا صَاحِبِى عِنْدَ غُرْبَتِى',
      meal: 'Ey gurbetliğimde dostum,',
      latin: 'Yâ Sâhibî ‘inde gurbeti',
      no: 4,
    },
    {
      arab: 'يَا وَلِيِّى عِنْدَ نِعْمَتِى',
      meal: 'Ey nîmetlendiğim anda sahibim,',
      latin: 'Yâ Veliyyî ‘inde ni’metî',
      no: 5,
    },
    {
      arab: 'يَا كَاشِفِى عِنْدَ كُرْبَتِى',
      meal: 'Ey kederim ânında ferahlatıcım,',
      latin: 'Yâ Kâşifi ‘inde kürbetî',
      no: 6,
    },
    {
      arab: 'يَا غِيَاثِى عِنْدَ افْتِقَار۪ى',
      meal: 'Ey ihtiyacım ânında yardımıma koşan,',
      latin: 'Yâ Ğıyâşî ‘inde’f-tikârî',
      no: 7,
    },
    {
      arab: 'يَا مَلْجَائِى عِنْدَ اضْطِرَار۪ى',
      meal: 'Ey zor durumumda sığınağım,',
      latin: 'Yâ Melceî ‘inde’d-dırârî',
      no: 8,
    },
    {
      arab: 'يَا مُعِينِى عِنْدَ فَزَعِى',
      meal: 'Ey korkum ânında yardımcım,',
      latin: 'Yâ Mu’înî ‘inde feze’î',
      no: 9,
    },
    {
      arab: 'يَا دَلِيلِى عِنْدَ حَيْرَتِى',
      meal: '10‪-‬ Ey şaşkınlığım ânında yol göstericim,',
      latin: 'Yâ Delîlî ‘inde hayrati',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '12': [
    {
      arab: 'يَا عَلَّا مَ الْغُيُوبِ',
      meal: 'Ey gaybları bilen,',
      latin: 'Yâ ‘Allâme’l-ğuyûb',
      no: 1,
    },
    {
      arab: 'يَا غَفَّارَ الذُّنُوبِ',
      meal: 'Ey günahları bağışlayan,',
      latin: 'Yâ Ğaffara’z-zünûb',
      no: 2,
    },
    {
      arab: 'يَا سَتَّارَ الْعُيُوبِ',
      meal: 'Ey ayıpları örten,',
      latin: 'Yâ Settâra’l-‘uyûb',
      no: 3,
    },
    {
      arab: 'يَا كَشَّافَ الْكُرُوبِ',
      meal: 'Ey sıkıntıları kaldıran,',
      latin: 'Yâ Keşşâfe’l-kürûb',
      no: 4,
    },
    {
      arab: 'يَا مُقَلِّبَ الْقُلُوبِ',
      meal: 'Ey kalpleri değiştiren,',
      latin: 'Yâ Mukallibe’l-kulûb',
      no: 5,
    },
    {
      arab: 'يَا مُزَيِّنَ الْقُلُوبِ',
      meal: 'Ey kalpleri süsleyen,',
      latin: 'Yâ Muzeyyine’l-kulûb',
      no: 6,
    },
    {
      arab: 'يَا مُنَوِّرَ الْقُلُوبِ',
      meal: 'Ey kalpleri nurlandıran,',
      latin: 'Yâ Munevvira’l-kulûb',
      no: 7,
    },
    {
      arab: 'يَا طَبِيبَ الْقُلُوبِ',
      meal: 'Ey kalplerin tabibi,',
      latin: 'Yâ Tabîbe’l-kulûb',
      no: 8,
    },
    {
      arab: 'يَا حَبِيبَ الْقُلُوبِ',
      meal: 'Ey kalplerin sevgilisi,',
      latin: 'Yâ Habîbe’l-kulûb',
      no: 9,
    },
    {
      arab: 'يَٓا اَنِيسَ الْقُلُوبِ',
      meal: 'Ey kalplerin dostu,',
      latin: 'Yâ Enîse’l-kulûb',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '13': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا جَلِيلُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum: Ey yücelik ve ululuk sahibi Celîl,',
      latin: 'Ve es’elüke biesmâike Yâ Celîl',
      no: 1,
    },
    {
      arab: 'يَا جَمِيلُ',
      meal: 'Ey gerçek güzellik sahibi Cemîl,',
      latin: 'Yâ Cemîl',
      no: 2,
    },
    {
      arab: 'يَا وَكِيلُ',
      meal: 'Ey kendine güvenen kullarının işini en iyi yoluna koyan Vekîl,',
      latin: 'Yâ Vekîl',
      no: 3,
    },
    {
      arab: 'يَا كَفِيلُ',
      meal: 'Ey kullarının tâkatini aşan işlerini üzerine alan Kefîl,',
      latin: 'Yâ Kefîl',
      no: 4,
    },
    {
      arab: 'يَا دَلِيلُ',
      meal: 'Ey kullarına yol gösteren Delîl,',
      latin: 'Yâ Delîl',
      no: 5,
    },
    {
      arab: 'يَا مُقِيلُ',
      meal: 'Ey kullarının hatâ ve yanlışlarını bağışlayan Mukîl,',
      latin: 'Yâ Mukîl',
      no: 6,
    },
    {
      arab: 'يَا خَبِيرُ',
      meal: 'Ey her şeyden haberdar olan Habîr,',
      latin: 'Yâ Habîr',
      no: 7,
    },
    {
      arab: 'يَا لَطِيفُ',
      meal: 'Ey lütuf ve keremi bol olan Latîf,',
      latin: 'Yâ Latîf',
      no: 8,
    },
    {
      arab: 'يَا عَزِيزُ',
      meal: 'Ey sonsuz izzet sahibi Azîz,',
      latin: 'Yâ Azîz',
      no: 9,
    },
    {
      arab: 'يَا مَلِيكُ',
      meal: 'Ey bütün mevcudâtın gerçek sahibi ve hükümdarı olan Melik,',
      latin: 'Yâ Melik',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '14': [
    {
      arab: 'يَا دَلِيلَ الْمُتَحَيِّرِينَ',
      meal: 'Ey şaşkınların yol göstericisi,',
      latin: 'Yâ Delîle’l-mütehayyirîn',
      no: 1,
    },
    {
      arab: 'يَا غِيَاثَ الْمُسْتَغِيثِينَ',
      meal: 'Ey yardım isteyenlerin yardımcısı,',
      latin: 'Yâ Gıyâse’l-müsteğîsîn',
      no: 2,
    },
    {
      arab: 'يَا صَرِيخَ الْمُسْتَصْرِخِينَ',
      meal: 'Ey medet isteyenlerin imdat edicisi,',
      latin: 'Yâ Sarîha’l-müstesrihîn',
      no: 3,
    },
    {
      arab: 'يَا جَارَ الْمُسْتَجِيرِينَ',
      meal: 'Ey korunmak isteyenlerin koruyucusu,',
      latin: 'Yâ Câra’l-müstecîrîn',
      no: 4,
    },
    {
      arab: 'يَا مَلْجَأَ الْعَاصِينَ',
      meal: 'Ey âsilerin sığınağı,',
      latin: 'Yâ Melcee’l-‘âsîn',
      no: 5,
    },
    {
      arab: 'يَا غَافِرَ الْمُذْنِبِينَ',
      meal: 'Ey günahkârların bağışlayıcısı,',
      latin: 'Yâ Ğâfıra’l-müznibîn',
      no: 6,
    },
    {
      arab: 'يَٓا اَمَانَ الْخَٓائِفِينَ',
      meal: 'Ey korkanlara emniyet veren,',
      latin: 'Yâ Emâne’l-hâifîn',
      no: 7,
    },
    {
      arab: 'يَا رَاحِمَ الْمَسَاكِينَ',
      meal: 'Ey miskinlere merhamet eden,',
      latin: 'Yâ Râhime’l-mesâkîn',
      no: 8,
    },
    {
      arab: 'يَٓا اَنِيسَ الْمُسْتَوْحِشِينَ',
      meal: 'Ey yalnızlık duyanların dostu,',
      latin: 'Yâ Enîse’l-müstevhişîn',
      no: 9,
    },
    {
      arab: 'يَا مُجِيبَ دَعْوَةِ الْمُضْطَرِّينَ',
      meal: 'Ey darda kalanların duâlarına cevap veren,',
      latin: 'Yâ Mucîbe da’veti’l-müdtarrîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '15': [
    {
      arab: 'يَا ذَا الْجُودِ وَ اْلاِحْسَانِ',
      meal: 'Ey cömertlik ve ihsan sahibi,',
      latin: 'Yâ Ze’l-cûdi ve’l-ihsân',
      no: 1,
    },
    {
      arab: 'يَا ذَا الْفَضْلِ وَ اْلاِمْتِنَانِ',
      meal: 'Ey fazıl ve iyilik sahibi,',
      latin: 'Yâ Ze’l-fadli ve’l-imtinân',
      no: 2,
    },
    {
      arab: 'يَا ذَا الْاَمْنِ وَ الْاَمَانِ',
      meal: 'Ey emniyet ve emân sahibi,',
      latin: 'Yâ Ze’l-emni ve’l-emân',
      no: 3,
    },
    {
      arab: 'يَا ذَا الْقُدْسِ وَ السُّبْحَانِ',
      meal: 'Ey kudsiyet ve kemalât sahibi,',
      latin: 'Yâ Ze’l-kudsi ve’s-sübhân',
      no: 4,
    },
    {
      arab: 'يَا ذَا الْحِكْمَةِ وَ الْبَيَانِ',
      meal: 'Ey hikmet ve beyan sahibi,',
      latin: 'Yâ Ze’l-hikmeti ve’l-beyân',
      no: 5,
    },
    {
      arab: 'يَا ذَا الرَّحْمَةِ وَ الرِّضْوَانِ',
      meal: 'Ey rahmet ve rıdvan sahibi,',
      latin: 'Yâ Ze’r-rahmeti ve’r-rıdvân',
      no: 6,
    },
    {
      arab: 'يَا ذَا الْحُجَّةِ وَ الْبُرْهَانِ',
      meal: 'Ey kesin delil ve bürhan sahibi,',
      latin: 'Yâ Ze’l-hucceti ve’l-bürhân',
      no: 7,
    },
    {
      arab: 'يَا ذَا الْعَظَمَةِ وَ السُّلْطَانِ',
      meal: 'Ey azamet ve saltanat sahibi,',
      latin: 'Yâ Ze’l-‘azameti ve’s-sultân',
      no: 8,
    },
    {
      arab: 'يَا ذَا الْعَفْوِ وَ الْغُفْرَانِ',
      meal: 'Ey af ve mağfiret sahibi,',
      latin: 'Yâ Ze’l-‘afvi ve’l-ğufrân',
      no: 9,
    },
    {
      arab: 'يَا ذَا الرَّأْفَةِ وَ الْمُسْتَعَانِ',
      meal: 'Ey kendisinden yardım istenen şefkat sahibi,',
      latin: 'Yâ Ze’r-ra’feti ve’l-müste’ân',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '16': [
    {
      arab: 'يَا مَنْ هُوَ رَبُّ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyin Rabbi,',
      latin: 'Yâ Men hüve Rabbü külli şey’',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ اِلٰهُ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyin ilâhı,',
      latin: 'Yâ Men hüve ilâhü külli şey’',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ خَالِقُ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyin yaratıcısı,',
      latin: 'Yâ Men hüve Hâliku külli şey’',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ فَوْقَ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyin üzerinde olan,',
      latin: 'Yâ Men hüve fevka külli şey’',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ قَبْلَ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyden önce olan,',
      latin: 'Yâ Men hüve kable külli şey’',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ بَعْدَ كُلِّ شَىْءٍ',
      meal: 'Ey fani olan her şey ve biten her zamandan sonra vücudu daim ve baki kalan,',
      latin: 'Yâ Men hüve ba’de külli şey’',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ عَالِمُ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyi bilen,',
      latin: 'Yâ Men hüve ‘Alimü külli şey’',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ قَادِرُ كُلِّ شَىْءٍ',
      meal: 'Ey her şeye gücü yeten,',
      latin: 'Yâ Men hüve Kâdiru külli şey’',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ صَانِعُ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyin Sâni’i,',
      latin: 'Yâ Men hüve Sâni’u külli şey’',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ يَبْقٰى وَ يَفْنٰى كُلُّ شَىْءٍ',
      meal: 'Ey her şey fenâ bulup, Kendisi bâki kalan',
      latin: 'Yâ Men hüve yebkâ veyefnâ küllü şey’',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '17': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُؤْمِنُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey kalplerde îman nûrunu yakan ve kullarına huzur ve güven veren Mü’min,',
      latin: 'Ve es’elüke biesmâike Yâ Mu’min',
      no: 1,
    },
    {
      arab: 'يَا مُهَيْمِنُ',
      meal: 'Ey bütün varlıkları ilim ve kontrolü altında tutan Müheymin,',
      latin: 'Yâ Muheymin',

      no: 2,
    },
    {
      arab: 'يَا مُكَوِّنُ',
      meal: 'Ey bütün mahlûkatı yoktan meydana getiren Mükevvin,',
      latin: 'Yâ Mukevvin',
      no: 3,
    },
    {
      arab: 'يَا مُلَقِّنُ',
      meal: 'Ey bütün yaratıklarına dünyadaki vazifelerini öğretip telkin eden Mülakkin,',
      latin: 'Yâ Mulakkin',
      no: 4,
    },
    {
      arab: 'يَا مُبَيِّنُ',
      meal: 'Ey kulları için açıklanması gereken her şeyi beyan eden Mübeyyin,',
      latin: 'Yâ Mubeyyin',
      no: 5,
    },
    {
      arab: 'يَا مُهَوِّنُ',
      meal: 'Ey musîbetleri hafifleten ve zorlukları kolaylaştıran Mühevvin,',
      latin: 'Yâ Muhevvin',
      no: 6,
    },
    {
      arab: 'يَا مُزَيِّنُ',
      meal: 'Ey her şeyi münasip şekilde süsleyen Müzeyyin,',
      latin: 'Yâ Muzeyyin',
      no: 7,
    },
    {
      arab: 'يَا مُعَظِّمُ',
      meal: 'Ey dilediğini yücelten ve kullarına büyüklüğünü gösteren Muazzım,',
      latin: 'Yâ Muazzîm',
      no: 8,
    },
    {
      arab: 'يَا مُعَوِّنُ',
      meal: 'Ey muhtaçların yardımına koşan Muavvin,',
      latin: 'Yâ Muavvin',
      no: 9,
    },
    {
      arab: 'يَا مُلَوِّنُ',
      meal: 'Ey her şeyi çeşit çeşit renklerle bezeyen Mülevvin,',
      latin: 'Yâ Mulevvin',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '18': [
    {
      arab: 'يَا مَنْ هُوَ فِى مُلْكِهِ مُقِيمٌ',
      meal: 'Ey mülkünde dâim olan,',
      latin: 'Yâ men hüve fî mülkihî mükîm',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى جَلَالِهِ عَظِيمٌ',
      meal: 'Ey celâlinde azîm olan,',
      latin: 'Yâ men hüve fî celâlihî ‘azîm',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى سُلْطَانِهِ قَدِيمٌ',
      meal: 'Ey saltanatında kadîm olan,',
      latin: 'Yâ men hüve fî sültânihî kadîm',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ عَلٰى عَبْدِهِ رَحِيمٌ',
      meal: 'Ey kullarına rahmet eden,',
      latin: 'Yâ men hüve ‘alâ ‘abdihî rahîm',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ بِكُلِّ شَىْءٍ عَلِيمٌ',
      meal: 'Ey her şeyi bilen,',
      latin: 'Yâ men hüve bikülli şey’in ‘alîm',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ لِمَنْ جَفَاهُ حَلِيمٌ',
      meal: 'Ey emirlerine uymayana halîm olan,',
      latin: 'Yâ men hüve limen cefâhu halîm',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ لِمَنْ تَرَجَّاهُ كَرِيمٌ',
      meal: 'Ey kendisine ümit bağlayana kerîm olan,',
      latin: 'Yâ men hüve limen teraccâhü kerîm',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى مَقَادِيرِهِ حَكِيمٌ',
      meal: 'Ey ölçülerinde hikmetli olan,',
      latin: 'Yâ men hüve fî mekâdîrihî hakim',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى حُكْمِهِ لَطِيفٌ',
      meal: 'Ey hükmünde lütuf sahibi olan,',
      latin: 'Yâ men hüve fi hükmihî latîf',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى لُطْفِهِ قَدِيرٌ',
      meal: 'Ey lütfünde kadîr olan,',
      latin: 'Yâ men hüve fı lütfihî kadîr',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '19': [
    {
      arab: 'يَا مَنْ لَا يُرْجىٰٓ اِلَّا فَضْلُهُ',
      meal: 'Ey fazlından başka bir şey ümit edilmeyen,',
      latin: 'Yâ men la yürcâ illâ fadlüh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا يُخَافُ اِلَّا عَدْلُهُ',
      meal: 'Ey adâletinden başka bir şeyden korkulmayan,',
      latin: 'Yâ men lâ yuhâfü illâ ‘adlüh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا يُنْتَظَرُ اِلَّا بِرُّهُ',
      meal: 'Ey iyiliğinden başka bir şey beklenmeyen,',
      latin: 'Yâ men lâ yuntezaru illa birruh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يُسْئَلُ اِلَّا عَفْوُهُ',
      meal: 'Ey affından başka bir şey istenmeyen,',
      latin: 'Yâ men lâ yus’elü illâ ‘afvüh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا يَدُومُ اِلَّا مُلْكُهُ',
      meal: 'Ey mülkünden başkası devam etmeyen',
      latin: 'Yâ men lâ yedûmü illâ mülküh',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا سُلْطَانَ اِلَّا سُلْطَانُهُ',
      meal: 'Ey saltanatından başka saltanat bulunmayan,',
      latin: 'Yâ men lâ sültâne illâ sültânüh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَا بُرْهَانَ اِلَّا بُرْهَانُهُ',
      meal: 'Ey burhanlarından başka burhan bulunmayan,',
      latin: 'Yâ men lâ bürhâne illâ bürhânüh',
      no: 7,
    },
    {
      arab: 'يَا مَنْ وَسِعَتْ كُلَّ شَىْءٍ رَحْمَتُهُ',
      meal: 'Ey rahmeti her şeyi kuşatmış olan,',
      latin: 'Yâ men vesiat külle şey’in rahmetüh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ سَبَقَتْ رَحْمَتُهُ عَلٰى غَضَبِهِ',
      meal: 'Ey rahmeti gazabını geçmiş olan,',
      latin: 'Yâ men sebekat rahmetühû ‘alâ ğadabih',
      no: 9,
    },
    {
      arab: 'يَا مَنْ اَحَاطَ بِكُلِّ شَىْءٍ عِلْمُهُ',
      meal: 'Ey ilmiyle her şeyi kuşatmış olan,',
      latin: 'Yâ men ehâta bi külli şey’in ‘ilmüh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '20': [
    {
      arab: 'يَا فَارِجَ الْهَمِّ',
      meal: 'Ey tasayı kaldıran,',
      latin: 'Yâ Fârice’l-hemm',
      no: 1,
    },
    {
      arab: 'يَا كَاشِفَ الْغَمِّ',
      meal: 'Ey gamı gideren,',
      latin: 'Yâ Kâşife’l-ğamm',
      no: 2,
    },
    {
      arab: 'يَا غَافِرَ الذَّنْبِ',
      meal: 'Ey günahı affeden,',
      latin: 'Yâ Gâfire’z-zenb',
      no: 3,
    },
    {
      arab: 'يَا قَابِلَ التَّوْبِ',
      meal: 'Ey tövbeyi kabul eden,',
      latin: 'Yâ Kâbile’t-tevb',
      no: 4,
    },
    {
      arab: 'يَاخَالِقَ الْخَلْقِ',
      meal: 'Ey yaratılmışların yaratıcısı,',
      latin: 'Yâ Hâlika’l-halk',
      no: 5,
    },
    {
      arab: 'يَا صَادِقَ الْوَعْدِ',
      meal: 'Ey vaadinde sâdık olan,',
      latin: 'Yâ Sâdika’l-va’d',
      no: 6,
    },
    {
      arab: 'يَا رَازِقَ الطِّفْلِ',
      meal: 'Ey yavrulara rızık veren,',
      latin: 'Yâ Râzika’t-tıfl',
      no: 7,
    },
    {
      arab: 'يَا مُوفِىَ الْعَهْدِ',
      meal: 'Ey sözünü yerine getiren,',
      latin: 'Yâ Mûfiye’l-‘ahd',
      no: 8,
    },
    {
      arab: 'يَا عَالِمَ السِّرِّ',
      meal: 'Ey gizliyi bilen,',
      latin: 'Yâ ‘Alime’s-sirr',
      no: 9,
    },
    {
      arab: 'يَا فَالِقَ الْحَبِّ',
      meal: 'Ey tohumu yarıp sümbüllendiren,',
      latin: 'Yâ Fâlika’l-habb',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '21': [
    {
      arab: 'فَاَسْئَلُكَ بِاَسْمآَئِكَ يَا عَلِىُّ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum: Ey her şeyiyle yüce olan Alî,',
      latin: 'Ve es’elüke biesmâike yâ ‘alî',
      no: 1,
    },
    {
      arab: 'يَا وَفِىُّ',
      meal: 'Ey sözünden vefâlı olan ve vaadinden dönmeyen Vefî,',
      latin: 'Yâ Vefî',
      no: 2,
    },
    {
      arab: 'يَا وَلِىُّ',
      meal: 'Ey müminlerin dostu olan Velî,',
      latin: 'Yâ Velî',
      no: 3,
    },
    {
      arab: 'يَا غَنِىُّ',
      meal: 'Ey gerçek zenginlik sahibi ve hiçbir şeye muhtaç olmayan Ganî,',
      latin: 'Yâ Ganî',
      no: 4,
    },
    {
      arab: 'يَا مَلِىُّ',
      meal: 'Ey sonsuz servet ve tükenmez hazineler sahibi Melî,',
      latin: 'Yâ Melîyy',
      no: 5,
    },
    {
      arab: 'يَا زَكِىُّ',
      meal: 'Ey her cihetten temiz ve pâk olan Zekî,',
      latin: 'Yâ Zekiyy',
      no: 6,
    },
    {
      arab: 'يَا رَضِىُّ',
      meal: 'Ey kendisine kulluk edenlerden hoşnut olan Razî,',
      latin: 'Yâ Radiyy',
      no: 7,
    },
    {
      arab: 'يَا بَدِىُّ',
      meal: 'Ey eser ve ihsanlarıyla varlığı apaçık görünen Bedî,',
      latin: 'Yâ Bediyy',
      no: 8,
    },
    {
      arab: 'يَا خَفِىُّ',
      meal: 'Ey şiddet-i zuhûrundan gizlenen Hafî,',
      latin: 'Yâ HafIyy',
      no: 9,
    },
    {
      arab: 'يَا قَوِىُّ',
      meal: 'Ey güç ve kuvveti sonsuz olan Kavî,',
      latin: 'Yâ Kaviyy',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '22': [
    {
      arab: 'يَا مَنْ اَظْهَرَ الْجَمِيلَ',
      meal: 'Ey güzeli açığa çıkaran,',
      latin: 'Yâ Men azhera’l-cemîl',
      no: 1,
    },
    {
      arab: 'يَا مَنْ سَتَرَ عَلَى الْقَبِيحِ',
      meal: 'Ey çirkinin üzerini örten,',
      latin: 'Yâ Men setera ‘ale’l-kabîh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا يُؤَاخِذُ بِالْجَرِيمَةِ',
      meal: 'Ey suç sebebiyle hemen azarlamayan,',
      latin: 'Yâ Men lâ yuâhizü bi’l-cerîmeh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يَهْتِكُ السِّتْرَ',
      meal: 'Ey ayıpların üzerindeki perdeyi yırtmayan,',
      latin: 'Yâ Men lâ yehtikü’s-sitr',
      no: 4,
    },
    {
      arab: 'يَا عَظِيمَ الْعَفْوِ',
      meal: 'Ey affı büyük olan,',
      latin: 'Yâ ‘Azîme’l-‘afv',
      no: 5,
    },
    {
      arab: 'يَا حَسَنَ التَّجَاوُزِ',
      meal: 'Ey günahkârları cezalandırmaktan vazgeçmesi güzel olan,',
      latin: 'Yâ Hasene’t-tecâvüz',
      no: 6,
    },
    {
      arab: 'يَا وَاسِعَ الْمَغْفِرَةِ',
      meal: 'Ey mağfireti geniş olan,',
      latin: 'Yâ Vâsi’a’l-mağfireh',
      no: 7,
    },
    {
      arab: 'يَا بَاسِطَ الْيَدَيْنِ بِالرَّحْمَةِ',
      meal: 'Ey rahmeti bol veren,',
      latin: 'Yâ Bâsita’l-yedeyni bi’r-rahmeh',
      no: 8,
    },
    {
      arab: 'يَا صَاحِبَ كُلِّ نَجْوٰى',
      meal: 'Ey bütün sessiz yalvarışların sahibi,',
      latin: 'Yâ Sahibe külli necvâ',
      no: 9,
    },
    {
      arab: 'يَا مُنْتَهٰى كُلِّ شَكْوٰى',
      meal: 'Ey bütün şikâyetler kendisinde son bulan,',
      latin: 'Yâ Muntehâ külli şekva',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '23': [
    {
      arab: 'يَا ذَا النِّعْمَةِ السَّابِغَةِ',
      meal: 'Ey bol nimet sahibi,',
      latin: 'Yâ Ze’n-ni’meti’s-sâbiğah',
      no: 1,
    },
    {
      arab: 'يَا ذَا الرَّحْمَةِ الْوَاسِعَةِ',
      meal: 'Ey geniş rahmet sahibi,',
      latin: 'Yâ Ze’r-rahmeti’l-vâsi’ah',
      no: 2,
    },
    {
      arab: 'يَا ذَا الْحِكْمَةِ الْبَالِغَةِ',
      meal: 'Ey tam hikmet sahibi,',
      latin: 'Yâ Ze’l-hikmeti’l-bâliğah',
      no: 3,
    },
    {
      arab: 'يَا ذَا الْقُدْرَةِ الْكَامِلَةِ',
      meal: 'Ey kâmil kudret sahibi,',
      latin: 'Yâ Ze’l-kudreti’l-kâmileh',
      no: 4,
    },
    {
      arab: 'يَا ذَا الْحُجَّةِ الْقَاطِعَةِ',
      meal: 'Ey kesin hüccet sahibi,',
      latin: 'Yâ Ze’l-hucceti’l-kâtı’ah',
      no: 5,
    },
    {
      arab: 'يَا ذَا الْكَرَامَةِ الظَّاهِرَةِ',
      meal: 'Ey açık ikram sahibi,',
      latin: 'Yâ Ze’l-kerâmeti’z-zâhirah',
      no: 6,
    },
    {
      arab: 'يَا ذَا الصِّفَةِ الْعَالِيَةِ',
      meal: 'Ey yüce sıfat sahibi,',
      latin: 'YâZe’s-sıfati’l-‘âliyeh',
      no: 7,
    },
    {
      arab: 'يَا ذَا الْعِزَّةِ الدَّٓائِمَةِ',
      meal: 'Ey dâim izzet sahibi,',
      latin: 'YâZe’l-‘izzeti’d-dâimeh',
      no: 8,
    },
    {
      arab: 'يَا ذَا الْقُوَّةِ الْمَتِينَةِ',
      meal: 'Ey metin kuvvet sahibi,',
      latin: 'Yâ Ze’l-kuvveti’l-metîneh',
      no: 9,
    },
    {
      arab: 'يَا ذَا الْمِنَّةِ السَّابِقَةِ',
      meal: 'Ey geçmiş minnet sahibi,',
      latin: 'Yâ Ze’l-minneti’s-sâbikah',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ entei-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '24': [
    {
      arab: 'يَٓا اَحْكَمَ الْحَاكِمِينَ',
      meal: 'Ey hükmedenlerin en hükmedicisi,',
      latin: 'Yâ Ahkeme’l-hâkimîn',
      no: 1,
    },
    {
      arab: 'يَٓا اَعْدَلَ الْعَادِلِينَ',
      meal: 'Ey âdillerin en adâletlisi,',
      latin: 'Yâ ‘Adele’l-‘âdilîn',
      no: 2,
    },
    {
      arab: 'يَٓا اَصْدَقَ الصَّادِقِينَ',
      meal: 'Ey doğruların en doğrusu,',
      latin: 'Yâ Asdeka’s-sâdikîn',
      no: 3,
    },
    {
      arab: 'يَٓا اَظْهَرَ الظَّاهِرِينَ',
      meal: 'Ey varlığı açık olanların en açığı,',
      latin: 'Yâ Azhera’z-zâhirîn',
      no: 4,
    },
    {
      arab: 'يَٓا اَطْهَرَ الطَّاهِرِينَ',
      meal: 'Ey temiz olanların en temizi,',
      latin: 'Yâ Athera’t-tâhirîn',
      no: 5,
    },
    {
      arab: 'يَٓا اَحْسَنَ الْخَالِقِينَ',
      meal: 'Ey yaratıcılık mertebelerinin en güzelinde olan,',
      latin: 'Yâ Ahsene’l-hâlikîn',
      no: 6,
    },
    {
      arab: 'يَٓا اَسْرَعَ الْحَاسِبِينَ',
      meal: 'Ey hesaba çekenlerin en süratlisi,',
      latin: 'Yâ Esra’a’l-hâsibîn',
      no: 7,
    },
    {
      arab: 'يَٓا اَسْمَعَ السَّامِعِينَ',
      meal: 'Ey işitenlerin en iyi işiticisi,',
      latin: 'Yâ Esme’a’s-sâmi’în',
      no: 8,
    },
    {
      arab: 'يَٓا اَكْرَمَ الْاَكْرَمِينَ',
      meal: 'Ey ikram edenlerin en iyi ikram edicisi,',
      latin: 'Yâ Ekrame’l-ekramîn',
      no: 9,
    },
    {
      arab: 'يَٓا اَرْحَمَ الرَّاحِمِينَ',
      meal: 'Ey merhamet edenlerin en merhametlisi,',
      latin: 'Yâ Erhame’r-râhimîn',
      no: 10,
    },
    {
      arab: 'يَٓا اَشْفَعَ الشَّافِعِينَ',
      meal: 'Ey şefaat edenlerin en şefaat edicisi,',
      latin: 'Yâ Eşfe’a’ş-şâfi’în',
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
      no: 12,
    },
  ],
  '25': [
    {
      arab: 'يَا بَدِيعَ السَّمٰوَاتِ',
      meal: 'Ey semâları yoktan yaratan,',
      latin: 'Yâ Bedi’a’s-semâvât',
      no: 1,
    },
    {
      arab: 'يَا جَاعِلَ الظُّلُمَاتِ',
      meal: 'Ey karanlıkları meydana getiren,',
      latin: 'Yâ Câ’ile’z-zulümât',
      no: 2,
    },
    {
      arab: 'يَا عَالِمَ الْخَفِيَّاتِ',
      meal: 'Ey gizlilikleri bilen,',
      latin: 'Yâ ‘A’lime’l-hafıyyât',
      no: 3,
    },
    {
      arab: 'يَا رَاحِمَ الْعَبَرَاتِ',
      meal: 'Ey için için üzülenlere acıyan,',
      latin: 'Yâ Râhîme’l-‘aberât',
      no: 4,
    },
    {
      arab: 'يَا سَاتِرَ الْعَوَرَاتِ',
      meal: 'Ey utanılacak şeyleri örten,',
      latin: 'Yâ Sâtira’l-‘averât',
      no: 5,
    },
    {
      arab: 'يَا كَاشِفَ الْبَلِيَّاتِ',
      meal: 'Ey belâları defeden,',
      latin: 'Yâ Kâşife’l-beliyyât',
      no: 6,
    },
    {
      arab: 'يَا مُحْيِىَ الْاَمْوَاتِ',
      meal: 'Ey ölüleri dirilten,',
      latin: 'Yâ Muhyiye’l-emvât',
      no: 7,
    },
    {
      arab: 'يَا ضَاعِفَ الْحَسَنَاتِ',
      meal: 'Ey sevapları kat kat yazan,',
      latin: 'Yâ Dâ’ife’l-hasenât',
      no: 8,
    },
    {
      arab: 'يَا مُنْزِلَ الْبَرَكَاتِ',
      meal: 'Ey bereketleri indiren,',
      latin: 'Yâ Munzile’l-berakât',
      no: 9,
    },
    {
      arab: 'يَا شَدِيدَ النَّقَمَاتِ',
      meal: 'Ey asilere hak ettikleri büyük ceza ve şiddetli azabı veren,',
      latin: 'Yâ Şedîde’n-nekamât',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '26': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُصَوِّرُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey her varlığa münasip şekil giydiren Musavvir,',
      latin: 'Ve es’elüke biesmâike, yâ Musavvir',
      no: 1,
    },
    {
      arab: 'يَا مُقَدِّرُ',
      meal: 'Ey her şeyin plan ve programını ölçülü yapan Mukaddir,',
      latin: 'Yâ Mukaddir',
      no: 2,
    },
    {
      arab: 'يَا مُطَهِّرُ',
      meal: 'Ey her şeyi maddi ve manevi kirlerden temizleyen Mutahhir,',
      latin: 'Yâ Mutahhir',
      no: 3,
    },
    {
      arab: 'يَا مُنَوِّرُ',
      meal: 'Ey nûruyla her şeyi nurlandıran Münevvir,',
      latin: 'Yâ Munevvir',
      no: 4,
    },
    {
      arab: 'يَا مُقَدِّمُ',
      meal: 'Ey dilediğini öne geçiren Mukaddim,',
      latin: 'Yâ Mukaddim',
      no: 5,
    },
    {
      arab: 'يَا مُؤَخِّرُ',
      meal: 'Ey istediğini arkaya bırakan Muahhir,',
      latin: 'Yâ Muahhir',
      no: 6,
    },
    {
      arab: 'يَا مُيَسِّرُ',
      meal: 'Ey hayırlı işleri kolaylaştıran Müyessir,',
      latin: 'Yâ Muyessir',

      no: 7,
    },
    {
      arab: 'يَا مُنْذِرُ',
      meal: 'Ey kullarını azâbıyla korkutan Münzir,',
      latin: 'Yâ Munzir',
      no: 8,
    },
    {
      arab: 'يَا مُبَشِّرُ',
      meal: 'Ey kullarını Cennet ve diğer mükafatlarla müjdeleyen Mübeşşir,',
      latin: 'Yâ Mubeşşir',
      no: 9,
    },
    {
      arab: 'يَا مُدَبِّرُ',
      meal: 'Ey bütün kâinatı tam bir nizam içinde idare eden Müdebbir,',
      latin: 'Yâ Mudebbir',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '27': [
    {
      arab: 'يَا رَبَّ الْبَيْتِ الْحَرَامِ',
      meal: 'Ey Beytül Haramın Rabbi',
      latin: 'Yâ Rabbe’l-beyti’l-harâm',
      no: 1,
    },
    {
      arab: 'يَا رَبَّ الشَّهْرِ الْحَرَامِ',
      meal: 'Ey haram ayların sahibi,',
      latin: 'Yâ Rabbe’ş-şehri’l-harâm',
      no: 2,
    },
    {
      arab: 'يَا رَبَّ الْمَسْجِدِ الْحَرَامِ',
      meal: 'Ey Mescidül Haramın Rabbi,',
      latin: 'Yâ Rabbe’l-mescidi’l-harâm',
      no: 3,
    },
    {
      arab: 'يَا رَبَّ الْبَلَدِ الْحَرَامِ',
      meal: 'Ey haram belde olan Mekke’nin Rabbi,',
      latin: 'Yâ Rabbe’l-beledi’l-harâm',
      no: 4,
    },
    {
      arab: 'يَا رَبَّ الرُّكْنِ وَ الْمَقَامِ',
      meal: 'Ey Rükn-ü Hacerül-Esved ve Makam-ı İbrahim’in Rabbi,',
      latin: 'Yâ Rabbe’r-rukni ve’l-mekâm',
      no: 5,
    },
    {
      arab: 'يَا رَبَّ الْمَشْعَرِ الْحَرَامِ',
      meal: 'Ey Meş’aril-Haramın Rabbi,',
      latin: 'Yâ Rabbe’l-meş’ari’l-harâm',
      no: 6,
    },
    {
      arab: 'يَا رَبَّ الْحِلِّ وَ الْحَرَامِ',
      meal: 'Ey helâl ve haramın Rabbi,',
      latin: 'Yâ Rabbe’l-hılli ve’l-haram',
      no: 7,
    },
    {
      arab: 'يَا رَبَّ النُّورِ وَ الظَّلَامِ',
      meal: 'Ey nur ve karanlığın Rabbi,',
      latin: 'Yâ Rabbe’n-nûri.ve’z-zalâm',
      no: 8,
    },
    {
      arab: 'يَا رَبَّ التَّحِيَّةِ وَ السَّلَامِ',
      meal: 'Ey tahiyyât ve selâmın Rabbi,',
      latin: 'Yâ Rabbe’t-tahiyyeti ve’s-selâm',
      no: 9,
    },
    {
      arab: 'يَا رَبَّ الْجَلَالِ وَ اْلاِكْرَامِ',
      meal: 'Ey celâl ve ikrâmın Rabbi,',
      latin: 'Yâ Rabbe’l-celâli ve’l-ikrâm',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '28': [
    {
      arab: 'يَا عِمَادَ مَنْ لَا عِمَادَ لَهُ',
      meal: 'Ey desteği olmayanların desteği,',
      latin: 'Yâ ‘İmâde men lâ ‘imâde leh',
      no: 1,
    },
    {
      arab: 'يَا سَنَدَ مَنْ لَا سَنَدَ لَهُ',
      meal: 'Ey dayanağı olmayanların dayanağı,',
      latin: 'Yâ Senede men lâ senede leh',
      no: 2,
    },
    {
      arab: 'يَا زُخْرَ مَنْ لَا زُخْرَ لَهُ',
      meal: 'Ey övünülecek bir şeyi olmayanların övüncü,',
      latin: 'Yâ Zühra men lâ zühra leh',
      no: 3,
    },
    {
      arab: 'يَا غِيَاثَ مَنْ لَا غِيَاثَ لَهُ',
      meal: 'Ey imdâda koşacak kimsesi olmayanların imdâdı,',
      latin: 'Yâ Giyâşe men lâ ğiyâşe leh',
      no: 4,
    },
    {
      arab: 'يَا حِرْزَ مَنْ لَا حِرْزَ لَهُ',
      meal: 'Ey korunacak yeri olmayanların koruyucusu,',
      latin: 'Yâ Hırze men lâ hırze leh',
      no: 5,
    },
    {
      arab: 'يَا فَخْرَ مَنْ لَا فَخْرَ لَهُ',
      meal: 'Ey iftihar edecek kimsesi olmayanların iftihârı,',
      latin: 'Yâ Fahra men lâ fahra leh',
      no: 6,
    },
    {
      arab: 'يَا عِزَّ مَنْ لَا عِزَّ لَهُ',
      meal: 'Ey izzeti olmayanların izzeti,',
      latin: 'Yâ ‘İzze men lâ ‘izze leh',
      no: 7,
    },
    {
      arab: 'يَا مُعِينَ مَنْ لَا مُعِينَ لَهُ',
      meal: 'Ey yardımcısı olmayanların yardımcısı,',
      latin: 'Yâ Mu’îne men lâ mu’îne leh',
      no: 8,
    },
    {
      arab: 'يَٓا اَنِيسَ مَنْ لَٓا اَنِيسَ لَهُ',
      meal: 'Ey dostu olmayanların dostu,',
      latin: 'Yâ Enîse men lâ enîse leh',
      no: 9,
    },
    {
      arab: 'يَا غُنْيَةَ مَنْ لَا غُنْيَةَ لَهُ',
      meal: 'Ey zenginliği olmayanların zenginliği,',
      latin: 'Yâ Gunyete men lâ gunyete leh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '29': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا قَٓائِمُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey varlığında başkasına muhtaç olmayan Kâim,',
      latin: 'Ve es’elüke biesmâike Yâ Kâim',
      no: 1,
    },
    {
      arab: 'يَا دَٓائِمُ',
      meal: 'Ey varlığının sonu olmayan Dâim,',
      latin: 'Yâ Dâim',
      no: 2,
    },
    {
      arab: 'يَا رَاحِمُ',
      meal: 'Ey mahlûkatına merhamet eden Râhim,',
      latin: 'Yâ Rahim',
      no: 3,
    },
    {
      arab: 'يَا حَاكِمُ',
      meal: 'Ey mevcudatına hükmeden Hâkim,',
      latin: 'Yâ Hâkim',
      no: 4,
    },
    {
      arab: 'يَا عَالِمُ',
      meal: 'Ey her şeyi bilen Âlim,',
      latin: 'Yâ ‘Âlim',
      no: 5,
    },
    {
      arab: 'يَا عَاصِمُ',
      meal: 'Ey yarattıklarını koruyan Âsım,',
      latin: 'Yâ ‘Âsim',
      no: 6,
    },
    {
      arab: 'يَا قَاسِمُ',
      meal: 'Ey her şeyi adâletle taksim eden Kâsım,',
      latin: 'Yâ Kâsim',
      no: 7,
    },
    {
      arab: 'يَا سَالِمُ',
      meal: 'Ey ayıp ve kusur kendisine ârız olmayan Sâlim,',
      latin: 'Yâ Salim',
      no: 8,
    },
    {
      arab: 'يَا قَابِضُ',
      meal: 'Ey istediğinin maddî ve mânevî rızkını daraltan Kâbıd,',
      latin: 'Yâ Kâbid',
      no: 9,
    },
    {
      arab: 'يَا بَاسِطُ',
      meal: 'Ey istediğinin maddî ve mânevî rızkını genişleten Bâsıt,',
      latin: 'Yâ Basit',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٢٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '30': [
    {
      arab: 'يَا عَاصِمَ مَنِ اسْتَعْصَمَهُ',
      meal: 'Ey kendisine sığınmak isteyenleri koruyan,',
      latin: 'Yâ ‘Âsıme-meni’sta’sameh',
      no: 1,
    },
    {
      arab: 'يَا رَاحِمَ مَنِ اسْتَرْحَمَهُ',
      meal: 'Ey kendisinden merhamet isteyenlere merhamet eden,',
      latin: 'Yâ Râhime meni’sterhameh',
      no: 2,
    },
    {
      arab: 'يَا نَاصِرَ مَنِ اسْتَنْصَرَهُ',
      meal: 'Ey kendisinden yardım isteyenlere yardım eden,',
      latin: 'Yâ Nasıra meni’stensarah',
      no: 3,
    },
    {
      arab: 'يَا حَافِظَ مَنِ اسْتَحْفَظَهُ',
      meal: 'Ey korunmak isteyenleri muhafaza eden,',
      latin: 'Yâ Hafıza meni’stahfezah',
      no: 4,
    },
    {
      arab: 'يَا مُكْرِمَ مَنِ اسْتَكْرَمَهُ',
      meal: 'Ey kendisinden ikram isteyenlere ikram eden,',
      latin: 'Yâ Mukrime meni’stekrameh',
      no: 5,
    },
    {
      arab: 'يَا مُرْشِدَ مَنِ اسْتَرْشَدَهُ',
      meal: 'Ey kendisinden irşad edilmeyi isteyenleri irşad eden,',
      latin: 'Yâ Murşide meni’sterşedeh',
      no: 6,
    },
    {
      arab: 'يَا مُعِينَ مَنِ اسْتَعَانَهُ',
      meal: 'Ey kendisinden inâyet isteyenlere inâyet eden,',
      latin: 'Yâ Mu’îne meni’ste’âneh',
      no: 7,
    },
    {
      arab: 'يَا مُغِيثَ مَنِ اسْتَغَاثَهُ',
      meal: 'Ey kendisinden imdat isteyenlere imdat eden,',
      latin: 'Yâ Muğîse meni’steğâseh',
      no: 8,
    },
    {
      arab: 'يَا صَرِيخَ مَنِ اسْتَصْرَخَهُ',
      meal: 'Ey feryat edenlerin feryâdına koşan,',
      latin: 'Yâ Sarîha meni’stesrahah',
      no: 9,
    },
    {
      arab: 'يَا غَافِرَ مَنِ اسْتَغْفَرَهُ',
      meal: 'Ey kendisinden mağfiret isteyenleri bağışlayan,',
      latin: 'Yâ Ğâfıra meni’stağferah',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٣٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’rı-nâr.',
    },
  ],
  '31': [
    {
      arab: 'يَا كَرِيمَ الصَّفْحِ',
      meal: 'Ey affı bol olan,',
      latin: 'Yâ Kerîme’s-saftı',
      no: 1,
    },
    {
      arab: 'يَا عَظِيمَ الْمَنِّ',
      meal: 'Ey iyiliği büyük olan,',
      latin: 'Yâ ‘Azîme’l-menn',
      no: 2,
    },
    {
      arab: 'يَا كَثِيرَ الْخَيْرِ',
      meal: 'Ey hayrı çok olan,',
      latin: 'Yâ Keşîra’l-hayr',
      no: 3,
    },
    {
      arab: 'يَا قَدِيمَ الْفَضْلِ',
      meal: 'Ey fazlı kadîm olan,',
      latin: 'Yâ Kadîme’l-fadl',
      no: 4,
    },
    {
      arab: 'يَا لَطِيفَ الصُّنْعِ',
      meal: 'Ey sanatı güzel olan,',
      latin: 'Yâ Latîfe’s-sun’',
      no: 5,
    },
    {
      arab: 'يَا دَٓائِمَ اللُّطْفِ',
      meal: 'Ey lütfü dâim olan,',
      latin: 'Yâ Dâime’l-lütf',
      no: 6,
    },
    {
      arab: 'يَا نَافِسَ الْكَرْبِ',
      meal: 'Ey sıkıntıyı gideren,',
      latin: 'Yâ Nâfise’l-kerb',
      no: 7,
    },
    {
      arab: 'يَا كَاشِفَ الضُّرِّ',
      meal: 'Ey zararı kaldıran,',
      latin: 'Yâ Kâşife’d-durr',
      no: 8,
    },
    {
      arab: 'يَا مَالِكَ الْمُلْكِ',
      meal: 'Ey mülkün sahibi,',
      latin: 'Yâ Mâlike’l-mülk',
      no: 9,
    },
    {
      arab: 'يَا قَاضِيًا بِالْحَقِّ',
      meal: 'Ey hak ile hükmeden,',
      latin: 'Yâ Kâdiyen bi’l-hakk',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '32': [
    {
      arab: 'يَا عَزِيزًا لَا يُضَامُ',
      meal: 'Ey mağlup edilmeyen Azîz,',
      latin: 'Yâ ‘Azîzen lâ yudâm',
      no: 1,
    },
    {
      arab: 'يَا لَطِيفًا لَا يُرَامُ',
      meal: 'Ey kendisinden uzaklaşılmayan Lâtîf,',
      latin: 'Yâ Latîfen lâ yurâm',
      no: 2,
    },
    {
      arab: 'يَا رَقِيبًا لَا يَنَامُ',
      meal: 'Ey uyumayan gözetleyici,',
      latin: 'Yâ Rakîben lâ yenâm',
      no: 3,
    },
    {
      arab: 'يَا قَٓائِمًا لَا يَفُوتُ',
      meal: 'Ey yok olmayan Mevcûd,',
      latin: 'Yâ Kaimen lâ yefût',
      no: 4,
    },
    {
      arab: 'يَا حَيًّا لَا يَمُوتُ',
      meal: 'Ey ölmeyen Hayy,',
      latin: 'Yâ Hayyen lâ yemût',
      no: 5,
    },
    {
      arab: 'يَا مَلِكًا لَا يَزُولُ',
      meal: 'Ey yok olmayan Melik,',
      latin: 'Yâ Meliken lâyezûl',
      no: 6,
    },
    {
      arab: 'يَا بَاقِيًا لَا يَفْنٰى',
      meal: 'Ey fenâ bulmayan Bâkî,',
      latin: 'Yâ Bakiyen lâ yefnâ',
      no: 7,
    },
    {
      arab: 'يَا عَالِمًا لَا يَجْهَلُ',
      meal: 'Ey cehalet ârız olmayan Âlim,',
      latin: 'Yâ ‘Alimen lâ yechel',
      no: 8,
    },
    {
      arab: 'يَا صَمَدًا لَا يُطْعَمُ',
      meal: 'Ey taama muhtaç olmayan Samed,',
      latin: 'Yâ Sameden lâ yut’âm',
      no: 9,
    },
    {
      arab: 'يَا قَوِيًّا لَا يُضْعَفُ',
      meal: 'Ey zaafa uğratılmayan Kavî,',
      latin: 'Yâ Kaviyyen lâ yud’af',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '33': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا وَاحِدُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey isimlerinde, sıfatlarında ve fiillerinde ortağı olmayan Vâhid,',
      latin: 'Ve es’elüke biesmâike Yâ Vâhid',
      no: 1,
    },
    {
      arab: 'يَا وَاجِدُ',
      meal: 'Ey istediğini bulan Vâcid,',
      latin: 'Yâ Vâcid',
      no: 2,
    },
    {
      arab: 'يَا شَاهِدُ',
      meal: 'Ey her yerde hâzır ve nâzır olan Şâhid,',
      latin: 'Yâ Şâhid',
      no: 3,
    },
    {
      arab: 'يَا مَاجِدُ',
      meal: 'Ey sonsuz şan ve yücelik sahibi Mâcid,',
      latin: 'Yâ Mâcid',
      no: 4,
    },
    {
      arab: 'يَا رَاشِدُ',
      meal: 'Ey bütün işlerini ezelî hikmetine göre neticeye ulaştıran Râşid,',
      latin: 'Yâ Râşid',
      no: 5,
    },
    {
      arab: 'يَا بَاعِثُ',
      meal: 'Ey peygamberler gönderen ve ölüleri dirilten Bâis,',
      latin: 'Yâ Bâis',
      no: 6,
    },
    {
      arab: 'يَا وَارِثُ',
      meal: 'Ey her şeyin hakiki ilk ve son sahibi olan, mülk yalnız ona kalan Vâris,',
      latin: 'Yâ Vâris',
      no: 7,
    },
    {
      arab: 'يَا ضَٓارُّ',
      meal: 'Ey hikmeti gereği elem ve zarar verici şeyleri yaratan Dârr,',
      latin: 'Yâ Dârr',
      no: 8,
    },
    {
      arab: 'يَا نَافِعُ',
      meal: 'Ey hayır ve menfaatli şeyleri yaratan Nâfi,',
      latin: 'Yâ Nâfi’',
      no: 9,
    },
    {
      arab: 'يَا هَادِى',
      meal: 'Ey kullarına hidayet veren Hâdi,',
      latin: 'Yâ Hâdî',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '34': [
    {
      arab: 'يَٓا اَعْظَمُ مِنْ كُلِّ عَظِيمٍ',
      meal: 'Ey bütün azîmlerden daha Azîm,',
      latin: 'Yâ A’zamü min külli ‘azîm',
      no: 1,
    },
    {
      arab: 'يَٓا اَكْرَمُ مِنْ كُلِّ كَرِيمٍ',
      meal: 'Ey bütün cömertlerden daha Kerîm,',
      latin: 'Yâ Ekramü min külli kerîm',
      no: 2,
    },
    {
      arab: 'يَٓا اَرْحَمُ مِنْ كُلِّ رَحِيمٍ',
      meal: 'Ey bütün merhametlilerden daha Rahîm,',
      latin: 'Yâ Erhamü min külli rahîm',
      no: 3,
    },
    {
      arab: 'يَٓا اَحْكَمُ مِنْ كُلِّ حَكِيمٍ',
      meal: 'Ey bütün hikmet sahiplerinden daha Hakîm,',
      latin: 'Yâ Ahkemü min külli hakîm',
      no: 4,
    },
    {
      arab: 'يَٓا اَعْلَمُ مِنْ كُلِّ عَلِيمٍ',
      meal: 'Ey bütün âlimlerden daha Alîm,',
      latin: 'Yâ Aİemü min külli ‘alîm',
      no: 5,
    },
    {
      arab: 'يَٓا اَقْدَمُ مِنْ كُلِّ قَدِيمٍ',
      meal: 'Ey bütün önce yaratılanlardan daha evvel var olan Kadîm,',
      latin: 'Yâ Akdemü min külli kadîm',
      no: 6,
    },
    {
      arab: 'يَٓا اَكْبَرُ مِنْ كُلِّ كَبِيرٍ',
      meal: 'Ey bütün büyüklerden daha büyük,',
      latin: 'Yâ Ekberu min külli kebîr',
      no: 7,
    },
    {
      arab: 'يَٓا اَجَلُّ مِنْ كُلِّ جَلِيلٍ',
      meal: 'Ey bütün yücelerden daha Celîl,',
      latin: 'Yâ Ecellü min külli celîl',
      no: 8,
    },
    {
      arab: 'يَٓا اَعَزُّ مِنْ كُلِّ عَزِيزٍ',
      meal: 'Ey bütün izzet sahiplerinden daha Azîz,',
      latin: 'Yâ E’azzü min külli ‘azîz',
      no: 9,
    },
    {
      arab: 'يَٓا اَلْطَفُ مِنْ كُلِّ لَطِيفٍ',
      meal: 'Ey bütün lütuf sahiplerinden daha Lâtif,',
      latin: 'Yâ Eltafü min külli latîf',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '35': [
    {
      arab: 'يَا مَنْ هُوَ فِى عَهْدِهِ وَفِىٌّ',
      meal: 'Ey ahdinde vefalı,',
      latin: 'Yâ Men hüve fî ‘ahdihî vefiyy',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى وَفَٓائِهِ قَوِىٌّ',
      meal: 'Ey vefasında kuvvetli,',
      latin: 'Yâ Men hüve fî vefaihî kaviyy',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى قُوَّتِهِ عَلِىٌّ',
      meal: 'Ey kuvvetinde yüce,',
      latin: 'Yâ Men hüve fî kuvvetihi ‘aliyy',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى عُلُوِّهِ قَرِيبٌ',
      meal: 'Ey yüceliğinde yakın,',
      latin: 'Yâ Men hüve fî ‘ulüvvihî karîb',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى قُرْبِهِ لَطِيفٌ',
      meal: 'Ey yakınlığında latîf,',
      latin: 'Yâ Men hüve fî kurbihî latîf',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى لُطْفِهِ شَرِيفٌ',
      meal: 'Ey lütfünde şerîf,',
      latin: 'Yâ Men hüve fî lütfıhî şerîf',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى شَرَفِهِ عَزِيزٌ',
      meal: 'Ey şerefinde azîz,',
      latin: 'Yâ Men hüve fî şerefîhî ‘azîz',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى عِزَّتِهِ عَظِيمٌ',
      meal: 'Ey izzetinde azîm,',
      latin: 'Yâ Men hüve fî ‘izzetihî ‘azîm',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى عَظَمَتِهِ مَجِيدٌ',
      meal: 'Ey azametinde mecîd,',
      latin: 'Yâ Men hüve fî ‘azametihî mecîd',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى مَجْدِهِ حَمِيدٌ',
      meal: 'Ey yüceliğinde hamîd,',
      latin: 'Yâ Men hüve fî mecdihî hamîd',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '36': [
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ خَاضِعٌ لَهُ',
      meal: 'Ey her şeyin kendisine boyun eğdiği,',
      latin: 'Yâ Men hüve küllü şey’in hâdiun leh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ كَٓائِنٌ لَهُ',
      meal: 'Ey her şey kendisi için var olan,',
      latin: 'Yâ Men hüve küllü şey’in kâinün leh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ مَوْجُودٌ لَهُ',
      meal: 'Ey her şey kendisi için mevcut olan,',
      latin: 'Yâ Men hüve küllü şey’in mevcudun leh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ مُنِيبٌ لَهُ',
      meal: 'Ey her şeyin kendisine döndüğü,',
      latin: 'Yâ Men hüve küllü şey’in münîbün leh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ خَٓائِفٌ مِنْهُ',
      meal: 'Ey her şeyin kendisinden korktuğu,',
      latin: 'Yâ Men hüve küllü şey’in hâifün minh',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ مُسَبِّحٌ لَهُ',
      meal: 'Ey her şeyin kendisini tesbih ettiği,',
      latin: 'Yâ Men hüve küllü şey’in müsebbihun leh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ قَٓائِمٌ بِهِ',
      meal: 'Ey her şey onunla ayakta olan,',
      latin: 'Yâ Men hüve küllü şey’in kâimün bih',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ خَاشِعٌ لَهُ',
      meal: 'Ey her şeyin kendisine itaat ettiği,',
      latin: 'Yâ Men hüve küllü şey’in hâşiün leh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ صَٓائِرٌ اِلَيْهِ',
      meal: 'Ey her şeyin kendisine yöneldiği,',
      latin: 'Yâ Men hüve küllü şey’in sâirun ileyh',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ كُلُّ شَىْءٍ هَالِكٌ اِلَّا وَجْهَهُ',
      meal: 'Ey ona bakan yüzü müstesnâ her şeyin helâk olduğu,',
      latin: 'Yâ men hüve küllü şey’in hâlikün illâ vecheh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '37': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا كَافِى',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey kullarına yeten Kâfi,',
      latin: 'Ve es’elüke biesmâike Yâ Kâfi',
      no: 1,
    },
    {
      arab: 'يَا وَافِى',
      meal: 'Ey vaadinde duran Vâfi,',
      latin: 'Yâ Vâfî',
      no: 2,
    },
    {
      arab: 'يَا شَافِى',
      meal: 'Ey her türlü derde devâ veren Şâfi,',
      latin: 'Yâ Şâfî',
      no: 3,
    },
    {
      arab: 'يَا مُعَافِى',
      meal: 'Ey maddî ve mânevî dertlere âfiyet veren Muâfi,',
      latin: 'Yâ Mu’âfî',
      no: 4,
    },
    {
      arab: 'يَا عَالِى',
      meal: 'Ey her şeyiyle yüce olan Âli,',
      latin: 'Yâ ‘Âlî',
      no: 5,
    },
    {
      arab: 'يَا دَاعِى',
      meal: 'Ey kullarını iyiliğe ve Cennete davet eden Dâi,',
      latin: 'Yâ Dâ’î',
      no: 6,
    },
    {
      arab: 'يَا رَاضِى',
      meal: 'Ey iyi kullarından hoşnut olan Râzi,',
      latin: 'Yâ Râdî',
      no: 7,
    },
    {
      arab: 'يَا قَاضِى',
      meal: 'Ey hikmet ve adâletle hükmeden Kâdi,',
      latin: 'Yâ Kâdî',
      no: 8,
    },
    {
      arab: 'يَا بَاقِى',
      meal: 'Ey varlığının sonu olmayan Bâkî,',
      latin: 'Yâ Bakî',
      no: 9,
    },
    {
      arab: 'يَا هَادِى',
      meal: 'Ey dilediğini doğru yola ulaştıran Hâdi,',
      latin: 'Yâ Hâdî',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ îâ ilahe illâ ente’l-emâ-ne’I-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '38': [
    {
      arab: 'يَا مَنْ لَامَفَرَّ اِلَّا ٓ اِلَيْهِ',
      meal: 'Ey kendisinden başka kaçacak yer olmayan,',
      latin: 'Yâ Men lâ meferra illâ ileyh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا مَفْزَعَ اِلَّا ٓ اِلَيْهِ',
      meal: 'Ey kendisinden başka sığınılacak yer olmayan,',
      latin: 'Yâ Men lâ mefze’a illâ ileyh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا مَلْجَأَ اِلَّا ٓ اِلَيْهِ',
      meal: 'Ey kendisinden başka ilticâ edilecek yer olmayan,',
      latin: 'Yâ Men lâ melcee illâ ileyh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يُتَوَكَّلُ اِلَّا عَلَيْهِ',
      meal: 'Ey kendisinden başka tevekkül edilecek kimse olmayan,',
      latin: 'Yâ Men lâ yutevekkelü illâ ‘aleyh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا مَقْصَدَ اِلَّا ٓ اِلَيْهِ',
      meal: 'Ey kendisinden başka maksut olmayan,',
      latin: 'Yâ Men lâ maksade illâ ileyh',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا مَنْجَأَ اِلَّا ٓ اِلَيْهِ',
      meal: 'Ey kendisinden başka kurtuluş yeri olmayan,',
      latin: 'Yâ Men lâ mencee illâ ileyh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَا يُرْغَبُ اِلَّا ٓ اِلَيْهِ',
      meal: 'Ey kendisinden başkasına rağbet edilmeyen,',
      latin: 'Yâ Men lâ yurğabü illâ ileyh',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَا يُعْبَدُ اِلَّا ٓ اِيَّاهُ ٔ',
      meal: 'Ey kendisinden başkasına ibâdet edilmeyen,',
      latin: 'Yâ Men lâ yu’bedü illâ iyyâh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَا يُسْتَعَانُ اِلَّا مِنْهُ ٔ',
      meal: 'Ey kendisinden başkasından yardım istenilmeyen,',
      latin: 'Yâ Men lâ yuste’ânü illâ minh',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَا حَوْلَ وَ لَا قُوَّةَ اِلَّا بِهِ',
      meal: 'Ey kendisinden başka güç ve kuvvet sahibi bulunmayan,',
      latin: 'Yâ Men lâ havle velâ kuvvete illâ bih',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '39': [
    {
      arab: 'يَا خَيْرَ الْمَرْهُوبِينَ',
      meal: 'Ey kendisine kaçılanların en hayırlısı,',
      latin: 'Yâ Hayra’l-merhûbîn',
      no: 1,
    },
    {
      arab: 'يَا خَيْرَ الْمَطْلُوبِينَ',
      meal: 'Ey matlupların en hayırlısı,',
      latin: 'Yâ Hayra’l-matlûbîn',
      no: 2,
    },
    {
      arab: 'يَا خَيْرَ الْمَرْغُوبِينَ',
      meal: 'Ey rağbet edilenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-merğûbîn',
      no: 3,
    },
    {
      arab: 'يَا خَيْرَ الْمَسْئُولِينَ',
      meal: 'Ey kendisinden dilekte bulunulanların en hayırlısı,',
      latin: 'Yâ Hayra’l-mes’ûlîn',
      no: 4,
    },
    {
      arab: 'يَا خَيْرَ الْمَقْصُودِينَ',
      meal: 'Ey maksut olanların en hayırlısı,',
      latin: 'Yâ Hayra’l-maksûdîn',
      no: 5,
    },
    {
      arab: 'يَا خَيْرَ الْمَذْكُورِينَ',
      meal: 'Ey zikredilenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-mezkûrîn',
      no: 6,
    },
    {
      arab: 'يَا خَيْرَ الْمَشْكُورِينَ',
      meal: 'Ey şükredilenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-meşkûrîn',
      no: 7,
    },
    {
      arab: 'يَا خَيْرَ الْمَحْبُوبِينَ',
      meal: 'Ey sevilenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-mahbûbîn',
      no: 8,
    },
    {
      arab: 'يَا خَيْرَ الْمُنْزِلِينَ',
      meal: 'Ey indirenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-münzilîn',
      no: 9,
    },
    {
      arab: 'يَا خَيْرَ الْمُسْتَاْنِسِينَ',
      meal: 'Ey kendisine ünsiyet edilenlerin en hayırlısı,',
      latin: 'Yâ Hayra’l-müste’nisîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٣٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '40': [
    {
      arab: 'يَا مَنْ هُوَ خَلَقَ فَسَوّٰى',
      meal: 'Ey yaratıp düzene koyan,',
      latin: 'Yâ Men hüve halaka fesevvâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ قَدَّرَ فَهَدٰى',
      meal: 'Ey takdir edip hedefe götüren,',
      latin: 'Yâ Men hüve kaddera fehedâ',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ يَكْشِفُ الْبَلْوٰى',
      meal: 'Ey belâyı kaldıran,',
      latin: 'Yâ Men hüve yekşifü’l-belvâ',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ يَسْمَعُ النَّجْوٰى',
      meal: 'Ey gizli yakarışı işiten,',
      latin: 'Yâ Men hüve yesme’u’n-necvâ',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ يُنْقِذُ الْغَرْقٰى',
      meal: 'Ey batmışı kurtaran,',
      latin: 'Yâ Men hüve yünkizü’l-garkâ',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ يُنْجِى الْهَلْكٰى',
      meal: 'Ey helâk olana necât veren,',
      latin: 'Yâ Men hüve yünci’l-helkâ',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ يَشْفِى الْمَرْضٰى',
      meal: 'Ey hastaya şifa veren,',
      latin: 'Yâ Men hüve yeşfi’l-merdâ',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ اَمَاتَ وَ اَحْىٰ',
      meal: 'Ey öldüren ve dirilten,',
      latin: 'Yâ Men hüve emâte ve ahyâ',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ اَضْحَكَ وَ اَبْكٰى',
      meal: 'Ey güldüren ve ağlatan,',
      latin: 'Yâ Men hüve edhake ve ebkâ',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ اَضَلَّ وَ اَهْدٰى',
      meal: 'Ey saptıran ve hidâyete erdiren,',
      latin: 'Yâ Men hüve edalle ve ehdâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '41': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا غَافِرُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey dilediği kullarının günahlarını bağışlayan Gâfir,',
      latin: 'Ve es’elüke biesmâike Yâ Ğâfır',
      no: 1,
    },
    {
      arab: 'يَا سَاتِرُ',
      meal: 'Ey ayıp ve kusurları örten Sâtir,',
      latin: 'Yâ Sâtir',
      no: 2,
    },
    {
      arab: 'يَا قَاهِرُ',
      meal: 'Ey düşmanlarını mağlup eden Kâhir,',
      latin: 'Yâ Kahir',
      no: 3,
    },
    {
      arab: 'يَا قَادِرُ',
      meal: 'Ey her şeye gücü yeten Kâdir,',
      latin: 'Yâ Kadir',
      no: 4,
    },
    {
      arab: 'يَا نَاظِرُ',
      meal: 'Ey bütün mahlûkatının hallerini gören Nâzır,',
      latin: 'Yâ Nazır',
      no: 5,
    },
    {
      arab: 'يَا فَاطِرُ',
      meal: 'Ey bütün mahlûkatı yoktan var eden Fâtır,',
      latin: 'Yâ Fâtır',
      no: 6,
    },
    {
      arab: 'يَا شَاكِرُ',
      meal: 'Ey kendine yapılan ibâdet ve şükürlere bol mükâfat veren Şâkir,',
      latin: 'Yâ Şâkir',
      no: 7,
    },
    {
      arab: 'يَا ذَاكِرُ',
      meal: 'Ey kendisini zikredenleri yâd eden Zâkir,',
      latin: 'Yâ Zâkir',
      no: 8,
    },
    {
      arab: 'يَا نَاصِرُ',
      meal: 'Ey dostlarına yardım eden Nâsır,',
      latin: 'Yâ Nâsır',
      no: 9,
    },
    {
      arab: 'يَا جَابِرُ',
      meal: 'Ey dilediğini zorla yaptıran Câbir,',
      latin: 'Yâ Câbir',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: "Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne'l-emâne ecirnâ mine’n-nâr.",
    },
  ],
  '42': [
    {
      arab: 'يَا مَنْ هُوَ فِى الْبَرِّ وَ الْبَحْرِ سَبِيلُهُ',
      meal: 'Ey karada ve denizde yolu olan,',
      latin: 'Yâ Men hüve fi’l-berri ve’l-bahri sebîlüh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى اْلاٰفَاقِ اٰيَاتُهُ',
      meal: 'Ey dış âlemde âyetleri bulunan,',
      latin: 'Yâ Men hüve fi’l-âfaki âyâtüh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى اْلاٰيَاتِ بُرْهَانُهُ',
      meal: 'Ey âyetlerinde delili olan,',
      latin: 'Yâ Men hüve fi’l-âyâti bürhânüh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْمَمَاتِ قُدْرَتُهُ',
      meal: 'Ey ölümlerde kudreti tecellî eden,',
      latin: 'Yâ Men hüve fı’l-memâti kudratüh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْقُبُورِ عِزَّتُهُ',
      meal: 'Ey kabirlerde izzeti olan,',
      latin: 'Yâ Men hüve fı’l-kubûri ‘izzetüh',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْقِيَامَةِ مِلْكَتُهُ',
      meal: 'Ey Kıyâmette saltanatı olan,',
      latin: 'Yâ Men hüve fı’l-kıyâmeti milketüh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْحِسَابِ هَيْبَتُهُ',
      meal: 'Ey hesapta heybeti olan,',
      latin: 'Yâ Men hüve fı’l-hisâbi heybetüh',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْمِيزَانِ قَضَٓائُهُ',
      meal: 'Ey Mîzanda hükmü olan,',
      latin: 'Yâ Men hüve fı’l-mîzâni kadâüh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْجَنَّةِ رَحْمَتُهُ ',
      meal: 'Ey Cennette rahmeti olan,',
      latin: 'Yâ Men hüve fi’l-cenneti rahmetüh',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى النَّارِ عَذَابُهُ',
      meal: 'Ey ateşte azabı olan,',
      latin: 'Yâ Men hüve fı’n-nâri ‘azâbüh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '43': [
    {
      arab: 'يَا مَنْ هُوَ اِلَيْهِ يَهْرَبُ الْخَٓائِفُونَ',
      meal: 'Ey korkanların kendisine kaçtığı,',
      latin: 'Yâ Men hüve ileyhi yehrabü’l-hâifûn',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ اِلَيْهِ يَفْزَعُ الْمُذْنِبُونَ',
      meal: 'Ey günahkârların kendisine sığındığı,',
      latin: 'Yâ Men hüve ileyhi yefze’u’l-müznibûn',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ اِلَيْهِ يَقْصِدُ الْمُنِيبُونَ',
      meal: 'Ey tövbe edenlerin kendisine yöneldiği,',
      latin: 'Yâ Men hüve ileyhi yaksıdü’l-münîbûn',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ اِلَيْهِ يَلْجَأُ الْعَاصُونَ',
      meal: 'Ey âsilerin kendisine ilticâ ettiği,',
      latin: 'Yâ Men hüve ileyhi yelceü’l-‘âsûn',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ اِلَيْهِ يَرْغَبُ الزَّاهِدُونَ',
      meal: 'Ey zahitlerin kendisine rağbet ettiği,',
      latin: 'Yâ Men hüve ileyhi yerğabü’z-zâhidûn',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ فِيهِ يَطْمَعُ الْخَاطِؤُنَ',
      meal: 'Ey hatâlıların kendisine ümit beslediği,',
      latin: 'Yâ Men hüve fîhi yatme’u’l-hâtıûn',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ يَسْتَاْنِسُ بِهِ الْمُرِيدُونَ ْ',
      meal: 'Ey kendisini arzulayanların onunla ünsiyet bulduğu,',
      latin: 'Yâ Men hüve yeste’nisü bihi’l-mürîdûn',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ يَفْتَخِرُ بِهِ الْمُحْسِنُونَ',
      meal: 'Ey iyilik yapanların kendisiyle iftihar ettiği,',
      latin: 'Yâ Men hüve yeftehiru bihi’l-muhsinûn',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ عَلَيْهِ يَتَوَكَّلُ الْمُتَوَكِّلُونَ',
      meal: 'Ey tevekkül edenlerin kendisine güvendiği,',
      latin: 'Yâ men hüve ‘aleyhi yetevekkelü’l-mütevekkilun',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ يَسْكُنُ بِهِ الْمُوقِنُونَ',
      meal: 'Ey kuvvetle îman edenlerin kendisiyle huzur bulduğu,',
      latin: 'Yâ men hüve yeskünü bihi’l-mûkınûn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok. Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '44': [
    {
      arab: 'يَٓا اَقْرَبُ مِنْ كُلِّ قَرِيبٍ',
      meal: 'Ey bütün yakınlardan daha yakın,',
      latin: 'Yâ Ekrabu min külli karîb',
      no: 1,
    },
    {
      arab: 'يَٓا اَحَبُّ مِنْ كُلِّ حَبِيبٍ',
      meal: 'Ey bütün sevilenlerden daha sevgili,',
      latin: 'Yâ Ehabbu miri külli habîb',
      no: 2,
    },
    {
      arab: 'يَٓا اَعْظَمُ مِنْ كُلِّ عَظِيمٍ',
      meal: 'Ey bütün büyüklerden daha büyük,',
      latin: 'Yâ A’zamu min külli ‘azîm',
      no: 3,
    },
    {
      arab: 'يَٓا اَعَزُّ مِنْ كُلِّ عَزِيزٍ',
      meal: 'Ey bütün izzet sahiplerinden daha azîz,',
      latin: 'Yâ E’azzu min külli ‘azîz',
      no: 4,
    },
    {
      arab: 'يَٓا اَقْوٰى مِنْ كُلِّ قَوِىٍّ',
      meal: 'Ey bütün kuvvetlilerden daha kavî,',
      latin: 'Yâ Ekvâ min külli kaviyy',
      no: 5,
    },
    {
      arab: 'يَٓا اَغْنٰى مِنْ كُلِّ غَنِىٍّ',
      meal: 'Ey bütün zenginlerden daha zengin,',
      latin: 'Yâ Ağnâ min külli ğaniyy',
      no: 6,
    },
    {
      arab: 'يَٓا اَجْوَدُ مِنْ كُلِّ جَوَادٍ',
      meal: 'Ey bütün cömertlerden daha cömert,',
      latin: 'Yâ Ecvedu min külli cevâd',
      no: 7,
    },
    {
      arab: 'يَٓا اَرْأَفُ مِنْ كُلِّ رَؤُفٍ',
      meal: 'Ey bütün şefkatlilerden daha raûf,',
      latin: 'Yâ Er’efu min külli raûf',
      no: 8,
    },
    {
      arab: 'يَٓا اَرْحَمُ مِنْ كُلِّ رَحِيمْ',
      meal: 'Ey bütün merhametlilerden daha rahîm,',
      latin: 'Yâ Erhamu min külli rahîm',
      no: 9,
    },
    {
      arab: 'يَٓا اَجَلُّ مِنْ كُلِّ جَلِيلٍ',
      meal: 'Ey bütün yücelerden daha yüce,',
      latin: 'Yâ Ecellu min külli celîl',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '45': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا قَرِيبُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey her şeye her şeyden daha yakın olan Karîb,',
      latin: 'Ve es’elüke biesmâike Yâ Karîb',
      no: 1,
    },
    {
      arab: 'يَا رَقِيبُ',
      meal: 'Ey bütün mahlûkatını gözetleyen Rakîb,',
      latin: 'Yâ Rakîb',
      no: 2,
    },
    {
      arab: 'يَا حَبِيبُ',
      meal: 'Ey müminlerin sevgilisi olan Habîb,',
      latin: 'Yâ Habîb',
      no: 3,
    },
    {
      arab: 'يَا مُجِيبُ',
      meal: 'Ey kullarının duâlarına cevap veren Mucîb,',
      latin: 'Yâ Mucîb',
      no: 4,
    },
    {
      arab: 'يَا حَسِيبُ',
      meal: 'Ey kullarının bütün fiillerinin hesâbını gören Hasîb,',
      latin: 'Yâ Hasîb',
      no: 5,
    },
    {
      arab: 'يَا طَبِيبُ',
      meal: 'Ey bütün dertlere devâ veren Tabîb,',
      latin: 'Yâ Tabîb',
      no: 6,
    },
    {
      arab: 'يَا بَصِيرُ',
      meal: 'Ey her şeyi bütün incelikleriyle gören Basîr,',
      latin: 'Yâ Basîr',
      no: 7,
    },
    {
      arab: 'يَا خَبِيرُ',
      meal: 'Ey her şeyden haberdar olan Habîr,',
      latin: 'Yâ Habîr',
      no: 8,
    },
    {
      arab: 'يَا مُنِيرُ',
      meal: 'Ey her şeyi nûruyla aydınlatan Münîr,',
      latin: 'Yâ Munîr',
      no: 9,
    },
    {
      arab: 'يَا مُبِينُ',
      meal: 'Ey kullarına gerekli her şeyi açıklayan Mübîn,',
      latin: 'Yâ Mubîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '46': [
    {
      arab: 'يَا غَالِبًا غَيْرَ مَغْلُوبٍ',
      meal: 'Ey mağlûp olmayan Galip,',
      latin: 'Yâ Ğâliben gayra mağlûb',
      no: 1,
    },
    {
      arab: 'يَا صَانِعًا غَيْرَ مَصْنُوعٍ',
      meal: 'Ey yaratılmış olmayan Sanatkâr,',
      latin: 'Yâ Sâni’an gayra masnu’',
      no: 2,
    },
    {
      arab: 'يَا خَالِقًا غَيْرَ مَخْلُوقٍ',
      meal: 'Ey mahlûk olmayan Yaratıcı,',
      latin: 'Yâ Hâlikan gayra mahlûk',
      no: 3,
    },
    {
      arab: 'يَا مَالِكًا غَيْرَ مَمْلُوكٍ',
      meal: 'Ey sahip olunamayan Mülk Sahibi,',
      latin: 'Yâ Mâliken gayra memlûk',
      no: 4,
    },
    {
      arab: 'يَا قَاهِرًا غَيْرَ مَقْهُورٍ',
      meal: 'Ey kendisine üstün gelinemeyen Kahir,',
      latin: 'Yâ Kâhiran gayra makhûr',
      no: 5,
    },
    {
      arab: 'يَا رَافِعًا غَيْرَ مَرْفُوعٍ',
      meal: 'Ey yükseltilmekten münezzeh Yükseltici,',
      latin: 'Yâ Râfı’an gayra merfu’',
      no: 6,
    },
    {
      arab: 'يَا نَاصِرًا غَيْرَ مَنْصُورٍ',
      meal: 'Ey yardım edilmeyen Yardım Edici,',
      latin: 'Yâ Hafızan gayra mahfuz',
      no: 7,
    },
    {
      arab: 'يَا حَافِظًا غَيْرَ مَحْفُوظٍ',
      meal: 'Ey korunmayan Koruyucu ,',
      latin: 'Yâ Nâsiran gayra mensur',
      no: 8,
    },
    {
      arab: 'يَا شَاهِدًا غَيْرَ غَٓائِبٍ',
      meal: 'Ey gaip olmayan Şahit,',
      latin: 'Yâ Sahiden gayra gâib',
      no: 9,
    },
    {
      arab: 'يَا قَرِيبًا غَيْرَ بَعِيدٍ',
      meal: 'Ey uzak olmayan yakın,',
      latin: 'Yâ Karîben gayra ba’îd',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '47': [
    {
      arab: 'يَا نُورَ النُّورِ',
      meal: 'Ey nurların nuru,',
      latin: 'Yâ Nûra’n-nûr',
      no: 1,
    },
    {
      arab: 'يَا مُنَوِّرَ النُّورِ',
      meal: 'Ey nurları nurlandıran,',
      latin: 'Yâ Munevvira’n-nûr',
      no: 2,
    },
    {
      arab: 'يَا مُصَوِّرَ النُّورِ',
      meal: 'Ey nurlara sûret ve şekil veren,',
      latin: 'Yâ Musavvira’n-nûr',
      no: 3,
    },
    {
      arab: 'يَا خَالِقَ النُّورِ',
      meal: 'Ey nurları yaratan,',
      latin: 'Yâ Hâlika’n-nûr',
      no: 4,
    },
    {
      arab: 'يَا مُدَبِّرَ النُّورِ',
      meal: 'Ey nurları idâre eden,',
      latin: 'Yâ Mukaddira’n-nûr',
      no: 5,
    },
    {
      arab: 'يَا مُقَدِّرَ النُّورِ',
      meal: 'Ey nurları takdir eden,',
      latin: 'Yâ Mudebbira’n-nûr',
      no: 6,
    },
    {
      arab: 'يَا نُورًا قَبْلَ كُلِّ نُورٍ',
      meal: 'Ey bütün nurlardan evvel olan Nur,',
      latin: 'Yâ Nûran kable külli nûr',
      no: 7,
    },
    {
      arab: 'يَا نُورًا بَعْدَ كُلِّ نُورٍ',
      meal: 'Ey bütün nurlardan sonra da var olan Nur,',
      latin: 'Yâ Nûran ba’de külli nûr',
      no: 8,
    },
    {
      arab: 'يَا نُورًا فَوْقَ كُلِّ نُورٍ',
      meal: 'Ey bütün nurların üstünde olan Nur,',
      latin: 'Yâ Nûran fevka külli nûr',
      no: 9,
    },
    {
      arab: 'يَا نُورًا لَيْسَ مِثْلَهُ نُورٌ',
      meal: 'Ey hiçbir nûrun Kendisine benzemediği Nur,',
      latin: 'Yâ Nûran leyse mislehû nûr',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '48': [
    {
      arab: 'يَا مَنْ عَطَٓاؤُهُ شَرِيفٌ',
      meal: 'Ey bağış ve ihsânı şerefli olan,',
      latin: 'Yâ Men ‘atâuhû şerîf',
      no: 1,
    },
    {
      arab: 'يَا مَنْ فِعْلُهُ لَطِيفٌ',
      meal: 'Ey fiili latîf olan,',
      latin: 'Yâ Men fı’lühû latîf',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لُطْفُهُ مُقِيمٌ',
      meal: 'Ey lütfü dâim olan,',
      latin: 'Yâ Men lütfühû mükim',
      no: 3,
    },
    {
      arab: 'يَا مَنْ اِحْسَانُهُ قَدِيمٌ',
      meal: 'Ey ihsânı kadîm olan,',
      latin: 'Yâ Men ihsânühû kadîm',
      no: 4,
    },
    {
      arab: 'يَا مَنْ قَوْلُهُ حَقٌّ',
      meal: 'Ey sözü hak olan,',
      latin: 'Yâ Men kavlühü hakk',
      no: 5,
    },
    {
      arab: 'يَا مَنْ وَعْدُهُ صِدْقٌ',
      meal: 'Ey vaadi doğru olan,',
      latin: 'Yâ Men va’dühû sıdk',
      no: 6,
    },
    {
      arab: 'يَا مَنْ عَفْوُهُ فَضْلٌ',
      meal: 'Ey affı fazıl olan,',
      latin: 'Yâ Men ‘afVühû fadl',
      no: 7,
    },
    {
      arab: 'يَا مَنْ عَذَابُهُ عَدْلٌ',
      meal: 'Ey azâbı adâlet olan,',
      latin: 'Yâ Men ‘azabühû ‘adl',
      no: 8,
    },
    {
      arab: 'يَا مَنْ ذِكْرُهُ حُلْوٌ',
      meal: 'Ey zikri tatlı olan,',
      latin: 'Yâ Men zikrühû hulv',
      no: 9,
    },
    {
      arab: 'يَا مَنْ اُنْسُهُ لَذِيذٌ',
      meal: 'Ey dostluğu lezzetli olan,',
      latin: 'Yâ men ünsühû leziz',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '49': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُنَوِّلُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey kullarına nîmet ihsan eden Münevvil,',
      latin: 'Ve es’elüke biesmâike Yâ Munevvil',
      no: 1,
    },
    {
      arab: 'يَا مُفَصِّلُ',
      meal: 'Ey bütün müşkülleri halleden ve hak ile bâtılın arasını ayıran Mufassıl,',
      latin: 'Yâ Mufassil',
      no: 2,
    },
    {
      arab: 'يَا مُبَدِّلُ',
      meal: 'Ey istediğini istediği şekilde değiştiren Mübeddil,',
      latin: 'Yâ Mubeddil',
      no: 3,
    },
    {
      arab: 'يَا مُسَهِّلُ',
      meal: 'Ey zorlukları kolaylaştıran Müsehhil,',
      latin: 'Yâ Musehhil',
      no: 4,
    },
    {
      arab: 'يَا مُذَلِّلُ',
      meal: 'Ey istediğini zelîl kılan ve mahlûkatına boyun eğdiren Müzellil,',
      latin: 'Yâ Muzellil',
      no: 5,
    },
    {
      arab: 'يَا مُنَزِّلُ',
      meal: 'Ey kitaplar ve bereketler indiren; dilediğinin rütbesini alçaltan Münezzil,',
      latin: 'Yâ Munezzil',
      no: 6,
    },
    {
      arab: 'يَا مُحَوِّلُ',
      meal: 'Ey kâinattaki bütün işleri döndüren ve kullarını halden hâle sevk eden Muhavvil,',
      latin: 'Yâ Muhavvil',
      no: 7,
    },
    {
      arab: 'يَا مُجَمِّلُ',
      meal: 'Ey her şeyi münâsip şekilde güzelleştiren Mücemmil,',
      latin: 'Yâ Mucemmil',
      no: 8,
    },
    {
      arab: 'يَا مُكَمِّلُ',
      meal: 'Ey her şeyi kemâle erdiren Mükemmil,',
      latin: 'Yâ Mukemmil',
      no: 9,
    },
    {
      arab: 'يَا مُفَضِّلُ',
      meal: 'Ey istediğini istediğine üstün kılan Mufaddıl,',
      latin: 'Yâ Mufaddil',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٤٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '50': [
    {
      arab: 'يَا مَنْ يَرٰى وَ لَا يُرٰى',
      meal: 'Ey her şeyi gören, fakat kendisi görülmeyen,',
      latin: 'Yâ Men yerâ velâ yurâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ يَخْلُقُ وَ لَا يُخْلَقُ',
      meal: 'Ey her şeyi yaratan, fakat kendisi yaratılmayan,',
      latin: 'Yâ Men yahlüku velâ yuhlâk',
      no: 2,
    },
    {
      arab: 'يَا مَنْ يَهْدِى وَ لَا يُهْدٰى',
      meal: 'Ey her şeye yol gösteren, fakat kendisi yol gösterilmeye muhtaç olmayan,',
      latin: 'Yâ Men yehdî velâ yuhda',
      no: 3,
    },
    {
      arab: 'يَا مَنْ يُحْيِى وَ لَا يُحْيٰى',
      meal: 'Ey hayat veren, fakat kendisi hayat verilmeye muhtaç olmayan,',
      latin: 'Yâ Men yühyî velâ yuhyâ',
      no: 4,
    },
    {
      arab: 'يَا مَنْ يُطْعِمُ وَ لَا يُطْعَمُ',
      meal: 'Ey her şeyi doyuran, fakat kendisi doyurulmaktan münezzeh olan,',
      latin: 'Yâ Men yüt’imü velâ yut’am',
      no: 5,
    },
    {
      arab: 'يَا مَنْ يُجِيرُ وَ لَا يُجَارُ',
      meal: 'Ey her şeyi koruyan, fakat kendisi korunmaya muhtaç olmayan,',
      latin: 'Yâ Men yücîru velâ yucâr',
      no: 6,
    },
    {
      arab: 'يَا مَنْ يَقْضِى وَ لَا يُقْضٰى عَلَيْهِ',
      meal: 'Ey her şey hakkında karar veren, fakat kendisi hakkında hüküm verilmeyen,',
      latin: 'Yâ Men yakdî velâ yukdâ ‘aleyh',
      no: 7,
    },
    {
      arab: 'يَا مَنْ يَحْكُمُ وَ لَا يُحْكَمُ عَلَيْهِ',
      meal: 'Ey hüküm veren, fakat kendisi hakkında hüküm verilmeyen,',
      latin: 'Yâ Men yahkümü velâ yuhkemü ‘aleyh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَمْ يَلِدْ وَ لَمْ يُولَدْ',
      meal: 'Ey doğurmayan ve doğmayan',
      latin: 'Yâ Men lem yelid velem yûled',
      no: 9,
    },
    {
      arab: 'وَ لَمْ يَكُنْ لَهُ كُفُوًا اَحَدٌ',
      meal: 'Ey hiçbir şey kendisine denk olmayan',
      latin: 'Ve lem yekûn lehû küfüven ehad',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '51': [
    {
      arab: 'يَا نِعْمَ الْحَبِيبُ',
      meal: 'Ey en güzel Sevgili,',
      latin: 'Yâ Ni’me’l-habîb',
      no: 1,
    },
    {
      arab: 'يَا نِعْمَ الطَّبِيبُ',
      meal: 'Ey en güzel Tabip,',
      latin: 'Yâ Ni’me’t-tabîb',
      no: 2,
    },
    {
      arab: 'يَا نِعْمَ الْحَسِيبُ',
      meal: 'Ey en güzel hesap gören,',
      latin: 'Yâ Ni’me’l-hasîb',
      no: 3,
    },
    {
      arab: 'يَا نِعْمَ الْقَرِيبُ',
      meal: 'Ey en güzel Yakın,',
      latin: 'Yâ Ni’me’l-karîb',
      no: 4,
    },
    {
      arab: 'يَا نِعْمَ الرَّقِيبُ',
      meal: 'Ey en güzel Gözetleyici,',
      latin: 'Yâ Ni’me’r-rakîb',
      no: 5,
    },
    {
      arab: 'يَا نِعْمَ الْمُجِيبُ',
      meal: 'Ey en güzel Cevap Veren,',
      latin: 'Yâ Ni’me’l-mucîb',
      no: 6,
    },
    {
      arab: 'يَا نِعْمَ الْاَنِيسُ',
      meal: 'Ey en güzel Dost,',
      latin: 'Yâ Ni’me’l-enîs',
      no: 7,
    },
    {
      arab: 'يَا نِعْمَ الْوَكِيلُ',
      meal: 'Ey en güzel Vekîl,',
      latin: 'Yâ Ni’me’l-vekîl',
      no: 8,
    },
    {
      arab: 'يَا نِعْمَ الْمَوْلٰى',
      meal: 'Ey en güzel Efendi,',
      latin: 'Yâ Ni’me’l-mevlâ',
      no: 9,
    },
    {
      arab: 'يَا نِعْمَ النَّصِيرُ',
      meal: 'Ey en güzel Yardımcı,',
      latin: 'Yâ Ni’me’n-nasîr',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '52': [
    {
      arab: 'يَا سُرُورَ الْعَارِفِينَ',
      meal: 'Ey kendisini tanıyanların sevinci,',
      latin: 'Yâ Sürûra’l-‘ârifîn',
      no: 1,
    },
    {
      arab: 'يَٓا اَنِيسَ الْمُرِيدِينَ',
      meal: 'Ey kendisini arzulayanların dostu,',
      latin: 'Yâ Enîse’l-mürîdîn',
      no: 2,
    },
    {
      arab: 'يَا مُغِيثَ الْمُشْتَاقِينَ',
      meal: 'Ey kendisine müştâk olanların imdâdına koşan,',
      latin: 'Yâ Muğîse’l-müştâkîn',
      no: 3,
    },
    {
      arab: 'يَا حَبِيبَ التَّوَّابِينَ',
      meal: 'Ey tövbekârların sevgilisi,',
      latin: 'Yâ Habîbe’t-tevvâbîn',
      no: 4,
    },
    {
      arab: 'يَا رَازِقَ الْمُقِلِّينَ',
      meal: 'Ey ihtiyaç sahiplerine rızık veren,',
      latin: 'Yâ Râzika’l-mükillîn',
      no: 5,
    },
    {
      arab: 'يَا رَجَٓاءَ الْمُذْنِبِينَ',
      meal: 'Ey günahkârların ümidi,',
      latin: 'Yâ Recâe’l-müznibîn',
      no: 6,
    },
    {
      arab: 'يَا كَاشِفَ الْمَكْرُوبِينَ',
      meal: 'Ey sıkıntıda olanların ferahlatıcısı,',
      latin: 'Yâ Kâşife’l-mekrûbîn',
      no: 7,
    },
    {
      arab: 'يَا مُنَفِّسًا عَنِ الْمَغْمُومِينَ',
      meal: 'Ey gamlılara nefes aldıran,',
      latin: 'Yâ Muneffisen ‘ani’l-mağmûmîn',
      no: 8,
    },
    {
      arab: 'يَا مُفَرِّجًا عَنِ الْمَحْزُونِينَ',
      meal: 'Ey mahzunlara kurtuluş yolu gösteren,',
      latin: 'Yâ Muferricen ‘ani’l-mahzûnîn',
      no: 9,
    },
    {
      arab: 'يَٓا اِلٰهَ الْاَوَّلِينَ وَ اْلاٰخِرِينَ',
      meal: 'Ey evvel ve âhirlerin ilâhı,',
      latin: 'Yâ İlâhe’l-evvelîne ve’l-âhirîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '53': [
    {
      arab: 'يَا رَبَّ الْجَنَّةِ وَ النَّارِ',
      meal: 'Ey Cennet ve Cehennemin Rabbi,',
      latin: 'Yâ Rabbe’l-cenneti ve’n-nâr',
      no: 1,
    },
    {
      arab: 'يَا رَبَّ النَّبِيِّينَ وَ الْاَخْيَارِ',
      meal: 'Ey peygamberler ve hayırlıların Rabbi,',
      latin: 'Yâ Rabbe’n-nebiyyîne ve’l-ahyâr',
      no: 2,
    },
    {
      arab: 'يَا رَبَّ الصِّدّ۪يقِينَ وَ الْاَبْرَارِ',
      meal: 'Ey Sıddıkların ve iyilerin Rabbi,',
      latin: 'Yâ Rabbe’s-sıddîkîne ve’l-ebrâr',
      no: 3,
    },
    {
      arab: 'يَا رَبَّ الصِّغَارِ وَ الْكِبَارِ',
      meal: 'Ey küçüklerin ve büyüklerin Rabbi,',
      latin: 'Yâ Rabbe’s-siğâri ve’l-kibâr',
      no: 4,
    },
    {
      arab: 'يَا رَبَّ الْحُبُوبِ وَ الْاَثْمَارِ',
      meal: 'Ey dânelerin ve meyvelerin Rabbi,',
      latin: 'Yâ Rabbe’l-hubûbi ve’l-eşmâr',
      no: 5,
    },
    {
      arab: 'يَا رَبَّ الْاَنْهَارِ وَ الْاَشْجَارِ',
      meal: 'Ey nehirlerin ve ağaçların Rabbi,',
      latin: 'Yâ Rabbe’l-enhâri ve’l-eşcâr',
      no: 6,
    },
    {
      arab: 'يَا رَبَّ الصَّحَارٰى وَ الْقِفَارِ',
      meal: 'Ey sahraların ve çöllerin Rabbi,',
      latin: 'Yâ Rabbe’s-sahârâ ve’l-kıfâr',
      no: 7,
    },
    {
      arab: 'يَا رَبَّ الْعَبِيدِ وَ الْاَحْرَارِ',
      meal: 'Ey kölelerin ve hürlerin Rabbi,',
      latin: 'Yâ Rabbe’l-‘abîdi ve’l-ahrâr',
      no: 8,
    },
    {
      arab: 'يَا رَبَّ اْلاِعْلَانِ وَ اْلاِسْرَارِ',
      meal: 'Ey açığa çıkarma ve gizlemelerin Rabbi,',
      latin: 'Yâ Rabbe’l-i’lâni ve’l-isrâr',
      no: 9,
    },
    {
      arab: 'يَا رَبَّ الَّيْلِ وَ النَّهَارِ',
      meal: 'Ey gece ve gündüzün Rabbi,',
      latin: 'Yâ Rabbe’l-leyli ve’n-nehâr',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '54': [
    {
      arab: 'يَا مَنْ لَحِقَ كُلِّ شَىْءٍ عِلْمُهُ',
      meal: 'Ey ilmi her şeye ulaşan,',
      latin: 'Yâ Men lahika külli şey’in ‘ilmüh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ نَفَذَ بِكُلِّ شَىْءٍ بَصَرُهُ',
      meal: 'Ey basarı her şeye nüfûz eden,',
      latin: 'Yâ Men nefeze bi külli şey’in besaruh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ بَلَغَتْ اِلٰى كُلِّ شَىْءٍ قُدْرَتُهُ',
      meal: 'Ey kudreti her şeye bâliğ olan,',
      latin: 'Yâ Men beleğat ilâ külli şey’in kudratüh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يُحْصِى الْعِبَادُ نَعْمَٓائَهُ',
      meal: 'Ey nîmetleri sayılamayan,',
      latin: 'Yâ Men lâ yuhsı’l-‘ibâdü na’mâeh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا تَبْلُغُ الْخَلَٓائِقُ شُكْرَهُ',
      meal: 'Ey mahlûkatın gerçek şükrüne erişemediği,',
      latin: 'Yâ Men lâ teblüğu’l-halâiku şükrah',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا تُدْرِكُ الْاَفْهَامُ جَلَالَهُ',
      meal: 'Ey zihinlerin, yüceliğini idrak edemediği,',
      latin: 'Yâ Men lâ tüdrikü’l-efhâmü celâleh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَا تَنَالُ الْاَوْهَامُ كُنْهَهُ',
      meal: 'Ey hayallerin, hakîkatine erişemediği,',
      latin: 'Yâ Men lâ tenâlü’l-evhâmü künheh',
      no: 7,
    },
    {
      arab: 'يَا مَنِ الْعَظَمَةُ وَ الْكِبْرِيَٓاءُ رِدَٓاؤُهُ',
      meal: 'Ey azamet ve kibriyâ örtüsü olan,',
      latin: 'Yâ Meni’l-‘azâmetü ve’l-kibriyâü ridâüh',
      no: 8,
    },
    {
      arab: 'يَا مَنِ الْهَيْبَةُ وَ السُّلْطَانُ بَهَٓاؤُهُ',
      meal: 'Ey heybet ve saltanat güzelliği olan,',
      latin: 'Yâ Meni’l-heybetü ve’s-sültânü behâüh',
      no: 9,
    },
    {
      arab: 'يَا مَنْ تَعَزَّزَ بِالْعِزِّ بَقَٓاؤُهُ',
      meal: 'Ey bekası izzetle yücelenen',
      latin: 'Yâ Men te’azzeze bi’l-‘izzi bekâüh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '55': [
    {
      arab: 'يَا مَنْ لَهُ الْمَثَلُ الْاَعْلٰى',
      meal: 'Ey en yüce misâller Kendisine ait olan,',
      latin: 'Yâ Men lehü’l-meşelü’l-a’lâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَهُ الصِّفَاتُ الْعُلٰى',
      meal: 'Ey en yüce sıfatlar Kendisine ait olan,',
      latin: 'Yâ Men lehü’l-sıfâtü’l-‘ulâ',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَهُ اْلاٰخِرَةُ وَ اْلاُولٰى',
      meal: 'Ey âhiret ve dünya Kendisine âit olan,',
      latin: 'Yâ Men lehü’l-âhiratü ve’l-ûlâ',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَهُ الْجَنَّةُ الْمَاْوٰى',
      meal: 'Ey Cennetül-Mevâ’nın sahibi,',
      latin: 'Yâ Men lehü’l-cennetü’l-me’vâ',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَهُ النَّارُ وَ اللَّظٰى',
      meal: 'Ey Cehennem ve ateşin sahibi,',
      latin: 'Yâ Men lehü’n-nâru ve’l-lezâ',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَهُ اْلاٰيَاتُ الْكُبْرٰى',
      meal: 'Ey en büyük âyetler sahibi,',
      latin: 'Yâ Men lehü’l-âyâtü’l-kübrâ',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَهُ الْاَسْمَٓاءُ الْحُسْنٰى',
      meal: 'Ey en güzel isimler sahibi,',
      latin: 'Yâ Men lehü’l-esmâü’l-hüsnâ',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَهُ الْحُكْمُ وَ الْقَضَٓاءُ',
      meal: 'Ey hüküm ve kazâ sahibi,',
      latin: 'Yâ Men lehü’l-hükmü ve’l-kadâ',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَهُ السَّمٰوَاتُ الْعُلٰى',
      meal: 'Ey yüce göklerin sahibi,',
      latin: 'Yâ Men lehü’s-semâvâtü’l-‘ulâ',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَهُ الْعَرْشُ وَ الثَّرٰى',
      meal: 'Ey arş ve yerin sahibi,',
      latin: 'Yâ Men lehü’l-‘arşü ve’s-serâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '56': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا عَفُوُّ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey kullarını çok çok affeden Afüvv,',
      latin: 'Ve es’elüke biesmâike Yâ’Afüvv',
      no: 1,
    },
    {
      arab: 'يَا غَفُورُ',
      meal: 'Ey kullarının günahlarını bağışlayan Gafûr,',
      latin: 'Yâ Ğafûr',
      no: 2,
    },
    {
      arab: 'يَا وَدُودُ',
      meal: 'Ey itaatkâr kullarını çok seven Vedûd,',
      latin: 'Yâ Vedûd',
      no: 3,
    },
    {
      arab: 'يَا شَكُورُ',
      meal: 'Ey rızâsı için yapılan işleri bol sevapla karşılayan Şekûr,',
      latin: 'Yâ Şekûr',
      no: 4,
    },
    {
      arab: 'يَا صَبُورُ',
      meal: 'Ey âsileri hemen cezâlandırmayıp, çok sabreden Sabûr,',
      latin: 'Yâ Sabûr',
      no: 5,
    },
    {
      arab: 'يَا رَؤُفُ',
      meal: 'Ey kullarına çok şefkat edip esirgeyen Raûf,',
      latin: 'Yâ Rauf',
      no: 6,
    },
    {
      arab: 'يَا عَطُوفُ',
      meal: 'Ey kullarına karşı pek merhametli olan Atûf,',
      latin: 'Yâ’Atûf',
      no: 7,
    },
    {
      arab: 'يَا قُدُّوسُ',
      meal: 'Ey bütün mahlûkatı maddî ve manevî kirlerden arındıran Kuddüs,',
      latin: 'Yâ Kuddûs',
      no: 8,
    },
    {
      arab: 'يَا حَىُّ',
      meal: 'Ey gerçek hayat sahibi olan Hayy,',
      latin: 'Yâ Hayy',
      no: 9,
    },
    {
      arab: 'يَا قَيُّومُ',
      meal: 'Ey gökleri, yeri ve bütün mahlûkatı ayakta tutan Kayyûm,',
      latin: 'Yâ Kayyûm',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '57': [
    {
      arab: 'يَا مَنْ هُوَ فِى السَّمَٓاءِ عَظَمَتُهُ',
      meal: 'Ey semâda azameti görülen,',
      latin: 'Yâ Men hüve fı’s-semâi ‘azametüh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْاَرْضِ اٰيَاتُهُ',
      meal: 'Ey yerde âyetleri tecellî eden,',
      latin: 'Yâ Men hüve fi’l-ardi âyâtüh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى كُلِّ شَىْءٍ دَلَٓائِلُهُ',
      meal: 'Ey her şeyde delilleri bulunan,',
      latin: 'Yâ Men hüve fî külli şey’in delâilüh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْبِحَارِ عَجَٓائِبُهُ',
      meal: 'Ey denizde acâip sanatları bulunan,',
      latin: 'Yâ Men hüve fi’l-bihâri ‘acâibüh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ يَبْدَؤُ الْخَلْقَ ثُمَّ يُعِيدُهُ',
      meal: 'Ey mahlûkatı ilk defa yaratıp, öldükten sonra tekrar dirilten,',
      latin: 'Yâ Men yebdeü’l-halka sümme yü’îdüh',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى الْجِبَالِ خَزَٓائِنُهُ',
      meal: 'Ey dağlarda hazineleri bulunan,',
      latin: 'Yâ Men hüve fi’l-cibâli hazâinüh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ اَحْسَنَ كُلَّ شَىْءٍ خَلَقَهُ',
      meal: 'Ey yarattığı her şeyi en güzel yapan,',
      latin: 'Yâ Men ahsene külle şey’in halekah',
      no: 7,
    },
    {
      arab: 'يَا مَنْ اِلَيْهِ يُرْجَعُ الْاَمْرُ كُلُّهُ',
      meal: 'Ey bütün işler kendisine dönen,',
      latin: 'Yâ Men ileyhi yürce’u’l-emrü küllüh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ ظَهَرَ فِى كُلِّ شَىْءٍ لُطْفُهُ',
      meal: 'Ey her şeyde lütfü açıkça görünen,',
      latin: 'Yâ Men zahera fî külli şey’in lütfülı',
      no: 9,
    },
    {
      arab: 'يَا مَنْ يُعَرِّفُ الْخَلَٓائِقَ قُدْرَتَهُ',
      meal: 'Ey mahlûkatına kudretini tanıtan,',
      latin: 'Yâ Men yü’arrifü’l-halâika kudrateh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '58': [
    {
      arab: 'يَا حَبِيبَ مَنْ لَا حَبِيبَ لَهُ',
      meal: 'Ey sevgilisi olmayanların sevgilisi,',
      latin: 'Yâ Habîbe men lâ habîbe leh',
      no: 1,
    },
    {
      arab: 'يَا طَبِيبَ مَنْ لَا طَبِيبَ لَهُ',
      meal: 'Ey tabibi olmayanların tabibi,',
      latin: 'Yâ Tabîbe men lâ tabîbe leh',
      no: 2,
    },
    {
      arab: 'يَا مُجِيبَ مَنْ لَا مُجِيبَ لَهُ',
      meal: 'Ey isteklerini dinleyip cevap verecek kimsesi olmayanların Mucîbi,',
      latin: 'Yâ Mucîbe men lâ mücîbe leh',
      no: 3,
    },
    {
      arab: 'يَا شَفِيقَ مَنْ لَا شَفِيقَ لَهُ',
      meal: 'Ey şefkat edecek kimsesi olmayanların şefkat edicisi,',
      latin: 'Yâ Şefîka men lâ şefîka leh',
      no: 4,
    },
    {
      arab: 'يَا رَفِيقَ مَنْ لَا رَفِيقَ لَهُ',
      meal: 'Ey arkadaşı olmayanların arkadaşı,',
      latin: 'Yâ Rafîka men lâ rafîka leh',
      no: 5,
    },
    {
      arab: 'يَا شَفِيعَ مَنْ لَا شَفِيعَ لَهُ',
      meal: 'Ey şefaat edecek kimsesi olmayanların Şefîi,',
      latin: 'Yâ Şefî’a men lâ şefî’a leh',
      no: 6,
    },
    {
      arab: 'يَا مُغِيثَ مَنْ لَا مُغِيثَ لَهُ',
      meal: 'Ey imdâdına koşacak kimsesi olmayanların imdat edicisi,',
      latin: 'Yâ Muğîse men lâ müğîse leh',
      no: 7,
    },
    {
      arab: 'يَا دَلِيلَ مَنْ لَا دَلِيلَ لَهُ',
      meal: 'Ey yol gösterecek kimsesi olmayanların yol göstericisi,',
      latin: 'Yâ Delîle men lâ delîle leh',
      no: 8,
    },
    {
      arab: 'يَا قَٓائِدَ مَنْ لَا قَٓائِدَ لَهُ',
      meal: 'Ey rehberi olmayanların rehberi,',
      latin: 'Yâ Kaide men lâ kaide leh',
      no: 9,
    },
    {
      arab: 'يَا رَاحِمَ مَنْ لَا رَاحِمَ لَهُ',
      meal: 'Ey merhamet edecek kimsesi olmayanların merhamet edicisi,',
      latin: 'Yâ Râhıme men lâ râhıme leh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '59': [
    {
      arab: 'يَا كَافِىَ مَنِ اسْتَكْفَاهُ',
      meal: 'Ey Kendisini her şeye bedel yeter görenlerin Kâfisi,',
      latin: 'Yâ Kâfiye meni’stekfâh',
      no: 1,
    },
    {
      arab: 'يَا هَادِىَ مَنِ اسْتَهْدَاهُ',
      meal: 'Ey Kendisinden hidâyet isteyenlerin hidâyet edicisi,',
      latin: 'Yâ Hâdiye meni’stehdâh',
      no: 2,
    },
    {
      arab: 'يَا كَالِىَ مَنِ اسْتَكْلَاهُ',
      meal: 'Ey gizlenecek yer arayanların üstünü örten,',
      latin: 'Yâ Kâliye meni’steklâh',
      no: 3,
    },
    {
      arab: 'يَا دَاعِىَ مَنِ اسْتَدْعَاهُ',
      meal: 'Ey Kendisini çağıranları Cennetine dâvet eden,',
      latin: 'Yâ Dâ’iye meni’sted’âh',
      no: 4,
    },
    {
      arab: 'يَا شَافِىَ مَنِ اسْتَشْفَاهُ',
      meal: 'Ey Kendisinden şifa isteyene şifa veren,',
      latin: 'Yâ Şâfıye meni’steşfâh',
      no: 5,
    },
    {
      arab: 'يَا قَاضِىَ مَنِ اسْتَقْضَاهُ',
      meal: 'Ey Kendisinden hükmetmesini isteyenler hakkında hükmeden,',
      latin: 'Yâ Kâdiye meni’stakdâh',
      no: 6,
    },
    {
      arab: 'يَا مُغْنِىَ مَنِ اسْتَغْنَاهُ',
      meal: 'Ey maddi ve manevi zenginlik isteyenleri zenginleştiren,',
      latin: 'Yâ Muğniye meni’steğnâh',
      no: 7,
    },
    {
      arab: 'يَا مُوفِىَ مَنِ اسْتَوْفَاهُ',
      meal: 'Ey Kendisinden her ihtiyacını yerine getirmesini isteyenlerin ihtiyaçlarına yeterli cevap veren,',
      latin: 'Yâ Mûfîye meni’stevfâh',
      no: 8,
    },
    {
      arab: 'يَا مُقَوِّىَ مَنِ اسْتَقْوَاهُ',
      meal: 'Ey kuvvet ve güç isteyenlere kâfi kuvvet veren,',
      latin: 'Yâ Mukavviye meni’stakvâh',
      no: 9,
    },
    {
      arab: 'يَا وَلِىَّ مَنِ اسْتَوْلَاهُ',
      meal: 'Ey Kendisinden dostluk ve sahiplik isteyenlerin dost ve sahibi,',
      latin: 'Yâ Veliyye meni’stevlâh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٥٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '60': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَٓا اَوَّلُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey her şeyden önce olan Evvel,',
      latin: 'Ve es’elüke biesmâike Yâ Evvel',
      no: 1,
    },
    {
      arab: 'يَٓا اٰخِرُ',
      meal: 'Ey her şeyden sonra olan Âhir,',
      latin: 'Yâ Âhir',
      no: 2,
    },
    {
      arab: 'يَا ظَاهِرُ',
      meal: 'Ey varlığı apaçık görünen Zâhir,',
      latin: 'Yâ Zahir',
      no: 3,
    },
    {
      arab: 'يَا بَاطِنُ',
      meal: 'Ey her şeyin içyüzünden haberdar olan Bâtın,',
      latin: 'Yâ Bâtın',
      no: 4,
    },
    {
      arab: 'يَا خَالِقُ',
      meal: 'Ey her şeyi yoktan yaratan Hâlık,',
      latin: 'Yâ Halik',
      no: 5,
    },
    {
      arab: 'يَا رَازِقُ',
      meal: 'Ey her şeyi münâsip bir şekilde rızıklandıran Râzık,',
      latin: 'Yâ Râzik',
      no: 6,
    },
    {
      arab: 'يَا صَادِقُ',
      meal: 'Ey her işi doğru olan ve sözünü yerine getiren Sâdık,',
      latin: 'Yâ Sâdık',
      no: 7,
    },
    {
      arab: 'يَا سَابِقُ',
      meal: 'Ey varlığı her şeyden önce olan Sâbık,',
      latin: 'Yâ Sabık',
      no: 8,
    },
    {
      arab: 'يَا سَٓائِقُ',
      meal: 'Ey her şeyi mukadder hedefine sevk eden Sâik,',
      latin: 'Yâ Saik',
      no: 9,
    },
    {
      arab: 'يَا فَالِقُ',
      meal: 'Ey tohum ve çekirdekleri yarıp sümbüllendiren Fâlık,',
      latin: 'Yâ Fâlik',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ اَجِرْنَا مِنَ النَّارِ ﴿٦٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne ecirnâ mine’n-nâr.',
    },
  ],
  '61': [
    {
      arab: 'يَا مَنْ يُقَلِّبُ الَّيْلَ وَ النَّهَارَ',
      meal: 'Ey gece ve gündüzü peş peşe değiştiren,',
      latin: 'Yâ Men yükallibü’l-leyle ve’n-nehâr',
      no: 1,
    },
    {
      arab: 'يَا مَنْ خَلَقَ الظُّلُمَاتِ وَ النُّورَ',
      meal: 'Ey karanlıkları ve nûru yaratan,',
      latin: 'Yâ Men Halaka’z-zulümâti ve’n-nûr',
      no: 2,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الظِّلَّ وَ الْحَرُورَ',
      meal: 'Ey gölgeleri ve harâreti meydana getiren,',
      latin: 'Yâ Men ce’ale’z-zılle ve’l-harur',
      no: 3,
    },
    {
      arab: 'يَا مَنْ سَخَّرَ الشَّمْسَ وَ الْقَمَرَ',
      meal: 'Ey güneş ve aya boyun eğdiren,',
      latin: 'Yâ Men sehhara’s-semse ve’l-kamer',
      no: 4,
    },
    {
      arab: 'يَا مَنْ خَلَقَ الْمَوْتَ وَ الْحَيٰوةَ',
      meal: 'Ey ölümü ve hayatı yaratan,',
      latin: 'Yâ Men haleka’l-mevte ve’l-hayah',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَهُ الْخَلْقُ وَ الْاَمْرُ',
      meal: 'Ey yaratmak ve emretmek Kendisine âit olan,',
      latin: 'Yâ Men lehü’l-halku ve’l-emr',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَمْ يَتَّخِذْ صَاحِبَةً وَ لَا وَلَدًا',
      meal: 'Ey eş ve evlât edinmeyen,',
      latin: 'Yâ Men lem yettehiz sâhibeten velâ veledâ',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَمْ يَكُنْ لَهُ شَرِيكٌ فِى الْمُلْكِ',
      meal: 'Ey mülkünde hiçbir şerîki olmayan,',
      latin: 'Yâ Men lem yekûn lehû şerikim fi’l-mülk',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَمْ يَكُنْ لَهُ وَلِىٌّ مِنَ الذُّلِّ',
      meal: 'Ey zilletten münezzeh olduğu için dosta ihtiyacı olmayan,',
      latin: 'Yâ Men lem yekûn lehû veliyyün mine’z-züll',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَهُ الْحَوْلُ وَ الْقُوَّةُ',
      meal: 'Ey havl ve kuvvet kendisine âit olan,',
      latin: 'Yâ men lehü’l-havlü ve’l-kuvveh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ enteİ-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '62': [
    {
      arab: 'يَا مَنْ يَعْلَمُ مُرَادَ الْمُرِيدِينَ',
      meal: 'Ey Kendisini arzulayanların murâdını bilen,',
      latin: 'Yâ Men ya’lemü mürâde’l-mürîdîn',
      no: 1,
    },
    {
      arab: 'يَا مَنْ يَمْلِكُ حَوَٓائِجَ السَّٓائِلِينَ',
      meal: 'Ey Kendisinden dilekte bulunanların ihtiyaç duyduklarına sahip olan,',
      latin: 'Yâ Men yemlikü havaice’s-sâilîn',
      no: 2,
    },
    {
      arab: 'يَا مَنْ يَسْمَعُ اَنِينَ الْوَالِهِينَ',
      meal: 'Ey üzüntüsünden kendinden geçenlerin inlemelerini işiten,',
      latin: 'Yâ Men yesme’u enîne’l-valihîn',
      no: 3,
    },
    {
      arab: 'يَا مَنْ يَرٰى بُكَٓاءَ الْخَٓائِفِينَ',
      meal: 'Ey Kendisinden korkarak ağlayanların ağlayışını gören,',
      latin: 'Yâ Men yerâ bükâe’l-hâifîn',
      no: 4,
    },
    {
      arab: 'يَا مَنْ يَعْلَمُ ضَمِيرَ الصَّامِتِينَ',
      meal: 'Ey suskunların içinden geçenleri bilen,',
      latin: 'Yâ Men ya’lemu damîra’s-sâmitîn',
      no: 5,
    },
    {
      arab: 'يَا مَنْ يَرٰى نَدَمَ النَّادِمِينَ',
      meal: 'Ey günahlarından pişmanlık duyanların nedâmetini gören,',
      latin: 'Yâ Men yerâ nedeme’n-nâdimîn',
      no: 6,
    },
    {
      arab: 'يَا مَنْ يَقْبَلُ عُذْرَ التَّٓائِبِينَ',
      meal: 'Ey tövbekârların özrünü kabul eden,',
      latin: 'Yâ Men yakbelü ‘uzre’t-tâibîn',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَا يُصْلِحُ عَمَلَ الْمُفْسِدِينَ',
      meal: 'Ey fesatçıların işini düzeltmeyen,',
      latin: 'Yâ Men lâ yuslihu ‘amele’l-müfsidîn',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَا يُضِيعُ اَجْرَ الْمُحْسِنِينَ',
      meal: 'Ey iyilik yapanların mükâfatını zâyi etmeyen,',
      latin: 'Yâ Men lâ yudî’u ecra’l-muhsinîn',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَا يَبْعُدُ عَنْ قُلُوبِ الْعَارِفِينَ',
      meal: 'Ey Kendisini tanıyanların kalplerinden uzaklaşmayan,',
      latin: 'Yâ Men lâ yeb’udü an kulûbi’l-‘arifîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '63': [
    {
      arab: 'يَا دَٓائِمَ الْبَقَٓاءِ',
      meal: 'Ey bekası dâim olan,',
      latin: 'Yâ Dâime’l-bekâ',
      no: 1,
    },
    {
      arab: 'يَا غَافِرَ الْخَطَٓاءِ',
      meal: 'Ey hatâları bağışlayan,',
      latin: 'Yâ Ğafira’l-hatâ',
      no: 2,
    },
    {
      arab: 'يَا سَامِعَ الدُّعَٓاءِ',
      meal: 'Ey duâları işiten,',
      latin: 'Yâ Sâmi’e’d-düâ',
      no: 3,
    },
    {
      arab: 'يَا وَاسِعَ الْعَطَٓاءِ',
      meal: 'Ey ihsânı geniş olan,',
      latin: 'Yâ Vâsi’a’l-‘atâ',
      no: 4,
    },
    {
      arab: 'يَا رَافِعَ السَّمَٓاءِ',
      meal: 'Ey gökleri yükselten,',
      latin: 'Yâ Râfı’a’s-semâ',
      no: 5,
    },
    {
      arab: 'يَا كَاشِفَ الْبَلَٓاءِ',
      meal: 'Ey belâları defeden,',
      latin: 'Yâ Kâşife’l-belâ',
      no: 6,
    },
    {
      arab: 'يَاعَظِيمَ الثَّنَٓاءِ',
      meal: 'Ey medih ve senâsı büyük olan,',
      latin: 'Yâ ‘Azîme’s-senâ',
      no: 7,
    },
    {
      arab: 'يَا قَدِيمَ السَّنَٓاءِ',
      meal: 'Ey varlığının parıltısı kadîm olan,',
      latin: 'Yâ Kadîme’s-senâ',
      no: 8,
    },
    {
      arab: 'يَا كَثِيرَ الْوَفَٓاءِ',
      meal: 'Ey vefâsı çok olan,',
      latin: 'Yâ Keşira’l-vefa',
      no: 9,
    },
    {
      arab: 'يَا شَرِيفَ الْجَزَٓاءِ',
      meal: 'Ey mükâfatı şerefli olan,',
      latin: 'Yâ Şerîfe’l-cezâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '64': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا غَفَّارُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey çok affeden Gaffâr,',
      latin: 'Ve es’elüke biesmâike Yâ Ğaffâr',
      no: 1,
    },
    {
      arab: 'يَا سَتَّارُ',
      meal: 'Ey bütün ayıpları örten Settâr,',
      latin: 'Yâ Settâr',
      no: 2,
    },
    {
      arab: 'يَا قَهَّارُ',
      meal: 'Ey her şeye galip gelen ve bütün düşmanlarını kahreden Kahhâr,',
      latin: 'Yâ Kahhâr',
      no: 3,
    },
    {
      arab: 'يَا جَبَّارُ',
      meal: 'Ey istediğini zorla yaptıran Cebbâr,',
      latin: 'Yâ Cebbar',
      no: 4,
    },
    {
      arab: 'يَا صَبَّارُ',
      meal: 'Ey çok sabreden ve kullarına sabır gücü veren Sabbâr,',
      latin: 'Yâ Sabbâr',
      no: 5,
    },
    {
      arab: 'يَا رَزَّاقُ',
      meal: 'Ey bütün rızka muhtaç olanları rızıklandıran Rezzâk,',
      latin: 'Yâ Razzâk',
      no: 6,
    },
    {
      arab: 'يَا فَتَّاحُ',
      meal: 'Ey her şeyi hikmetle açan Fettâh,',
      latin: 'Yâ Fettâh',
      no: 7,
    },
    {
      arab: 'يَا عَلَّا مُ',
      meal: 'Ey her şeyi çok iyi bilen Allâm,',
      latin: 'Yâ ‘Allâm',
      no: 8,
    },
    {
      arab: 'يَا وَهَّابُ',
      meal: 'Ey bol bol hediyeler veren Vehhâb,',
      latin: 'Yâ Vehhâb',
      no: 9,
    },
    {
      arab: 'يَا تَوَّابُ',
      meal: 'Ey bütün tövbeleri kabul eden Tevvâb,',
      latin: 'Yâ Tevvâb',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '65': [
    {
      arab: 'يَا مَنْ خَلَقَنِى وَ سَوَّانِى',
      meal: 'Ey beni yaratıp âzâlarımı düzene koyan,',
      latin: 'Yâ Men halekanî ve sevvânî',
      no: 1,
    },
    {
      arab: 'يَا مَنْ رَزَقَنِى وَ رَبَّانِى',
      meal: 'Ey bana rızık veren ve terbiye eden,',
      latin: 'Yâ Men razekanî ve rabbânî',
      no: 2,
    },
    {
      arab: 'يَا مَنْ اَطْعَمَنِى وَ سَقَانِى',
      meal: 'Ey beni yedirip içiren,',
      latin: 'Yâ Men et’amenî ve sekânî',
      no: 3,
    },
    {
      arab: 'يَا مَنْ قَرَّبَنِى وَ اَدْنَانِى',
      meal: 'Ey beni kendisine yaklaştırıp yakın kılan,',
      latin: 'Yâ Men karrabenî ve ednânî',
      no: 4,
    },
    {
      arab: 'يَا مَنْ عَصَمَنِى وَ كَفَانِى',
      meal: 'Ey beni günah tehlikelerinden koruyup bana kâfi gelen,',
      latin: 'Yâ Men ‘asamenî ve kefânî',
      no: 5,
    },
    {
      arab: 'يَا مَنْ حَفِظَنِى وَ كَلَانِى',
      meal: 'Ey beni muhafaza edip ayıplarımı örten,',
      latin: 'Yâ Men hafızanî ve kelânî',
      no: 6,
    },
    {
      arab: 'يَا مَنْ وَفَّقَنِى وَ هَدَانِى',
      meal: 'Ey bana tevfîk edip hidâyet eden,',
      latin: 'Yâ Men veffekanî ve hedânî',
      no: 7,
    },
    {
      arab: 'يَا مَنْ اَعَزَّنِى وَ اَغْنَانِى',
      meal: 'Ey beni azîz kılıp ihtiyaçlarımı gideren,',
      latin: 'Yâ Men e’azzenî ve ağnânî',
      no: 8,
    },
    {
      arab: 'يَا مَنْ اَمَاتَنِى وَ اَحْيَانِى',
      meal: 'Ey beni öldürüp dirilten,',
      latin: 'Yâ Men emâtenî ve ahyânî',
      no: 9,
    },
    {
      arab: 'يَا مَنْ اٰنَسَنِى وَ اٰوَانِى',
      meal: 'Ey bana ünsiyet verip rızıklandıran,',
      latin: 'Yâ Men ânesenî ve âvânî',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '66': [
    {
      arab: 'يَا مَنْ يُحِقُّ الْحَقَّ بِكَلِمَاتِهِ',
      meal: 'Ey kelimeleriyle hakkın hak olduğunu gösteren,',
      latin: 'Yâ Men yühikku’l-hakka bikelimâtih',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا مُعَقِّبَ لِحُكْمِهِ',
      meal: 'Ey hükmünü geri bıraktıracak kimse olmayan,',
      latin: 'Yâ Men lâ mü’akkibe lihukmih',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا رَٓادَّ لِقَضَٓائِهِ',
      meal: 'Ey kazâsını geri çevirecek kimse olmayan,',
      latin: 'Yâ Men lâ radde likadâih',
      no: 3,
    },
    {
      arab: 'يَا مَنْ يَحُولُ بَيْنَ الْمَرْءِ وَ قَلْبِهِ',
      meal: 'Ey kişiye kalbinden daha yakın olan,',
      latin: 'Yâ Men yehûlü beyne’l-mer’i ve kalbih',
      no: 4,
    },
    {
      arab: 'يَا مَنْ يَقْبَلُ التَّوْبَةَ عَنْ عِبَادِهِ',
      meal: 'Ey kullarından tövbeyi kabul eden,',
      latin: 'Yâ Men yakbelü’t-tevbete an ‘ibâdih',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا تَنْفَعُ الشَّفَاعَةُ اِلَّا بِاِذْنِهِ',
      meal: 'Ey izni olmadan hiçbir şefaat fayda vermeyen,',
      latin: 'Yâ Men lâ tenfe’u’ş-şefa’atü illâ biiznih',
      no: 6,
    },
    {
      arab: 'يَا مَنِ السَّمٰوَاتُ مَطْوِيَّاتٌ بِيَمِينِهِ',
      meal: 'Ey bütün gökler kudretiyle dürülmüş olan,',
      latin: 'Yâ Meni’s-semâvâtü matviyyâtün biyemînih',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ اَعْلَمُ بِمَنْ ضَلَّ عَنْ سَبِيلِهِ',
      meal: 'Ey yolundan sapanları en iyi bilen,',
      latin: 'Yâ Men hüve a’lemü bi men dalle ‘an sebîlih',
      no: 8,
    },
    {
      arab: 'يَا مَنْ يُسَبِّحُ الرَّعْدُ بِحَمْدِهِ وَ الْمَلَٓئِكَةُ مِنْ خِيفَتِهِ',
      meal: 'Ey gök gürültüsünün hamd ederek, meleklerin de korkusuyla Kendisini tesbih ettiği,',
      latin: 'Yâ Men yüsebbihu’r-ra’dü bihâmdi-hi ve’l-melâiketü min hîfetih',
      no: 9,
    },
    {
      arab: 'يَا مَنْ يُرْسِلُ الرِّيَاحَ بُشْرًا بَيْنَ يَدَىْ رَحْمَتِهِ',
      meal: 'Ey rahmetinin önünde rüzgârları müjdeci gönderen,',
      latin: 'Yâ Men yürsilü’r-riyâha büşran beyne yedey rahmetih',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '67': [
    {
      arab: 'يَا مَنْ جَعَلَ الْاَرْضَ مِهَادًا',
      meal: 'Ey yeri beşik yapan,',
      latin: 'Yâ Men ce’ale’l-arda mihâdâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الْجِبَالَ اَوْتَادًا',
      meal: 'Ey dağları direk yapan,',
      latin: 'Yâ Men ce’ale’l-cibâle evtâdâ',
      no: 2,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الشَّمْسَ سِرَاجًا',
      meal: 'Ey güneşi kandil kılan,',
      latin: 'Yâ Men ce’ale’l-şemse sirâcâ',
      no: 3,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الْقَمَرَ نُورًا',
      meal: 'Ey ay’ı nur kılan,',
      latin: 'Yâ Men ce’ale’l-kamera nûrâ',
      no: 4,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الَّيْلَ لِبَاسًا',
      meal: 'Ey geceyi örtü yapan,',
      latin: 'Yâ Men ce’ale’l-leyle libâsa',
      no: 5,
    },
    {
      arab: 'يَا مَنْ جَعَلَ النَّهَارَ مَعَاشًا',
      meal: 'Ey gündüzü maîşet zamanı yapan,',
      latin: 'Yâ Men ce’ale’n-nehâra me’âşâ',
      no: 6,
    },
    {
      arab: 'يَا مَنْ جَعَلَ النَّوْمَ سُبَاتًا',
      meal: 'Ey uykuyu huzur ve sükûn vasıtası kılan,',
      latin: 'Yâ Men ce’ale’n-nevme sübâtâ',
      no: 7,
    },
    {
      arab: 'يَا مَنْ جَعَلَ السَّمَٓاءَ بِنَٓاءً',
      meal: 'Ey semâyı bina kılan,',
      latin: 'Yâ Men ce’ale’s-semâe binâa',
      no: 8,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الْاَشْيَٓاءَ اَزْوَاجًا',
      meal: 'Ey eşyayı çift çift yaratan,',
      latin: 'Yâ Men ce’ale’l-eşyâe ezvâcâ',
      no: 9,
    },
    {
      arab: 'يَا مَنْ جَعَلَ النَّارَ مِرْصَادًا',
      meal: 'Ey ateşi gözcü kılan,',
      latin: 'Yâ Men ce’ale’n-nâra mirsâdâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '68': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا شَفِيعُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey gerçek şefaat sahibi Şefî,',
      latin: 'Ve es’elüke biesmâike Yâ Şefî’',
      no: 1,
    },
    {
      arab: 'يَا سَمِيعُ',
      meal: 'Ey gizli açık her sesi işiten Semî,',
      latin: 'Yâ Semî’',
      no: 2,
    },
    {
      arab: 'يَا رَفِيعُ',
      meal: 'Ey istediğini yükselten Rafî,',
      latin: 'Yâ Rafı’',
      no: 3,
    },
    {
      arab: 'يَا مَنِيعُ',
      meal: 'Ey istediğini engelleyen Menî,',
      latin: 'Yâ Meni’',
      no: 4,
    },
    {
      arab: 'يَا بَدِيعُ',
      meal: 'Ey kâinatı en güzel bir şekilde yoktan yaratan Bedî,',
      latin: 'Yâ Bedi’',
      no: 5,
    },
    {
      arab: 'يَا سَرِيعُ',
      meal: 'Ey hesâbı en süratli bir şekilde gören Serî,',
      latin: 'Yâ Serî’',
      no: 6,
    },
    {
      arab: 'يَا بَشِيرُ',
      meal: 'Ey sevdiklerini Cennet ve çeşitli mükâfatlarla müjdeleyen Beşîr,',
      latin: 'Yâ Beşîr',
      no: 7,
    },
    {
      arab: 'يَا نَذِيرُ',
      meal: 'Ey kullarını itaate sevk etmek için azâbıyla korkutan Nezîr,',
      latin: 'Yâ Nezîr',
      no: 8,
    },
    {
      arab: 'يَا قَدِيرُ',
      meal: 'Ey sonsuz kudret sahibi olan Kadîr,',
      latin: 'Yâ Kadîr',
      no: 9,
    },
    {
      arab: 'يَا مُقْتَدِرُ',
      meal: 'Ey her şeye gücü yeten Muktedir,',
      latin: 'Yâ Muktedir',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-em ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '69': [
    {
      arab: 'يَا حَىُّ قَبْلَ كُلِّ حَىٍّ',
      meal: 'Ey bütün dirilerden önce var olan gerçek hayat sahibi,',
      latin: 'Yâ Hayyü kable külli hayy',
      no: 1,
    },
    {
      arab: 'يَا حَىُّ بَعْدَ كُلِّ حَىٍّ',
      meal: 'Ey bütün dirilerden sonra bâkî kalacak gerçek hayat sahibi,',
      latin: 'Yâ Hayyü ba’de külli hayy',
      no: 2,
    },
    {
      arab: 'يَا حَىُّ الَّذِى لَا يُشْبِهُهُ شَىْءٌ',
      meal: 'Ey hiçbir şeyin Kendisine benzemediği gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî lâ yuşbihühû şey’',
      no: 3,
    },
    {
      arab: 'يَا حَىُّ الَّذِى لَيْسَ كَمِثْلِهِ حَىٌّ',
      meal: 'Ey hiçbir dirinin misli gibi olmadığı gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî leyse kemislihî hayy',
      no: 4,
    },
    {
      arab: 'يَا حَىُّ الَّذِى لَا يُشَارِكُهُ حَىٌّ',
      meal: 'Ey hiçbir dirinin Kendisine ortak olmadığı gerçek hayat sahibi,',
      latin: ' Yâ Hayyü’llezî lâ yuşârikühû hayy',
      no: 5,
    },
    {
      arab: 'يَا حَىُّ الَّذِى لَا يَحْتَاجُ اِلٰى حَىٍّ',
      meal: 'Ey hiçbir diriye muhtaç olmayan gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî lâ yahtâcü ilâ hayy',
      no: 6,
    },
    {
      arab: 'يَا حَىُّ الَّذِى يُمِيتُ كُلَّ حَىٍّ',
      meal: 'Ey bütün dirileri öldüren gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî yümîtü külle hayy',
      no: 7,
    },
    {
      arab: 'يَا حَىُّ الَّذِى يَرْزُقُ كُلَّ حَىٍّ',
      meal: 'Ey bütün dirileri rızıklandıran gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî yerzüku külle hayy',
      no: 8,
    },
    {
      arab: 'يَا حَىُّ الَّذِى يُحْيِى الْمَوْتٰى',
      meal: 'Ey ölüleri dirilten gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî yühyi’l-mevtâ',
      no: 9,
    },
    {
      arab: 'يَا حَىُّ الَّذِى لَا يَمُوتُ',
      meal: 'Ey hiç ölmeyecek olan gerçek hayat sahibi,',
      latin: 'Yâ Hayyü’llezî lâ yemût',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٦٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '70': [
    {
      arab: 'يَا مَنْ لَهُ ذِكْرٌ لَا يُنْسٰى',
      meal: 'Ey unutulmayan ve unutturulmayan zikrin sahibi,',
      latin: 'Yâ Men lehû zikrun lâ yunsâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَهُ نُورٌ لَا يُطْفٰى',
      meal: 'Ey söndürülemeyen nûrun sahibi,',
      latin: 'Yâ Men lehû nurun lâ yutfâ',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَهُ ثَنَٓاءٌ لَا يُحْصٰى',
      meal: 'Ey had ve hesâba gelmeyen medih ve senâ sahibi,',
      latin: 'Yâ Men lehû şenâün lâ yuhsâ',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَهُ نُعُوتٌ لَا تُغَيَّرُ',
      meal: 'Ey hiçbir şekilde değiştirilemeyen vasıflar sahibi,',
      latin: 'Yâ Men lehû nü’ûtün lâ tüğayyer',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَهُ نِعَمٌ لَا تُعَدُّ',
      meal: 'Ey sayılamayan nîmetler sahibi,',
      latin: 'Yâ Men lehû ni’amün lâ tü’add',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَهُ مُلْكٌ لَا يَزُولُ',
      meal: 'Ey zevâl bulmayan saltanat sahibi,',
      latin: 'Yâ Men lehû mülkün lâ yezûl',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَهُ جَلَالٌ لَا يُكَيَّفُ',
      meal: 'Ey gerçek keyfiyeti anlaşılamayan celâl sahibi,',
      latin: 'Yâ Men lehû celâlün lâ yukeyyef',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَهُ قَضَٓاءٌ لَا يُرَدُّ',
      meal: 'Ey reddedilemeyen hüküm sahibi,',
      latin: 'Yâ Men lehû kadâün lâ yuradd',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَهُ صِفَاتٌ لَا تُبَدَّلُ',
      meal: 'Ey tebdil edilemeyen sıfatlar sahibi,',
      latin: 'Yâ Men lehû sıfâtün lâ tübeddel',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَهُ كَمَالٌ لَا يُدْرَكُ',
      meal: 'Ey tam idrak edilemeyen kemâl sahibi,',
      latin: 'Yâ Men lehû kemâlün lâ yudrak',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '71': [
    {
      arab: 'يَا رَبَّ الْعَالَمِينَ',
      meal: 'Ey âlemlerin Rabbi,',
      latin: 'YâRabbe’I-‘âlemîn',
      no: 1,
    },
    {
      arab: 'يَا مَالِكَ يَوْمِ الدّ۪ينِ',
      meal: 'Ey amellerin karşılıklarının verildiği Kıyamet Gününün sahibi,',
      latin: 'Yâ Mâlike yevmi’d-dîn',
      no: 2,
    },
    {
      arab: 'يَا مَنْ يُحِبُّ الصَّابِرِينَ',
      meal: 'Ey sabredenleri seven,Ey sabredenleri seven,',
      latin: 'Yâ Men yühibbü’s-sâbirîn',
      no: 3,
    },
    {
      arab: 'يَا مَنْ يُحِبُّ التَّوَّابِينَ',
      meal: 'Ey tövbe edenleri seven,',
      latin: 'Yâ Men yuhibbü’t-tevvâbîn',
      no: 4,
    },
    {
      arab: 'يَا مَنْ يُحِبُّ الْمُتَطَهِّرِينَ',
      meal: 'Ey maddi ve manevi kirlerden temizlenenleri seven,',
      latin: 'Yâ Men yuhibbü’l-mütetahhirîn',
      no: 5,
    },
    {
      arab: 'يَا مَنْ يُحِبُّ الْمُحْسِنِينَ',
      meal: 'Ey Allah’ı görür gibi ibadet edenleri ve iyilik yapanları seven,',
      latin: 'Yâ Men yuhibbü’l-muhsinîn',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ خَيْرُ النَّاصِرِينَ',
      meal: 'Ey yardım edenlerin en hayırlısı,',
      latin: 'Yâ Men hüve hayru’n-nâsirîn',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ خَيْرُ الْفَاصِلِينَ',
      meal: 'Ey müşkül meseleleri halledip hükme bağlayanların en hayırlısı,',
      latin: 'Yâ Men hüve hayru’l-fasilîn',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ خَيْرُ الشَّاكِرِينَ',
      meal: 'Ey iyi amellere bol karşılık verenlerin en hayırlısı,',
      latin: 'Yâ Men hüve hayru’ş-şâkirîn',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ اَعْلَمُ بِالْمُفْسِدِينَ',
      meal: 'Ey ifsat edenleri en iyi bilen,',
      latin: 'Yâ men hüve a’lemü bi’l-müfsidîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '72': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُبْدِىُٔ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:',
      latin: 'Ve es’elüke biesmâike Yâ Mubdi',
      no: 1,
    },
    {
      arab: 'يَا مُعِيدُ',
      meal: 'Ey mahlûkatı öldükten sonra yeniden dirilten Muîd,',
      latin: 'Yâ Mu’îd',
      no: 2,
    },
    {
      arab: 'يَا حَفِيظُ',
      meal: 'Ey her şeyi muhafaza eden Hafîz,',
      latin: 'Yâ Hafız',
      no: 3,
    },
    {
      arab: 'يَا مُحِيطُ',
      meal: 'Ey her şeyi ilim ve kudretiyle kuşatan Muhît,',
      latin: 'Yâ Muhît',
      no: 4,
    },
    {
      arab: 'يَا حَمِيدُ',
      meal: 'Ey hamd ve senâya en çok layık olan ve çok övülen Hamîd,',
      latin: 'Yâ Hamîd',
      no: 5,
    },
    {
      arab: 'يَا مَجِيدُ',
      meal: 'Ey azamet, şeref ve hâkimiyeti sonsuz Mecîd,',
      latin: 'Yâ Mecîd',
      no: 6,
    },
    {
      arab: 'يَا مُقِيتُ',
      meal: 'Ey her türlü mahlûkata münasip rızık veren Mukît,',
      latin: 'Yâ Mukît',
      no: 7,
    },
    {
      arab: 'يَا مُغِيثُ',
      meal: 'Ey darda kalan çaresizlerin imdadına koşan Mugîs,',
      latin: 'Yâ Muğîs',
      no: 8,
    },
    {
      arab: 'يَا مُعِزُّ',
      meal: 'Ey istediğine izzet veren ve şereflendiren Muizz,',
      latin: 'Yâ Mu’îzz',
      no: 9,
    },
    {
      arab: 'يَا مُذِلُّ',
      meal: 'Ey istediğini zelil kılan Müzill,',
      latin: 'Yâ Muzill',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-e: ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '73': [
    {
      arab: 'يَا مَنْ هُوَ اَحَدٌ بِلَا ضِدٍّ',
      meal: 'Ey zıddı olmayan Ehad,',
      latin: '1Yâ Men hüve Ehadün bilâ didd',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ فَرْدٌ بِلَا نِدٍّ',
      meal: 'Ey dengi bulunmayan Ferd,',
      latin: 'Yâ Men hüve Ferdün bilâ nidd',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ صَمَدٌ بِلَا عَيْبٍ',
      meal: 'Ey kusur ve ihtiyaçtan münezzeh olan Samed,',
      latin: 'Yâ Men hüve Samedün bilâ ‘ayb',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ وِتْرٌ بِلَا شَفْعٍ',
      meal: 'Ey çifti bulunmayan Vitr,',
      latin: 'Yâ Men hüve Vitrun bilâ şef',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ رَبٌّ بِلَا وَزِيرٍ',
      meal: 'Ey veziri bulunmayan Rab,',
      latin: 'Yâ Men hüve Rabbün bilâ vezîr',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ غَنِىٌّ بِلَا فَقْرٍ',
      meal: 'Ey fakirliği bulunmayan Ganî,',
      latin: 'Yâ Men hüve Ğaniyyün bilâ fakr',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ سُلْطَانٌ بِلَا عَزْلٍ',
      meal: 'Ey azledilemeyen Sultan,',
      latin: 'Yâ Men hüve Sültânün bilâ ‘azl',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ مَلِيكٌ بِلَا عَجْزٍ',
      meal: 'Ey acizden münezzeh olan Melîk,',
      latin: 'Yâ Men hüve Melîkün bilâ ‘acz',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ مَوْجُودٌ بِلَا مِثْلٍ',
      meal: 'Ey benzeri olmayan Mevcûd,',
      latin: 'Yâ Men hüve Mevcudun bilâ misl',
      no: 9,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
      no: 10,
    },
  ],
  '74': [
    {
      arab: 'يَا مَنْ هُوَ ذِكْرُهُ شَرَفٌ لِلذَّاكِرِينَ',
      meal: 'Ey zikri Kendisini zikredenlere büyük şeref olan,',
      latin: 'Yâ Men hüve zikruhû şerafün li’z-zâkirîn',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ شُكْرُهُ فَوْزٌ لِلشَّاكِرِينَ',
      meal: 'Ey şükrü Kendisine şükredenlere büyük kurtuluş olan,',
      latin: 'Yâ Men hüve şükruhû fevzün li’ş-şâkirîn',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ حَمْدُهُ فَخْرٌ لِلْحَامِدِينَ',
      meal: 'Ey hamdı Kendisini övenlere büyük iftihar vesilesi olan,',
      latin: 'Yâ Men hüve hamdühû fahrun li’l-hâmidîn',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ طَاعَتُهُ نَجَاةٌ لِلْمُطِيعِينَ',
      meal: 'Ey tâati, Kendisine itaat edenlere necât olan,',
      latin: 'Yâ Men hüve tâ’atühû necâtün li’l-mütî’în',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ بَابُهُ مَفْتوُحٌ لِلطَّالِبِينَ',
      meal: 'Ey kapısı, Kendisini arayanlara açık olan,',
      latin: 'Yâ Men hüve bâbühü meftûhun li’t-tâlibîn',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ سَبِيلُهُ وَاضِحٌ لِلْمُؤْمِنِينَ',
      meal: 'Ey yolu müminlere zâhir ve belli olan,',
      latin: 'Yâ Men hüve sebilühû vâdihun li’l-mü’minîn',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ اٰيَاتُهُ بُرْهَانٌ لِلنَّاظِرِينَ',
      meal: 'Ey âyetleri bakanlar için kesin delil olan,',
      latin: 'Yâ men hüve âyâtühû bürhânün Ii’n-nâzirîn',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ كِتَابُهُ تَذْكِرَةٌ لِلْمُوقِنِينَ',
      meal: 'Ey kitabı kuvvetli îman sahipleri için öğüt olan,',
      latin: 'Yâ men hüve kitâbühû tezkiratün li’l-mûkınîn',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ عَفْوُهُ مَلْجَأٌ لِلْمُذْنِبِينَ',
      meal: 'Ey affı günahkarlar için sığınak olan,',
      latin: 'Yâ men hüve ‘afvühü melceün li’l-müznibîn',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ رَحْمَتُهُ قَرِيبٌ لِلْمُحْسِنِينَ',
      meal: 'Ey rahmeti muhsinler için yakın olan,',
      latin: 'Yâ men hüve rahmetühû karîbûn li’l-muhsinîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '75': [
    {
      arab: 'يَا مَنْ تَبَارَكَ اسْمُهُ',
      meal: 'Ey ismi yüce ve mübarek olan,',
      latin: 'Yâ Men tebâreke’smüh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ تَعَالٰى جَدُّهُ',
      meal: 'Ey şan ve makamı yüksek olan,',
      latin: 'Yâ Men te’âlâ ceddüh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ جَلَّ ثَنَٓاؤُهُ',
      meal: 'Ey senâ ve övgüsü büyük olan,',
      latin: 'Yâ Men celle senâüh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَٓا اِلٰهَ غَيْرُهُ',
      meal: 'Ey kendisinden başka ilâh olmayan,',
      latin: 'Yâ Men lâ ilahe ğayruh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ تَقَدَّسَتْ اَسْمَٓاؤُهُ',
      meal: 'Ey isimleri mukaddes olan,',
      latin: 'Yâ Men tekaddeset esmâüh',
      no: 5,
    },
    {
      arab: 'يَا مَنْ يَدُومُ بَقَٓاؤُهُ',
      meal: 'Ey bekâsı devam eden,',
      latin: 'Yâ Men yedûmü bekâüh',
      no: 6,
    },
    {
      arab: 'يَا مَنِ الْعَظَمَةُ بَهَٓاؤُهُ',
      meal: 'Ey azameti, bahâ ve kadri olan,',
      latin: 'Yâ Meni’l-‘azametü behâüh',
      no: 7,
    },
    {
      arab: 'يَا مَنِ الْكِبْرِيَٓاءُ رِدَٓاؤُهُ',
      meal: 'Ey büyüklük perdesi ola\tn,',
      latin: 'Yâ Meni’l-kibriyâü ridâüh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَا يُحْصٰى اٰلَٓاؤُهُ',
      meal: 'Ey gizli nimetleri grup grup bile sayılamayan,',
      latin: 'Yâ Men lâ yuhsâ âlâüh',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَا يُعَدُّ نَعْمَٓاؤُهُ',
      meal: 'Ey ihsan ve nimeti hesap ve sayıya gelmeyen,',
      latin: 'Yâ Men lâ yu’addü na’mâüh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '76': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُعِينُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey kullarına yardım eden Muîn,',
      latin: 'Ve es’elüke biesmâike Yâ Mu’în',
      no: 1,
    },
    {
      arab: 'يَا مُبِينُ',
      meal: 'Ey açıklanması gereken her şeyi beyan eden Mübîn,',
      latin: 'Yâ Mubîn',
      no: 2,
    },
    {
      arab: 'يَٓا اَمِينُ',
      meal: 'Ey kullarına emniyet ve huzur veren Emîn,',
      latin: 'Yâ Emîn',
      no: 3,
    },
    {
      arab: 'يَا مَكِينُ',
      meal: 'Ey saltanatı muhkem, nüfuz ve iktidar sahibi Mekîn,',
      latin: 'Yâ Mekîn',
      no: 4,
    },
    {
      arab: 'يَا مَتِينُ',
      meal: 'Ey hiçbir şey hükmünü sarsmayan ve Kendisine güvenilen Metîn,',
      latin: 'Yâ Metîn',
      no: 5,
    },
    {
      arab: 'يَا شَدِيدُ',
      meal: 'Ey azap ve ikâbı şiddetli olan Şedîd,',
      latin: 'Yâ Şedîd',
      no: 6,
    },
    {
      arab: 'يَا شَهِيدُ',
      meal: 'Ey kullarının her yaptığını gören Şehîd,',
      latin: 'Yâ Şehîd',
      no: 7,
    },
    {
      arab: 'يَا رَشِيدُ',
      meal: 'Ey bütün işlerini ezelî takdirine göre en güzel bir şekilde neticeye ulaştıran Raşîd,',
      latin: 'Yâ Raşîd',
      no: 8,
    },
    {
      arab: 'يَا حَمِيدُ',
      meal: 'Ey en çok övülen ve en çok övgüye layık olan Hamîd,',
      latin: 'Yâ Hamîd',
      no: 9,
    },
    {
      arab: 'يَا مَجِيدُ',
      meal: 'Ey sonsuz şeref sahibi Mecîd,',
      latin: 'Yâ Mecîd',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-neİ-emâne neccinâ mine’n-nâr.',
    },
  ],
  '77': [
    {
      arab: 'يَا ذَا الْعَرْشِ الْمَجِيدِ',
      meal: 'Ey yüce Arşın sahibi,',
      latin: 'Yâ Ze’l-arşi’l-mecîd',
      no: 1,
    },
    {
      arab: 'يَا ذَا الْقَوْلِ السَّدِيدِ',
      meal: 'Ey dosdoğru sözün sahibi,',
      latin: 'Yâ Ze’l-kavli’s-sedîd',
      no: 2,
    },
    {
      arab: 'يَا ذَا الْفَضْلِ الرَّشِيدِ',
      meal: 'Ey yerli yerince yapılan fazıl ve kerem sahibi,',
      latin: 'Yâ Ze’l-fadli’r-raşîd',
      no: 3,
    },
    {
      arab: 'يَا ذَا الْبَطْشِ الشَّدِيدِ',
      meal: 'Ey kıskıvrak yakalayan şiddetli azap sahibi,',
      latin: 'Yâ Ze’l-batşi’ş-şedîd',
      no: 4,
    },
    {
      arab: 'يَا ذَا الْوَعْدِ وَ الْوَعِيدِ',
      meal: 'Ey vaad ve tehdit sahibi,',
      latin: 'Yâ Ze’l-va’di ve’l-va’îd',
      no: 5,
    },
    {
      arab: 'يَا قَرِيبًا غَيْرَ بَعِيدٍ',
      meal: 'Ey uzak olmayan yakın,',
      latin: 'Yâ Karîben gayra ba’îd',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ الْوَلِىُّ الْحَمِيدُ',
      meal: 'Ey en fazla övgüye lâyık olan dost,',
      latin: 'Yâ Men hüve’l-veliyyü’l-hamîd',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ عَلٰى كُلِّ شَىْءٍ شَهِيدٌ',
      meal: 'Ey her şeyi müşahedesi altında tutan,',
      latin: 'Yâ Men hüve ‘alâ külli şey’in şehîd',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ لَيْسَ بِظَلَّا مٍ لِلْعَبِيدِ',
      meal: 'Ey kullarına hiçbir şekilde zulmedici olmayan,',
      latin: 'Yâ Men hüve leyse bizallâmîn li’l-‘abîd',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ اَقْرَبُ اِلَيْهِ مِنْ حَبْلِ الْوَرِيدِ',
      meal: 'Ey kuluna şah damarından daha yakın olan,',
      latin: 'Yâ men hüve akrabü ileyhi min habli’l-verîd',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '78': [
    {
      arab: 'يَا مَنْ لَا شَرِيكَ لَهُ وَ لَا وَزِيرَ',
      meal: 'Ey hiçbir ortak ve veziri olmayan,',
      latin: 'Yâ Men lâ şerîke lehû velâ vezîr',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا شَبِيهَ لَهُ وَ لَا نَظِيرَ',
      meal: 'Ey hiçbir benzeri ve dengi olmayan,',
      latin: 'Yâ Men lâ şebîhe lehû velâ nezîr',
      no: 2,
    },
    {
      arab: 'يَا خَالِقَ الشَّمْسِ وَ الْقَمَرِ الْمُنِيرِ',
      meal: 'Ey güneş ve nurlu ayın yaratıcısı,',
      latin: 'Yâ Hâlika’ş-şemsi ve’l-kameri’l-münîr',
      no: 3,
    },
    {
      arab: 'يَا مُغْنِىَ الْبَٓائِسِ الْفَقِيرِ',
      meal: 'Ey şiddetli sıkıntıya düşmüş fakirleri zenginleştiren,',
      latin: 'Yâ Muğniye’l-bâisi’l-fakîr',
      no: 4,
    },
    {
      arab: 'يَا رَازِقَ الطِّفْلِ الصَّغِيرِ',
      meal: 'Ey küçük yavrulara rızık veren,',
      latin: 'Yâ Râzika’t-tıfli’s-sağîr',
      no: 5,
    },
    {
      arab: 'يَا رَاحِمَ الشَّيْخِ الْكَبِيرِ',
      meal: 'Ey düşkün ihtiyarlara merhamet eden,',
      latin: 'Yâ Râhime’ş-şeyhi’l-kebir',
      no: 6,
    },
    {
      arab: 'يَا عِصْمَةَ الْخَٓائِفِ الْمُسْتَجِيرِ',
      meal: 'Ey korku içinde kurtuluş isteyenlerin sığınağı,',
      latin: 'Yâ ‘Ismete’l-hâifi’l-müstecîr',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ بِعِبَادِهِ بَصِيرٌ',
      meal: 'Ey kullarının her halini gören,',
      latin: 'Yâ Men hüve bi’ibâdihî basîr',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ بِحَوَايِجِ الْعِبَادِ خَبِيرٌ',
      meal: 'Ey kullarının ihtiyaçlarından haberdar olan,',
      latin: 'Yâ Men hüve bihavâyici’l-‘ibâdi habîr',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ عَلٰى كُلِّ شَىْءٍ قَدِيرٌ',
      meal: 'Ey her şeye gücü yeten,',
      latin: 'Yâ Men hüve ‘alâ külli şey’in kadîr',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '79': [
    {
      arab: 'يَا ذَا الْجُودِ وَ النِّعَمِ',
      meal: 'Ey cömertlik ve nimetler sahibi,',
      latin: 'Yâ Ze’l-cûdi ve’n-ni’âm',
      no: 1,
    },
    {
      arab: 'يَا ذَا الْفَضْلِ وَ الْكَرَمِ',
      meal: 'Ey fazıl ve kerem sahibi,',
      latin: 'Yâ Ze’l-fadli ve’l-keram',
      no: 2,
    },
    {
      arab: 'يَا ذَا الْبَاْسِ وَ النِّقَمِ',
      meal: 'Ey şiddetli belâ ve çetin azaplar sahibi,',
      latin: 'Yâ Ze’l-be’si ve’n-nikam',
      no: 3,
    },
    {
      arab: 'يَا خَالِقَ اللَّوْحِ وَ الْقَلَمِ',
      meal: 'Ey Levh-i Mahfûz ve Kalemi yaratan,',
      latin: 'Yâ Hâlika’l-levhi ve’l-kalem',
      no: 4,
    },
    {
      arab: 'يَا بَارِئَ الذَّرِّ وَ النَّسَمِ',
      latin: 'Yâ Bârie’z-zerri ve’n-nesem',
      meal: 'Ey zerreyi, hoş rüzgârları ve nefesleri yaratan,',
      no: 5,
    },
    {
      arab: 'يَا مُلْهِمَ الْعَرَبِ وَ الْعَجَمِ',
      meal: 'Ey bütün kullarına ilhamda bulunan,',
      latin: 'Yâ Mulhime’l-‘arabi ve’l-‘acem',
      no: 6,
    },
    {
      arab: 'يَا كَاشِفَ الضُّرِّ وَ الْاَلَمِ',
      meal: 'Ey zarar ve elemi gideren,',
      latin: 'Yâ Kâşife’drdurri ve’l-elem',
      no: 7,
    },
    {
      arab: 'يَا عَالِمَ السِّرِّ وَ الْهِمَمِ',
      meal: 'Ey gizli sır ve kaygıları bilen,',
      latin: 'Yâ ‘Alime’s-sirri ve’l-himem',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَهُ الْبَيْتُ وَ الْحَرَمُ',
      meal: 'Ey Kâbe-i Muazzama ve Harem-i Şerîfin sahibi,',
      latin: 'Yâ Men lehü’l-beytü ve’l-haram',
      no: 9,
    },
    {
      arab: 'يَا مَنْ يَخْلُقُ الْاَشْيَٓاءَ مِنَ الْعَدَمِ',
      meal: 'Ey eşyayı yoktan yaratan,',
      latin: 'Yâ Men yahlüku’l-eşyâe mine’l-‘adem',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٧٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '80': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا عَادِلُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey gerçek adalet sahibi Âdil,',
      latin: 'Ve es’elüke biesmâike Yâ ‘Adil',
      no: 1,
    },
    {
      arab: 'يَا قَابِلُ',
      meal: 'Ey rızâsı için yapılan işleri kabul eden Kâbil,',
      latin: 'Yâ Kabil',
      no: 2,
    },
    {
      arab: 'يَا فَاضِلُ',
      meal: 'Ey her şeyden üstün ve yüce olan Fâdıl,',
      latin: 'Yâ Fâdil',
      no: 3,
    },
    {
      arab: 'يَا فَاعِلُ',
      meal: 'Ey her işin hakiki yapıcısı olan Fâil,',
      latin: 'YâFâ’il',
      no: 4,
    },
    {
      arab: 'يَا كَافِلُ',
      meal: 'Ey yaratıkların her işini üzerine alan Kâfil,',
      latin: 'Yâ Kâfıl',
      no: 5,
    },
    {
      arab: 'يَا جَاعِلُ',
      meal: 'Ey her şeyi meydana getiren Câil,',
      latin: 'Yâ Câ’il',
      no: 6,
    },
    {
      arab: 'يَا كَامِلُ',
      meal: 'Ey her bakımdan eksiksiz olan Kâmil,',
      latin: 'Yâ Kâmil',
      no: 7,
    },
    {
      arab: 'يَا فَاطِرُ',
      meal: 'Ey mahlûkatı yokluk karanlıklarından varlık nûruna çıkaran Fâtır,',
      latin: 'Yâ Fâtır',
      no: 8,
    },
    {
      arab: 'يَا طَالِبُ',
      meal: 'Ey kulları için hayır murat eden ve onları dergâhına çağıran Tâlib,',
      latin: 'Yâ Tâlib',
      no: 9,
    },
    {
      arab: 'يَا مَطْلُوبُ',
      meal: 'Ey kullarının, rızasına ermek ve cemalini görmek için can attığı Matlûb,',
      latin: 'Yâ Matlûb',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '81': [
    {
      arab: 'يَا مَنْ اَنْعَمَ بِحَوْلِهِ',
      meal: 'Ey güç ve havliyle nimet veren,',
      latin: 'Yâ Men en’ame bihavlih',
      no: 1,
    },
    {
      arab: 'يَا مَنْ اَكْرَمَ بِطَوْلِهِ',
      meal: 'Ey geniş ve bol imkânlarıyla ikram eden,',
      latin: 'Yâ Men ekrame bitavlih',
      no: 2,
    },
    {
      arab: 'يَا مَنْ عَادَ بِلُطْفِهِ',
      meal: 'Ey tekrar tekrar lütufta bulunan,',
      latin: 'Yâ Men ‘âde bilütfıh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ تَعَزَّزَ بِقُدْرَتِهِ',
      meal: 'Ey kudretiyle her yerde izzetini gösteren,',
      latin: 'Yâ Men te’azzeze bikudratih',
      no: 4,
    },
    {
      arab: 'يَا مَنْ قَدَّرَ بِحِكْمَتِهِ',
      meal: 'Ey her şeyi hikmetiyle ölçüp biçen,',
      latin: 'Yâ Men kaddera bihikmetih',
      no: 5,
    },
    {
      arab: 'يَا مَنْ حَكَمَ بِتَدْبِيرِهِ',
      meal: 'Ey tedbîriyle hükmeden,',
      latin: 'Yâ Men hakeme bitedbîrih',
      no: 6,
    },
    {
      arab: 'يَا مَنْ دَبَّرَ بِعِلْمِهِ',
      meal: 'Ey ilmiyle her şeyi idare eden,',
      latin: 'Yâ Men debbera bi’ilmih',
      no: 7,
    },
    {
      arab: 'يَا مَنْ تَجَاوَزَ بِحِلْمِهِ',
      meal: 'Ey hilim ve yumuşaklığıyla kullarını cezalandırmaktan vazgeçen,',
      latin: 'Yâ Men tecâveze bihılmih',
      no: 8,
    },
    {
      arab: 'يَا مَنْ دَنَا فِى عُلُوِّهِ',
      meal: 'Ey yüceliğiyle beraber kullarına yakın olan,',
      latin: 'Yâ Men denâ fî ‘ulüvvih',
      no: 9,
    },
    {
      arab: 'يَا مَنْ عَلاٰ فِى دُنُوِّهِ',
      meal: 'Ey yakınlığında yüceliği tezâhür eden,',
      latin: 'Yâ Men ‘alâ fî dünüvvih',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '82': [
    {
      arab: 'يَا مَنْ يَخْلُقُ مَا يَشَٓاءُ',
      meal: 'Ey dilediğini yaratan,',
      latin: 'Yâ Men yahlüku ma yeşâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ يَفْعَلُ مَا يَشَٓاءُ',
      meal: 'Ey dilediğini yapan,',
      latin: 'Yâ Men yef’alü ma yeşâ',
      no: 2,
    },
    {
      arab: 'يَا مَنْ يَهْدِى مَنْ يَشَٓاءُ',
      meal: 'Ey dilediğine hidayet eden,',
      latin: 'Yâ Men yehdi men yeşâ',
      no: 3,
    },
    {
      arab: 'يَا مَنْ يُضِلُّ مَنْ يَشَٓاءُ',
      meal: 'Ey dilediğini saptıran,',
      latin: 'Yâ Men yudillü men yeşâ',
      no: 4,
    },
    {
      arab: 'يَا مَنْ يَغْفِرُ لِمَنْ يَشَٓاءُ',
      meal: 'Ey dilediğini bağışlayan,',
      latin: 'Yâ Men yağfiru limen yeşâ',
      no: 5,
    },
    {
      arab: 'يَا مَنْ يُعَذِّبُ مَنْ يَشَٓاءُ',
      meal: 'Ey dilediğine azap eden,',
      latin: 'Yâ Men yü’azzibü men yeşâ',
      no: 6,
    },
    {
      arab: 'يَا مَنْ يَتُوبُ عَلٰى مَنْ يَشَٓاءُ',
      meal: 'Ey dilediğinin tövbesini kabul eden,',
      latin: 'Ya Men yetûbü alâ men yeşâ',
      no: 7,
    },
    {
      arab: 'يَا مَنْ يُصَوِّرُ فِى الْاَرْحَامِ كَيْفَ يَشَٓاءُ',
      meal: 'Ey anne rahimlerindeki yavruları dilediği gibi şekillendiren,',
      latin: 'Yâ Men yüsavviru fı’l-erhâmi keyfe yeşâ',
      no: 8,
    },
    {
      arab: 'يَا مَنْ يَزِيدُ فِى الْخَلْقِ مَا يَشَٓاءُ',
      meal: 'Ey yaratıklarında dilediği şeyi ziyade kılan,',
      latin: 'Yâ Men yezîdü fi’l-halki mâ yeşâ',
      no: 9,
    },
    {
      arab: 'يَا مَنْ يَخْتَصُّ بِرَحْمَتِهِ مَنْ يَشَٓاءُ',
      meal: 'Ey rahmetini dilediğine tahsis eden,',
      latin: 'Yâ Men yahtassu bi rahmetihî men yeşâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '83': [
    {
      arab: 'يَا مَنْ لَمْ يَتَّخِذْ صَاحِبَةً وَ لَا وَلَدًا',
      meal: 'Ey hiçbir eş ve evlat edinmeyen,',
      latin: 'Yâ Men lem yettehiz sahibeten velâ veledâ',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا يُشْرِكُ فِى حُكْمِهِٓ اَحَدًا',
      meal: 'Ey kimseyi hükmüne ortak kılmayan,',
      latin: 'Yâ Men la yüşrikü fî hukmihî ehadâ',
      no: 2,
    },
    {
      arab: 'يَا مَنْ جَعَلَ لِكُلِّ شَىْءٍ قَدْرًا',
      meal: 'Ey her şeye bir plan ve miktar tayin eden,',
      latin: 'Yâ Men ce’ale li külli şey’in kadrâ',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَمْ يَزَلْ رَحِيمًا',
      meal: 'Ey şefkat ve merhameti zeval bulmayıp devam eden,',
      latin: 'Yâ Men lem yezel rahîmâ',
      no: 4,
    },
    {
      arab: 'يَا مَنْ جَاعِلَ الْمَلٰٓئِكَةِ رُسُلاً',
      meal: 'Ey melekleri elçi kılan,',
      latin: 'Yâ Câ’ile’l-melâiketi rusülâ',
      no: 5,
    },
    {
      arab: 'يَا مَنْ جَعَلَ فِى السَّمَٓاءِ بُرُوجًا',
      meal: 'Ey semâda burçlar meydana getiren,',
      latin: 'Yâ Men ce’ale fı’s-semâi bürûcâ',
      no: 6,
    },
    {
      arab: 'يَا مَنْ جَعَلَ الْاَرْضَ قَرَارًا',
      meal: 'Ey yeryüzünü kararlı ve barınmaya müsait kılan,',
      latin: 'Yâ Men ce’ale’l-arda karâra',
      no: 7,
    },
    {
      arab: 'يَا مَنْ جَعَلَ مِنَ الْمَٓاءِ بَشَرًا',
      meal: 'Ey insanı bir damla sudan yaratan,',
      latin: 'Yâ Men ce’ale mine’l-mâi beşerâ',
      no: 8,
    },
    {
      arab: 'يَا مَنْ اَحْصٰى كُلَّ شَىْءٍ عَدَدًا',
      meal: 'Ey her şeyi sayarak hesabını yapan,',
      latin: 'Yâ Men ahsa külle şey’in ‘adedâ',
      no: 9,
    },
    {
      arab: 'يَا مَنْ اَحَاطَ بِكُلِّ شَىْءٍ عِلْمًا',
      meal: 'Ey her şeyi ilmiyle kuşatan,',
      latin: 'Yâ Men ehâta bi külli şey’in ‘ilmâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '84': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا فَرْدُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey eşi ve benzeri olmayan Ferd,',
      latin: 'Ve es’elüke biesmâike Yâ Ferd',
      no: 1,
    },
    {
      arab: 'يَا وِتْرُ',
      meal: 'Ey zât, sıfat ve fiillerinde çifti olmayan Vitr,',
      latin: 'Yâ Vitr',
      no: 2,
    },
    {
      arab: 'يَٓا اَحَدُ',
      meal: 'Ey her bir şeyde birliğini gösteren Ehad,',
      latin: 'Yâ Ehad',
      no: 3,
    },
    {
      arab: 'يَا صَمَدُ',
      meal: 'Ey hiçbir şeye muhtaç olmayan ve her şeyin kendisine muhtaç olduğu Samed,',
      latin: 'Yâ Samed',
      no: 4,
    },
    {
      arab: 'يَٓا اَمْجَدُ',
      meal: 'Ey şan, şeref ve yüceliği en büyük olan Emced,',
      latin: 'Yâ Emced',
      no: 5,
    },
    {
      arab: 'يَٓا اَعَزُّ',
      meal: 'Ey izzet ve galibiyeti mukayeseye gelmeyen Eazz,',
      latin: 'Yâ E’azz',
      no: 6,
    },
    {
      arab: 'يَٓا اَجَلُّ',
      meal: 'Ey sonsuz azamet ve celâl sahibi Ecell,',
      latin: 'Yâ Eceli',
      no: 7,
    },
    {
      arab: 'يَٓا اَحَقُّ',
      meal: 'Ey bütün gerçeklerden daha gerçek ve ibâdete en çok lâyık olan Ehakk,',
      latin: 'Yâ Ehakk',
      no: 8,
    },
    {
      arab: 'يَٓا اَبَرُّ',
      meal: 'Ey herkesten fazla iyilik yapan Eberr,',
      latin: 'Yâ Eberr',
      no: 9,
    },
    {
      arab: 'يَٓا اَبَدُ',
      meal: 'Ey varlığının sonu olmayan Ebed,',
      latin: 'Yâ Ebed',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-nel-emâne neccinâ mine’n-nâr.',
    },
  ],
  '85': [
    {
      arab: 'يَا مَعْرُوفَ مَنْ عَرَفَهُ',
      meal: 'Ey Kendisini tanımak isteyenlerin mârufu,',
      latin: 'Yâ Ma’rûfe men ‘arafeh',
      no: 1,
    },
    {
      arab: 'يَا مَعْبُودَ مَنْ عَبَدَهُ',
      meal: 'Ey Kendisine ibâdet edenlerin mâbudu,',
      latin: 'Yâ Ma’bûde men ‘abedeh',
      no: 2,
    },
    {
      arab: 'يَا مَشْكُورَ مَنْ شَكَرَهُ',
      meal: 'Ey Kendisine şükredenlerin meşkûru,',
      latin: 'Yâ Meşkûre men şekerah',
      no: 3,
    },
    {
      arab: 'يَا مَذْكُورَ مَنْ ذَكَرَهُ',
      meal: 'Ey Kendisini zikredenlerin mezkûru,',
      latin: 'Yâ Mezkûre men zekerah',
      no: 4,
    },
    {
      arab: 'يَا مَحْمُودَ مَنْ حَمِدَهُ',
      meal: 'Ey Kendisini övenlerin mahmûdu,',
      latin: '5Yâ Mahmude men hamideh',
      no: 5,
    },
    {
      arab: 'يَا مَوْجُودَ مَنْ طَلَبَهُ',
      meal: 'Ey Kendisini arayanlar için mevcut olan,',
      latin: 'Yâ Mevcûde men talebeh',
      no: 6,
    },
    {
      arab: 'يَا مَوْصُوفَ مَنْ وَحَّدَهُ',
      meal: 'Ey Kendisini bir tanıyanların mevsûfu,',
      latin: 'Yâ Mevsûfe men vahhadeh',
      no: 7,
    },
    {
      arab: 'يَا مَحْبُوبَ مَنْ اَحَبَّهُ',
      meal: 'Ey Kendisini sevenlerin sevgilisi,',
      latin: '8Yâ Mahbûbe men ehabbeh',
      no: 8,
    },
    {
      arab: 'يَا مَرْغُوبَ مَنْ اَرَادَهُ',
      meal: 'Ey Kendisini arzulayanların merğubu,',
      latin: 'Yâ Merğûbe men erâdeh',
      no: 9,
    },
    {
      arab: 'يَا مَقْصُودَ مَنْ اَنَابَ اِلَيْهِ',
      meal: 'Ey dergâhına dönenlerin maksudu,',
      latin: 'Yâ Maksûde men enâbe ileyh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '86': [
    {
      arab: 'يَا مَنْ لَا مُلْكَ اِلَّا مُلْكَهُ',
      meal: 'Ey saltanatından başka gerçek saltanat olmayan,',
      latin: 'Yâ Men lâ mülke illâ mülküh',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا يُحْصِى الْعِبَادُ ثَنَٓائَهُ',
      meal: 'Ey kulların senâsını saymakla bitiremediği,',
      latin: 'Yâ Men lâ yuhsi’l-‘ibadü senaeh',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا تَصِفُ الْخَلَٓائِقُ جَلَالَهُ',
      meal: 'Ey mahlûkatın celâlini vasfedemediği,',
      latin: 'Yâ Men lâ tesıfü’l-halâiku celâleh',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يُدْرِكُ الْاَبْصَارُ كَمَالَهُ',
      meal: 'Ey gözlerin kemâlini idrak ve ihâta edemediği,',
      latin: 'Yâ Men lâ yudrikü’l-ebsâru kemâleh',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا يَبْلُغُ الْاَفْهَامُ صِفَاتَهُ',
      meal: 'Ey zekâların sıfatlarına ulaşmakta acze düştüğü,',
      latin: 'Yâ Men lâ yeblüğu’l-efhâmü sıfâtih',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا يَنَالُ الْاَفْكَارُ كِبْرِيَٓائَهُ',
      meal: 'Ey fikirlerin, kibriyasının hakikatine ulaşamadığı,',
      latin: 'Yâ Men lâ yenâlü’l-efkâru kibriyâeh',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَا يُحْسِنُ اْلاِنْسَانُ نُعُوتَهُ',
      meal: 'Ey insanların, sıfatlarını güzelce tavsif edemediği,',
      latin: 'Yâ Men lâ yuhsinü’l-insânü nü’ûteh',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَا يَرُدُّ الْعِبَادُ قَضَٓائَهُ',
      meal: 'Ey kulların, hükmünü geri çeviremediği,',
      latin: 'Yâ Men lâ yeruddü’l-‘ibâdü kadâeh',
      no: 8,
    },
    {
      arab: 'يَا مَنْ ظَهَرَ فِى كُلِّ شَىْءٍ اٰيَاتُهُ',
      meal: 'Ey her şeyde Kendisini tanıtan deliller açıkça görülen,',
      latin: 'Yâ Men zahera fî külli şey’in âyâtüh',
      no: 9,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
      no: 10,
    },
  ],
  '87': [
    {
      arab: 'يَا حَبِيبَ الْبَكَّٓائِينَ',
      meal: 'Ey günahları için ve kendisine olan aşk ve muhabbetten dolayı ağlayanların sevgilisi,',
      latin: 'Yâ Habîbe’l-bekkâîn',
      no: 1,
    },
    {
      arab: 'يَا سَنَدَ الْمُتَوَكِّلِينَ',
      meal: 'Ey kendisine tevekkül edenlerin dayanağı,',
      latin: 'Yâ Senede’l-mütevekkilîn',
      no: 2,
    },
    {
      arab: 'يَا هَادِىَ الْمُضِلِّينَ',
      meal: 'Ey hak yoldan sapanları hidayete erdiren,',
      latin: 'Yâ Hâdiye’l-mudillîn',
      no: 3,
    },
    {
      arab: 'يَا وَلِىَّ الْمُؤْمِنِينَ',
      meal: 'Ey müminlerin dost ve sahibi,',
      latin: 'Yâ Veliyye’l-mü’minîn',
      no: 4,
    },
    {
      arab: 'يَٓا اَنِيسَ الذَّاكِرِينَ',
      meal: 'Ey kendisini zikredenlerin can yoldaşı,',
      latin: 'Yâ Enîse’s-zâkirîn',
      no: 5,
    },
    {
      arab: 'يَٓا اَقْدَرَ الْقَادِرِينَ',
      meal: 'Ey bütün güçlülerden daha güçlü,',
      latin: 'Yâ Akdera’l-kâdirîn',
      no: 6,
    },
    {
      arab: 'يَٓا اَبْصَرَ النَّاظِرِينَ',
      meal: 'Ey bütün bakanlardan daha iyi gören,',
      latin: 'Yâ Ebsara’n-nâzırîn',
      no: 7,
    },
    {
      arab: 'يَٓا اَعْلَمَ الْعَالِمِينَ',
      meal: 'Ey bütün ilim sahiplerinden daha âlim,',
      latin: 'Yâ Aleme’l-‘âlimîn',
      no: 8,
    },
    {
      arab: 'يَا مَفْزَعَ الْمَلْهُوفِينَ',
      meal: 'Ey kederli bîçarelerin kaçıp sığındığı,',
      latin: 'Yâ Mefze’a’l-melhûfîn',
      no: 9,
    },
    {
      arab: 'يَٓا اَنْصَرَ النَّاصِرِينَ',
      meal: 'Ey bütün yardım edenlerden daha çok yardım eden,',
      latin: 'Yâ Ensara’n-nâsirîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr',
    },
  ],
  '88': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُكْرِمُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey gerçek ikram sahibi Mükrim,',
      latin: 'Ve es’elüke biesmâike Yâ Mukrim',
      no: 1,
    },
    {
      arab: 'يَا مُعَظِّمُ',
      meal: 'Ey dilediğini büyüten ve eserleriyle büyüklüğünü gösteren Muazzım,',
      latin: 'Yâ Mu’azzim',
      no: 2,
    },
    {
      arab: 'يَا مُنَعِّمُ',
      meal: 'Ey mahlûkatını çeşit çeşit nimetlere gark eden Müna’ım,',
      latin: 'Yâ Muna’im',
      no: 3,
    },
    {
      arab: 'يَا مُعْطِى',
      meal: 'Ey mahlûkatına lâzım olan her şeyi veren Mu’ti,',
      latin: '4Ya Mü’tî',
      no: 4,
    },
    {
      arab: 'يَا مُغْنِى',
      meal: 'Ey mahlûkatının ihtiyacını giderip zengin kılan Muğnî,',
      latin: 'Yâ Muğnî',
      no: 5,
    },
    {
      arab: 'يَا مُحْيِى',
      meal: 'Ey canlılara hayat veren Muhyî,',
      latin: 'Yâ Muhyî',
      no: 6,
    },
    {
      arab: 'يَا مُبْدِىُٔ',
      meal: 'Ey mahlûkatı maddesiz ve örneksiz ilk defa yaratan Mübdî,',
      latin: 'Yâ Mubdî',
      no: 7,
    },
    {
      arab: 'يَا مُرْضِى',
      meal: 'Ey mahlûkatını nimetleriyle hoşnut kılan Murzî,',
      latin: 'Yâ Murdî',
      no: 8,
    },
    {
      arab: 'يَا مُنْجِى',
      meal: 'Ey mahlûkatı her türlü tehlikeden kurtaran Müncî,',
      latin: 'Yâ Muncî',
      no: 9,
    },
    {
      arab: 'يَا مُحْسِنُ',
      meal: 'Ey bol bol iyilikte bulunan Muhsîn,',
      latin: 'Yâ Muhsin',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr',
    },
  ],
  '89': [
    {
      arab: 'يَا كَافِىَ كُلِّ شَىْءٍ',
      meal: 'Ey her şeye kâfi,',
      latin: 'Yâ Kâfiye külli şey',
      no: 1,
    },
    {
      arab: 'يَا قَٓائِمًا عَلٰى كُلِّ شَىْءٍ',
      meal: 'Ey her şeyi idare eden kaim,',
      latin: 'Yâ Kaimen ‘alâ külli şey',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا يُشْبِهُهُ شَىْءٌ',
      meal: 'Ey hiçbir şey Kendisine benzemeyen,',
      latin: 'Yâ Men lâ yuşbihühû şey',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يَزِيدُ فِى مُلْكِهِ شَىْءٌ',
      meal: 'Ey mülkünde, irâdesi dışında hiçbir şey artmayan,',
      latin: 'Yâ Men lâ yezîdü fî mülkihî şey',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا يَنْقُصُ مِنْ خَزَٓائِنِهِ شَىْءٌ',
      meal: 'Ey hazînelerinden hiçbir şey eksik olmayan,',
      latin: 'Yâ Men lâ yenkusu min hazainihî şey',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا يَخْفٰى عَلَيْهِ شَىْءٌ',
      meal: 'Ey hiçbir şey Kendisine gizli bulunmayan,',
      latin: 'Yâ Men lâ yahfâ ‘aleyhi şey',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَيْسَ كَمِثْلِهِ شَىْءٌ',
      meal: 'Ey misli ve benzeri hiçbir şey bulunmayan,',
      latin: 'Yâ Men leyse kemişlihî şey',
      no: 7,
    },
    {
      arab: 'يَا مَنْ بِيَدِهِ مَقَالِيدُ كُلِّ شَىْءٍ',
      meal: 'Ey her şeyin anahtarı elinde olan,',
      latin: 'Yâ Men biyedihî mekâlîdü külli şey',
      no: 8,
    },
    {
      arab: 'يَا مَنْ وَسِعَتْ رَحْمَتُهُ كُلَّ شَىْءٍ',
      meal: 'Ey rahmeti her şeyi kuşatan,',
      latin: 'Yâ Men vesi’at rahmetühû külle şey',
      no: 9,
    },
    {
      arab: 'يَا مَنْ يَبْقٰى وَ يَفْنٰى كُلُّ شَىْءٍ',
      meal: 'Ey her şey fâni olduğu halde Kendisi bâkî kalan,',
      latin: 'Yâ Men yebkâ ve yefnâ küllü şey',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ نَجِّنَا مِنَ النَّارِ ﴿٨٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '90': [
    {
      arab: 'يَا مَنْ لَا يَعْلَمُ الْغَيْبَ اِلَّا هُوَ',
      meal: 'Ey gaybı Kendisinden başka kimse bilemeyen,',
      latin: 'Yâ Men lâ ya’lemü’l-ğaybe illâ hû',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا يَصْرِفُ السُّٓوءَ اِلَّا هُوَ',
      meal: 'Ey kullarından kötülüğü Kendisinden başka kimse defedemeyen,',
      latin: 'Yâ Men lâ yasrifü’s-sûe illâ hû',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا يُدَبِّرُ الْاَمْرَ اِلَّا هُوَ',
      meal: 'Ey işleri Kendisinden başka kimse idâre edemeyen,',
      latin: 'Yâ Men lâ yudebbiru’l-emra illâ hû',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يَغْفِرُ الذُّنُوبَ اِلَّا هُوَ',
      meal: 'Ey günahları Kendisinden başka kimse mağfiret edemeyen,',
      latin: 'Yâ Men lâ yağfiru’z-zünûbe illâ hû',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا يُقَلِّبُ الْقَلْبَ اِلَّا هُوَ',
      meal: 'Ey kalpleri Kendisinden başkası değiştiremeyen,',
      latin: 'Yâ Men lâ yukallibü’l-kalbe illâ hû',
      no: 5,
    },
    {
      arab: 'يَا مَنْ لَا يَخْلُقُ الْخَلْقَ اِلَّا هُوَ',
      meal: 'Ey mahlûkatı Kendisinden başkası yaratamayan,',
      latin: 'Yâ Men lâ yahlüku’l-halka illâ hû',
      no: 6,
    },
    {
      arab: 'يَا مَنْ لَا يُتِمُّ النِّعْمَةَ اِلَّا هُوَ',
      meal: 'Ey nîmetleri Kendisinden başkası tamamlayamayan,',
      latin: 'Yâ Men lâ yutimmü’n-ni’mete illâ hû',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَا يُنَزِّلُ الْغَيْثَ اِلَّا هُوَ',
      meal: 'Ey yağmuru Kendisinden başkası yağdıramayan,',
      latin: 'Yâ Men lâ yunezzilü’l-ğayşe illâ hû',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَا يُحْيِى الْمَوْتٰى اِلَّا هُوَ',
      meal: 'Ey ölüleri kendisinden başkası diriltemeyen,',
      latin: 'Yâ Men lâ yuhyi’l-mevtâ illâ hû',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَا يُغْنِى عَلَى التَّحْقِيقِ اِلَّا هُوَ',
      meal: 'Ey kullarını kendisinden başkası gerçek zengin kılamayan,',
      latin: 'Yâ Men lâ yuğni ‘ale’t-tahkîki illâ hû',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩۰﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne neccinâ mine’n-nâr.',
    },
  ],
  '91': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا كَاشِفُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey belâları kaldıran ve güzellikleri açığa çıkaran Kâşif,',
      latin: 'Ve es’elüke biesmâike Yâ Kâşif',
      no: 1,
    },
    {
      arab: 'يَا فَارِجُ',
      meal: 'Ey keder ve tasadan kurtarıp ferahlatan Fâric,',
      latin: 'Yâ Fâric',
      no: 2,
    },
    {
      arab: 'يَا فَاتِحُ',
      meal: 'Ey her mevcuda münâsip bir sûret açan ve fetihler müyesser kılan Fâtih,',
      latin: 'Yâ Fâtih',
      no: 3,
    },
    {
      arab: 'يَا نَاصِرُ',
      meal: 'Ey kullarına yardım eden Nâsır,',
      latin: 'Yâ Nâsir',
      no: 4,
    },
    {
      arab: 'يَا ضَامِنُ',
      meal: 'Ey yaratıkların her türlü ihtiyacını üzerine alan Dâmin,',
      latin: 'Yâ Dâmin',
      no: 5,
    },
    {
      arab: 'يَٓا اٰمِرُ',
      meal: 'Ey her şeye fıtratının gayesini emreden Âmir,',
      latin: 'Yâ Âmir',
      no: 6,
    },
    {
      arab: 'يَا نَاهِى',
      meal: 'Ey her türlü kötülükten sakındıran Nâhî,',
      latin: 'Yâ Nâhî',
      no: 7,
    },
    {
      arab: 'يَا رَجَا',
      meal: 'Ey kullarının ümidi olan Recâ,',
      latin: 'Yâ Racâ',
      no: 8,
    },
    {
      arab: 'يَا مُرْتَجَا',
      meal: 'Ey kullarının ümit beslediği Mürtecâ,',
      latin: 'Yâ Murtecâ',
      no: 9,
    },
    {
      arab: 'يَا عَظِيمَ الرَّجَا',
      meal: 'Ey kendisine büyük ümitler beslenen Azîmür-Recâ,',
      latin: 'Yâ ‘Azîme’r-racâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩١﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '92': [
    {
      arab: 'يَا مُعِينَ الضُّعَفَٓاءِ',
      meal: 'Ey zayıfların yardımcısı,',
      latin: 'Yâ Mu’îne’d-du’afâ',
      no: 1,
    },
    {
      arab: 'يَا كَنْزَ الْفُقَرَٓاءِ',
      meal: 'Ey fakirlerin hazînesi,',
      latin: 'Yâ Kenze’l-fukarâ',
      no: 2,
    },
    {
      arab: 'يَا صَاحِبَ الْغُرَبَٓاءِ',
      meal: 'Ey gariplerin sahibi,',
      latin: 'Yâ Sâhibe’l-ğurabâ',
      no: 3,
    },
    {
      arab: 'يَا نَاصِرَ الْاَوْلِيَٓاءِ',
      meal: 'Ey dostların yardımcısı,',
      latin: 'Yâ Nâsira’l-evliyâ',
      no: 4,
    },
    {
      arab: 'يَا قَاهِرَ الْاَعْدَٓاءِ',
      meal: 'Ey düşmanların kahredicisi,',
      latin: 'Yâ Kâhira’l-a’dâ',
      no: 5,
    },
    {
      arab: 'يَا رَافِعَ السَّمَٓاءِ',
      meal: 'Ey gökleri yükselten,',
      latin: 'Yâ Râfia’s-semâ',
      no: 6,
    },
    {
      arab: 'يَا كَاشِفَ الْبَلَٓاءِ',
      meal: 'Ey belâları kaldıran,',
      latin: 'Yâ Kâşife’l-belâ',
      no: 7,
    },
    {
      arab: 'يَٓا اَنِيسَ الْاَوْلِيَٓاءِ',
      meal: 'Ey dostların can yoldaşı,',
      latin: 'Yâ Enîse’l-evliyâ',
      no: 8,
    },
    {
      arab: 'يَا حَبِيبَ الْاَتْقِيَٓاءِ',
      meal: 'Ey takvâ sahiplerinin sevgilisi,',
      latin: 'Yâ Habîbe’l-etkıyâ',
      no: 9,
    },
    {
      arab: 'يَٓا اِلٰهَ الْاَغْنِيَٓاءِ',
      meal: 'Ey zenginlerin mabudu,',
      latin: 'Yâ İlâhe’l-ağniyâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٢﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '93': [
    {
      arab: 'يَٓا اَوَّلَ كُلِّ شَىْءٍ وَ اٰخِرَهُ',
      meal: 'Ey her şeyin evveli ve âhiri,',
      latin: 'Yâ Evvele külli şey’in ve âhirah',
      no: 1,
    },
    {
      arab: 'يَٓا اِلٰهَ كُلِّ شَىْءٍ وَ صَانِعَهُ',
      meal: 'Ey her şeyin ilâhı ve sanatkârı,',
      latin: 'Yâ İlahe külli şey’in ve sâni’ah',
      no: 2,
    },
    {
      arab: 'يَا رَازِقَ كُلِّ شَىْءٍ وَ خَالِقَهُ',
      meal: 'Ey her şeyin râzıkı ve hâlıkı,',
      latin: 'Yâ Râzika külli şey’in ve hâlikah',
      no: 3,
    },
    {
      arab: 'يَا فَاطِرَ كُلِّ شَىْءٍ وَ مَلِيكَهُ',
      meal: 'Ey her şeyin yaratıcısı ve sultânı,',
      latin: 'Yâ Fâtira külli şey’in ve melîkeh',
      no: 4,
    },
    {
      arab: 'يَا قَابِضَ كُلِّ شَىْءٍ وَ بَاسِطَهُ',
      meal: 'Ey her şeyi daraltan ve genişleten,',
      latin: 'Yâ Kâbida külli şey’in ve bâsiteh',
      no: 5,
    },
    {
      arab: 'يَا مُبْدِىَٔ كُلِّ شَىْءٍ وَ مُعِيدَهُ',
      meal: 'Ey her şeyi ilk defa yaratan ve öldükten sonra tekrar iâde eden,',
      latin: 'Yâ Mubdie külli şey’in ve nıü’îdeh',
      no: 6,
    },
    {
      arab: 'يَا مُسَبِّبَ كُلِّ شَىْءٍ وَ مُقَدِّرَهُ',
      meal: 'Ey her şeye gerekli sebepleri yaratan ve bir ölçü takdir eden,',
      latin: 'Yâ Musebbibe külli şey’in ve mükaddirah',
      no: 7,
    },
    {
      arab: 'يَا مُرَبِّىَ كُلِّ شَىْءٍ وَ مُدَبِّرَهُ',
      meal: 'Ey her şeyi terbiye ve idâre eden,',
      latin: ' Yâ Murabbiye külli şey’in ve müdebbirah',
      no: 8,
    },
    {
      arab: 'يَا مُكَوِّرَ كُلِّ شَىْءٍ وَ مُحَوِّلَهُ',
      meal: 'Ey her şeyi döndüren ve değiştiren,',
      latin: 'Yâ Mukevvira külli şey’in ve muhavvileh',
      no: 9,
    },
    {
      arab: 'يَا مُحْيِىَ كُلِّ شَىْءٍ وَ مُمِيتَهُ',
      meal: 'Ey her şeyi dirilten ve öldüren,',
      latin: 'Yâ Muhyiye külli şey’in ve mümîteh',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٣﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '94': [
    {
      arab: 'يَا خَيْرَ ذَاكِرٍ وَ مَذْكُورٍ',
      meal: 'Ey yâd edenlerin ve yâd edilenlerin en hayırlısı,',
      latin: 'Yâ Hayra zâkirîn ve mezkûr',
      no: 1,
    },
    {
      arab: 'يَا خَيْرَ شَاكِرٍ وَ مَشْكُورٍ',
      meal: 'Ey şükrü kabul edenlerin ve şükredilenlerin en hayırlısı,',
      latin: 'Yâ Hayra şâkirîn ve meşkûr',
      no: 2,
    },
    {
      arab: 'يَا خَيْرَ شَاهِدٍ وَ مَشْهُودٍ',
      meal: 'Ey övülenlerin ve övenlerin en hayırlısı,',
      latin: 'Yâ Hayra şahidin ve meşhûd',
      no: 3,
    },
    {
      arab: 'يَا خَيْرَ حَامِدٍ وَ مَحْمُودٍ',
      meal: 'Ey görenlerin ve görülenlerin en hayırlısı,',
      latin: 'Yâ Hayra hâmidin ve mahmûd',
      no: 4,
    },
    {
      arab: 'يَا خَيْرَ دَاعٍ وَ مَدْعُوٍّ',
      meal: 'Ey çağıranların ve çağrılanların en hayırlısı,',
      latin: 'Yâ Hayra dâ’in ve med’uvv',
      no: 5,
    },
    {
      arab: 'يَا خَيْرَ مُجِيبٍ وَ مُجَابٍ',
      meal: 'Ey cevap verenlerin ve cevap verilenlerin en hayırlısı,',
      latin: 'Yâ Hayra mücîbin ve mücâb',
      no: 6,
    },
    {
      arab: 'يَا خَيْرَ مُونِسٍ وَ اَنِيسٍ',
      meal: 'Ey ünsiyet verenlerin ve Kendisiyle ünsiyet edilenlerin en hayırlısı,',
      latin: 'Yâ Hayra munisin ve enîs',
      no: 7,
    },
    {
      arab: 'يَا خَيْرَ صَاحِبٍ وَ جَلِيسٍ',
      meal: 'Ey bütün dostların ve meclis arkadaşlarının en hayırlısı,',
      latin: 'Yâ Hayra sahibin ve celîs',
      no: 8,
    },
    {
      arab: 'يَا خَيْرَ مَقْصُودٍ وَ مَطْلُوبٍ',
      meal: 'Ey bütün maksut ve matlupların en hayırlısı,',
      latin: 'Yâ Hayra maksûdin ve matlûb',
      no: 9,
    },
    {
      arab: 'يَا خَيْرَ حَبِيبٍ وَ مَحْبُوبٍ',
      meal: 'Ey sevenlerin ve sevilenlerin en hayırlısı,',
      latin: 'Yâ Hayra habîbin ve mahbûb',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٤﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '95': [
    {
      arab: 'يَا مَنْ هُوَ لِمَنْ دَعَاهُ مُجِيبٌ',
      meal: 'Ey kendisini çağıranlara cevap veren,',
      latin: 'Yâ Men hüve limen de’âhü mücîb',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ لِمَنْ اَطَاعَهُ حَبِيبٌ',
      meal: 'Ey kendisine itaat edenleri seven,',
      latin: 'Yâ Men hüve limen etâ’ahû habîb',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ لِمَنْ اَحَبَّهُ قَرِيبٌ',
      meal: 'Ey kendisini sevenlere yakın olan,',
      latin: 'Yâ Men hüve limen ehabbehû karîb',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ بِمَنْ اَرَادَهُ عَلِيمٌ',
      meal: 'Ey kendisini arzulayanları çok iyi bilen,',
      latin: 'Yâ Men hüve bimen erâdehû ‘alîm',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ لِمَنْ رَجَاهُ كَرِيمٌ',
      meal: 'Ey kendisine ümit besleyenlere iyilik eden,',
      latin: 'Yâ Men hüve limen recâhü kerîm',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ بِمَنْ عَصَاهُ حَلِيمٌ',
      meal: 'Ey kendisine isyan edenlere yumuşak davranıp hemen cezalandırmayan,',
      latin: 'Yâ Men hüve bimen ‘asâhü halîm',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى حِلْمِهِ حَكِيمٌ',
      meal: 'Ey yumuşaklığında hikmetli davranan,',
      latin: 'Yâ Men hüve fî hilmihî hakîm',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى حُكْمِهِ عَظِيمٌ',
      meal: 'Ey hükmünde büyük olan,',
      latin: 'Yâ Men hüve fî hükmihî ‘azîm',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ فِى عَظَمَتِهِ رَحِيمٌ',
      meal: 'Ey azametinde merhametli olan,',
      latin: 'Yâ Men hüve fî ‘azametihî rahîm',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ فِٓى اِحْسَانِهِ قَدِيمٌ',
      meal: 'Ey ihsânında kadîm olan,',
      latin: 'Yâ Men hüve fî ihsânihî kadîm',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٥﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '96': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا مُسَبِّبُ',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey sebepleri takdir eden Müsebbib,',
      latin: 'Ve es’elüke biesmâike Yâ Musebbib',
      no: 1,
    },
    {
      arab: 'يَا مُقَرِّبُ',
      meal: 'Ey itaatkâr kullarını kendisine yaklaştıran Mukarrib,',
      latin: 'Yâ Mukarrib',
      no: 2,
    },
    {
      arab: 'يَا مُعَقِّبُ',
      meal: 'Ey eşyayı hikmetle peş peşe getiren Muakkib,',
      latin: 'Yâ Mu’akkib',
      no: 3,
    },
    {
      arab: 'يَا مُقَلِّبُ',
      meal: 'Ey kullarının kalplerini halden hale değiştiren Mukallib,',
      latin: 'Yâ Mukallib',
      no: 4,
    },
    {
      arab: 'يَا مُقَدِّرُ',
      meal: 'Ey her şeye bir miktar tespit eden Mukaddir,',
      latin: 'Yâ Mukaddir',
      no: 5,
    },
    {
      arab: 'يَا مُرَتِّبُ',
      meal: 'Ey her şeyi düzene koyan Mürettib,',
      latin: 'Yâ Murattib',
      no: 6,
    },
    {
      arab: 'يَا مُرَغِّبُ',
      meal: 'Ey kullarını iyiliğe teşvik eden Murağğib,',
      latin: 'Yâ Murağğib',
      no: 7,
    },
    {
      arab: 'يَا مُذَكِّرُ',
      meal: 'Ey kullarına öğüt veren Müzekkir,Ey kullarına öğüt veren Müzekkir,',
      latin: 'Yâ Muzekkir',
      no: 8,
    },
    {
      arab: 'يَا مُكَوِّنُ',
      meal: 'Ey mahlûkatı var eden Mükevvin,',
      latin: 'Yâ Mukevvîn',
      no: 9,
    },
    {
      arab: 'يَا مُتَكَبِّرُ',
      meal: 'Ey sonsuz büyüklük ve azamet sahibi Mütekebbir,',
      latin: 'Yâ Mutekebbir',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٦﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '97': [
    {
      arab: 'يَا مَنْ لَا يُشْغِلُهُ سَمْعٌ عَنْ سَمْعٍ',
      meal: 'Ey bir işitme, kendisini diğer bir işitmeden alıkoymayan,',
      latin: 'Yâ Men lâ yuşğilühû sem’un an sem’',
      no: 1,
    },
    {
      arab: 'يَا مَنْ لَا يَمْنَعُهُ فِعْلٌ عَنْ فِعْلٍ',
      meal: 'Ey kendisi için bir iş diğer bir işe mâni olmayan,',
      latin: 'Yâ Men lâ yemne’uhû fı’lün an fi’l',
      no: 2,
    },
    {
      arab: 'يَا مَنْ لَا يُلْهِيهِ قَوْلٌ عَنْ قَوْلٍ',
      meal: 'Ey bir söz, kendisini diğer bir sözden oyalamayan,',
      latin: 'Yâ Men lâ yulhîhi kavlün an kavi',
      no: 3,
    },
    {
      arab: 'يَا مَنْ لَا يُغَلِّطُهُ سُؤَالٌ عَنْ سُؤَالٍ',
      meal: 'Ey kullarının bir isteği diğerine cevap vermekte kendisini karışıklığa sevk etmeyen,',
      latin: 'Yâ Men lâ yuğallituhû süâlün ‘an suâl',
      no: 4,
    },
    {
      arab: 'يَا مَنْ لَا يُبْرِمُهُ اِلْحَاحُ الْمُلِحّ۪ينَ',
      meal: 'Ey ısrarla istekte bulunanların ısrarı kendisini usandırmayan,',
      latin: 'Yâ Men lâ yubrimühû ilhâhu’Umulihhîn',
      no: 5,
    },
    {
      arab: 'يَا مَنْ شَرَحَ بِاْلاِسْلَامِ صُدُورَ الْمُؤْمِنِينَ',
      meal: 'Ey müminlerin kalplerini İslâm’la genişleten,',
      latin: 'Yâ Men şeraha bi’l-islâmi sudûra’l-mü’minîn',
      no: 6,
    },
    {
      arab: 'يَا مَنْ اَطَابَ بِذِكْرِهِ قُلُوبَ الْمُخْبِتِينَ',
      meal: 'Ey zikriyle mütevâzi ve huşû sahiplerinin kalplerini hoş eden,',
      latin: 'Yâ Men etâbe bi zikrihî kulûbe’l-muhbitîn',
      no: 7,
    },
    {
      arab: 'يَا مَنْ لَا يَغِيبُ عَنْ قُلُوبِ الْمُشْتَاقِينَ',
      meal: 'Ey kendisine iştiyak duyanların kalplerinden kaybolmayan,',
      latin: 'Yâ Men la yeğibü ‘an kulûbi’l-müştâkın',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ غَايَةُ مُرَادِ الْمُرِيدِينَ',
      meal: 'Ey kendisini arzulayanların son arzusu,',
      latin: 'Yâ Men hüve gâyetü mürâdi’l-mürîdîn',
      no: 9,
    },
    {
      arab: 'يَا مَنْ لَا يَخْفٰى عَلَيْهِ شَىْءٌ فِى الْعَالَمِينَ',
      meal: 'Ey âlemde hiçbir şey kendisine gizli olmayan,',
      latin: 'Yâ Men la yahfâ ‘aleyhi şey’ün fı’l-‘âlemîn',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٧﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '98': [
    {
      arab: 'يَا مَنْ هُوَ عِلْمُهُ سَابِقٌ',
      meal: 'Ey her şeyi var olmadan bilen,',
      latin: 'Yâ Men hüve ‘ilmühû sabık',
      no: 1,
    },
    {
      arab: 'يَا مَنْ هُوَ وَعْدُهُ صَادِقٌ',
      meal: 'Ey vaadi doğru olan,',
      latin: 'Yâ Men hüve va’dühû sâdık',
      no: 2,
    },
    {
      arab: 'يَا مَنْ هُوَ لُطْفُهُ ظَاهِرٌ',
      meal: 'Ey lütfü açık olan,',
      latin: 'Yâ Men hüve lütfühû zahir',
      no: 3,
    },
    {
      arab: 'يَا مَنْ هُوَ اَمْرُهُ غَالِبٌ',
      meal: 'Ey emri üstün ve galip olan,',
      latin: 'Yâ Men hüve emruhû ğâlib',
      no: 4,
    },
    {
      arab: 'يَا مَنْ هُوَ كِتَابُهُ مُحْكَمٌ',
      meal: 'Ey kitabı sağlam olan,',
      latin: 'Yâ Men hüve kitâbühû muhkem',
      no: 5,
    },
    {
      arab: 'يَا مَنْ هُوَ قَضَٓاؤُهُ كَٓائِنٌ',
      meal: 'Ey kaza ve hükmü var olan,',
      latin: 'Yâ Men hüve kadâühû kâin',
      no: 6,
    },
    {
      arab: 'يَا مَنْ هُوَ قُرْاٰنُهُ مَجِيدٌ',
      meal: 'Ey Kur’ân’ı yüce olan,',
      latin: 'Yâ Men hüve kur’anühû mecîd',
      no: 7,
    },
    {
      arab: 'يَا مَنْ هُوَ مُلْكُهُ قَدِيمٌ',
      meal: 'Ey saltanatı kadîm olan,',
      latin: 'Yâ Men hüve mülkühû kadîm',
      no: 8,
    },
    {
      arab: 'يَا مَنْ هُوَ فَضْلُهُ مُقِيمٌ',
      meal: 'Ey fazıl ve keremi dâim olan,',
      latin: 'Yâ Men hüve fadlühû mukîm',
      no: 9,
    },
    {
      arab: 'يَا مَنْ هُوَ عَرْشُهُ عَظِيمٌ',
      meal: 'Ey Arşı büyük olan,',
      latin: 'Yâ Men hüve ‘arşühû ‘azîm',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٨﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '99': [
    {
      arab: 'يَا رَبَّ الْاَرْبَابِ',
      meal: 'Ey rablık iddia edenlerin ve bütün terbiyecilerin Rabbi,',
      latin: '1Yâ Rabbe’l-erbâb',
      no: 1,
    },
    {
      arab: 'يَا مُفَتِّحَ الْاَبْوَابِ',
      meal: 'Ey bütün kapıları açan,',
      latin: 'Yâ Mufettiha’l-ebvâb',
      no: 2,
    },
    {
      arab: 'يَا مُسَبِّبَ الْاَسْبَابِ',
      meal: 'Ey sebepler tasarrufunda bulunan,',
      latin: 'Yâ Musebbibe’l-esbâb',
      no: 3,
    },
    {
      arab: 'يَا مُعْطِىَ الثَّوَابِ',
      meal: 'Ey sevapları veren,',
      latin: 'Yâ Mu’tiye’s sevâb',
      no: 4,
    },
    {
      arab: 'يَا مُلْهِمَ الصَّوَابِ',
      meal: 'Ey doğruları ilham eden,',
      latin: 'Yâ Mulhime’s-savâb',
      no: 5,
    },
    {
      arab: 'يَا مُنْشِىَٔ السَّحَابِ',
      meal: 'Ey bulutları yoktan yaratan,',
      latin: 'Yâ Munşie’s-sehâb',
      no: 6,
    },
    {
      arab: 'يَا شَدِيدَ الْعِقَابِ',
      meal: 'Ey azap ve ikabı şiddetli olan,',
      latin: 'Yâ Şedîde’l-‘ikâb',
      no: 7,
    },
    {
      arab: 'يَا سَرِيعَ الْحِسَابِ',
      meal: 'Ey hesabı süratli gören,',
      latin: 'Yâ Seri’a’l-hisâb',
      no: 8,
    },
    {
      arab: 'يَا مَنْ لَهُ اْلاِيَابُ',
      meal: 'Ey dönüş kendisine olan,',
      latin: 'Yâ Men lehü’l-iyâb',
      no: 9,
    },
    {
      arab: 'يَا غَفُورُ يَا تَوَّابُ',
      meal: 'Ey bağışlayan ve tövbeleri kabul eden,',
      latin: 'Yâ Gafuru yâ Tevvâb',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿٩٩﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.',
    },
  ],
  '100': [
    {
      arab: 'وَ اَسْئَلُكَ بِاَسْمَٓائِكَ يَا رَبَّنَا',
      meal: 'Allah’ım! Senden şu isimlerinin hakkı için istiyor ve yalvarıyorum:Ey Rabbimiz',
      latin: 'Ve es’elüke biesmâike Yâ Rabbena',
      no: 1,
    },
    {
      arab: 'يَا اِلٰهَنَا',
      meal: 'Ey İlâhımız',
      latin: 'Yâ İlâhenâ',
      no: 2,
    },
    {
      arab: 'يَا سَيِّدَنَا',
      meal: 'Ey Seyyidimiz',
      latin: 'Yâ Seyyidenâ',
      no: 3,
    },
    {
      arab: 'يَا مَوْلٰينَا',
      meal: 'Ey Mevlâmız',
      latin: 'Yâ Mevlânâ',
      no: 4,
    },
    {
      arab: 'يَا نَاصِرَنَا',
      meal: 'Ey Yardımcımız',
      latin: 'Yâ Nâsıranâ',
      no: 5,
    },
    {
      arab: 'يَا حَافِظَنَا',
      meal: 'Ey Koruyucumuz',
      latin: 'Yâ Hafızana',
      no: 6,
    },
    {
      arab: 'يَا قَادِرَنَا',
      meal: 'Ey Kâdirimiz',
      latin: 'Yâ Kâdiranâ',
      no: 7,
    },
    {
      arab: 'يَا رَازِقَنَا',
      meal: 'Ey Râzıkımız',
      latin: 'Yâ Râzikanâ',
      no: 8,
    },
    {
      arab: 'يَا دَلِيلَنَا',
      meal: 'Ey Delilimiz',
      latin: 'Yâ Delîlenâ',
      no: 9,
    },
    {
      arab: 'يَا مُغِيثَنَا',
      meal: 'Ey Medetkârımız',
      latin: 'Yâ Muğisenâ',
      no: 10,
    },
    {
      arab: 'سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ خَلِّصْنَا مِنَ النَّارِ ﴿١٠٠﴾',
      meal: 'Bütün kusurlardan münezzehsin, Senden başka ilâh yok! Emân ver bize. Bizi Cehennemden kurtar.',
      latin: 'Sübhâneke yâ lâ ilahe illâ ente’l-emâ-ne’l-emâne hallisnâ mine’n-nâr.”',
    },
  ],
  '101': [
    {
      arab: 'اَللّٰهُمَّ رَبَّنَا ٭ خَلِّصْنَا ٭ وَ اَجِرْنَا ٭ وَ نَجِّنَا مِنَ النَّارِ ٭',
      meal: 'Ey Allah’ım, ey Rabbimiz! Bizi Cehennem ateşinden halâs eyle, muhafaza et, necat ver!',
      latin: 'Allâhümme Rabbenâ * hallisnâ * ve ecirnâ * ve neccinâ mine’n-nâr.',
    },
    {
      arab: 'وَ عَافِنَا وَ اعْفُ عَنَّا وَ اَدْخِلْنَا الْجَنَّةَ دَارَ قُدْسِكَ مَعَ الْاَبْرَارِ ٭ بِعَفْوِكَ يَا مُجِيرُ ٭ بِفَضْلِكَ يَا غَفَّارُ',
      meal: 'Allah’ım, bize âfiyet ver, bizi affet, bizi iyilerle birlikte pâk ve temiz diyarın olan Cennete koy. \nBunu sadece affınla yap, ey kullarını azaptan koruyan Mücîr! Fazıl ve kereminle olsun, ey bütün günahları bağışlayan Gafur',
      latin: 'Ve âfinâ va’fü annâ ve edhilne’l-cennete dâra kudsike mea’l-ebrâr * bi-afvike yâ Mücîr * bi-fadlike yâ Gaffâr.',
    },
    {
      arab: 'وَ اَسْئَلُكَ بِحَقِّ هٰذِهِ الْاَسْمَٓاءِ الْكَر۪يمَةِ الشَّر۪يفَةِ وَ الصِّفَاتِ الْجَلِيلَةِ الَّلطِيفَةِ اَنْ تُصَلِّىَ عَلٰى سَيِّدِنَا مُحَمَّدٍ وَ عَلٰٓى اٰلِهِ وَ صَحْبِهِ بِعَدَدِ حَسَنَاتِ مُحَمَّدٍ بِسْمِ اللّٰهِ ٭ حَسْبِىَ اللّٰهُ ٭ لَٓا اِلٰهَ اِلَّا اللّٰهُ ٭ شَهِدَ اللّٰهُ ٭ قُلْ هُوَ اللّٰهُ ٭ مَا شَٓاءَ اللّٰهُ ٭ رَبِّىَ اللّٰهُ ٭ تَبَارَكَ اللّٰهُ ٭ تَعَالَى اللّٰهُ ٭ تَوَكَّلْتُ عَلَى اللّٰهِ ٭ فَسَيَكْف۪يكَهُمُ اللّٰهُ وَ هُوَ السَّمِيعُ الْعَلِيمُ',
      meal: 'Ben, şu kıymetli ve şerefli isimlerinin, şu yüce ve lâtif sıfatlarının hakkı için istiyor ve yalvarıyorum ki, Efendimiz Muhammed Aleyhisselâtü Vesselâma, onun yaptığı iyilikler sayısınca salât ve selâm eyle! \nAllah’ın ismiyle. Allah bana kâfi. Allah’tan başka ilâh yok. Allah her şeye şahit. De ki; O Allah’tır. Allah’ın dilediği olur. Rabbim Allah’tır. Allah’ın şânı yücedir. Allah âlîdir. Allah’a tevekkül edip güvendim. Allah onlara karşı sana kâfidir. O her şeyi işiten ve bilendir.',
      latin: 'Ve es’elüke bi-hakkı hâzihi’l-esmâi’l-kerîmeti’ş-şerîfeti ve’s-sıfâti’l-celîleti’l-latîfeti en tüsalliye alâ seyyidinâ Muhammedin ve alâ âlihî ve sahbihî bi-adedi hasenâti Muhammedin. Bismillâh * hasbiyallâh * lâ ilâhe illallâh * şehidallâh * kul hüvallâh * mâ şâallâh * rabbiyallâh * tebârakallâh * teâlallâh * tevekkeltü alallâh * feseyekfîkehumullâh ve hüve’s-semîu’l-alîm.',
    },
    {
      arab: `سُبْحَانَكَ يَا لَٓا اِلٰهَ اِلَّا ٓ اَنْتَ الْاَمَانَ الْاَمَانَ لَٓا اُحْصِى ثَنَٓاءً عَلَيْكَ اَنْتَ كَمَٓا اَثْنَيْتَ عَلٰى نَفْسِكَ ٭ يَٓا اَللّٰهُ ٭ يَا رَحْمٰنُ ٭ يَا رَحِيمُ ٭ يَا غَفُورُ ٭ يَا شَكُورُ ٭ اَسْئَلُكَ بِمَٓا اَحْصَيْتَهُ عَلَيْكَ مِنْ اَسْمَٓائِكَ الْحُسْنٰى وَ صِفَاتِكَ الْعُلْيَا وَ كَلِمَاتِكَ التَّٓامَّةِ اَنْ تَغْفِرَلِى وَ لِوَالِدَىَّ وَ لاُسْتَاذِى سَعِيدِ النُّورْسِى وَ لِطَلَبَةِ رَسَٓائِلِ النُّورِ وَ لِجَمِيعِ الْمُؤْمِنِينَ وَ الْمُؤْمِنَاتِ وَ الْمُسْلِمِينَ وَ الْمُسْلِمَاتِ الْاَحْيَٓاءِ مِنْهُمْ وَ الْاَمْوَاتِ وَ تَرْحَمَنَا رَحْمَةً تُغْنِينَابِهَا عَنْ رَحْمَةِ مَنْ سِوَاكَ مِنْ خَلْقِكَ وَ اَنْ تَقْضِىَ حَوَايِجَنَا وَ تُعْطِيَنَا سُؤَالَنَا فِى الدُّنْيَا وَ اْلاٰخِرَةِ وَ تَخْتِمَ لَنَا بِالسَّعَادَةِ وَ الشَّهَادَةِ وَ الْكَرَامَةِ وَ الْبُشْرٰى عِنْدَ فِرَاقِ الدُّنْيَا وَ تَجْزِىَ مُحَمَّدًا صَلَّى اللّٰهُ عَلَيْهِ وَ سَلَّمَ عَنَّا مَا هُوَ اَهْلُهُ وَ مُسْتَحَقُّهُ`,
      meal: 'Bütün kusurlardan münezzehsin. Ey kendisinden başka ilah olmayan Allah’ım! Eman ver bize, eman diliyorum. Sana olan medih ve senâları sayıp dökemiyorum. Sen, Zâtını övdüğün gibisin. \nEy bütün kemâl sıfatlarını taşıyan hakikî Ma’bud olan Allah! Ey bütün mahlûkata rızık verip merhamet eden Rahman! Ey ahirette sâlih kullarına lütuflarda bulunacak olan Rahîm! Ey bütün günahları bağışlayan Gafûr! Ey kullarının ibâdet ve şükürlerine bol mükâfatla karşılık veren Şekûr! \n Zâtın için saydığın güzel isimlerin, yüce sıfatların ve eksiksiz kelimelerin hakkı için Senden istiyor ve yalvarıyorum ki, beni, anne-babamı, Üstadım Said Nursî’yi, Nur Talebelerini ve bütün erkek ve kadın mümin ve Müslümanlardan hayatta olan ve ölenleri bağışla! \nDünyada ve ahirette ihtiyaçlarımızı yerine getir ve dilediğimizi ihsan eyle! Dünyadan ayrılırken son nefesimizi saâdet, şehâdet, ikram ve müjdeyle vermemizi nasip eyle! \nBizim adımıza Hazret-i Muhammed Aleyhissalâtü Vesselâmı lâyık ve müstahak olduğu şeylerle mükâfatlandır. ',
      latin: 'Sübhâneke yâ lâ ilâhe illâ ente’l-emâne’l-emâne. Lâ uhsî senâen aleyke, ente kemâ esneyte alâ nefsike * Yâ Allâh * Yâ Rahmân * Yâ Rahîm * Yâ Gafûr * Yâ Şekûr * Es’elüke bimâ ahsaytehû aleyke min esmâike’l-hüsnâ ve sıfâtike’l-ulyâ ve kelimâtike’t-tâmmeti en tağfira lî ve li-vâlideyye ve li-üstâzî Saîdi’n-Nursî ve li-talebeti Resâili’n-Nûr ve li-cemîi’l-mü’minîne ve’l-mü’minâti ve’l-müslimîne ve’l-müslimâti’l-ahyâi minhum ve’l-emvâti. Ve terhamenâ rahmeten tuğnînâ bihâ an rahmeti men sivâke min halkıke. Ve en takdiye havâicenâ ve tu’tiyenâ suâlenâ fi’d-dünyâ ve’l-âhirati ve tahtime lenâ bi’s-saâdeti ve’ş-şehâdeti ve’l-kerâmeti ve’l-büşrâ inde firâki’d-dünyâ. Ve tecziye Muhammeden sallallâhu aleyhi ve sellem annâ mâ huve ehluhû ve müstehakkuhû.',
    },
    {
      arab: 'وَ اَنْ لَا تَكِلَنَا عَلَٓى اَنْفُسِنَا طَرْفَةَ عَيْنٍ وَ لَٓا اِلَٓى اَحَدٍ مِنْ خَلْقِكَ',
      meal: 'Gözümüzü açıp kapayıncaya kadar bizi ne nefsimize, ne de yaratıklarından hiç birine havâle etme!',
      latin: 'Ve en lâ tekilenâ alâ enfüsinâ tarfete aynin ve lâ ilâ ehadin min halkıke.',
    },
    {
      arab: 'وَ تُصْلِحَ لَنَا شَاْنَنَا وَ اَنْ تَحْرُسَنَا بِعَيْنِكَ الَّتِى لَا تَنَامُ وَ تَحْفَظَنَا بِرُكْنِكَ الَّذِى لَا يُرَامُ يَا ذَا الْجَلَالِ وَ اْلاِكْرَامِ',
      meal: 'İşlerimizi ıslah edip, yoluna koy! Bizi, hiç zâil olmayan ilim ve sıyânetinle himâye eyle! Ayrı yaşanamayan desteğinle bizleri muhâfaza eyle, ey Celâl ve İkram Sahibi! ',
      latin: 'Ve tusliha lenâ şe’nenâ ve en tahrusenâ bi-aynikelletî lâ tenâmü ve tahfezanâ bi-ruknikellezî lâ yürâmü, yâ Ze’l-celâli ve’l-ikrâm.',
    },
    {
      arab: `وَ اَنْ تَصْرِفَ عَنَّا وَ عَمَّنْ عُلِّقَ عَلَيْهِ هٰذِهِ الْاَسْمَٓاءُ اٰفَةَ الْجِنِّ وَ اْلاِنْسِ وَ الشَّيَاطِينِ
        وَ زَلْزَلَةَ الْاَرْضِ وَ دَكْدَكَةَ الْجِبَالِ مِنْ خَشْيَتِهِ وَ اٰفَةَ الطَّاعُونِ وَ الْوَبَٓاءِ وَ عَيْنَ السُّٓوءِ وَ وَجَعَ الْجَوَارِحِ وَسَٓائِرَ اْلاٰفَاتِ و تَحَفْظَنَا مِنْ كُلِّ شَرٍّ وَ سُٓوءٍ وَ تَرْزُقَنَا السَّلَامَةَ وَ الْعَافِيَةَ وَ الْخَيْرَ فِى الدُّنْيَا وَ اْلاٰخِرَةِ اِنَّكَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ`,
      meal: 'Bizden ve bu isimleri üzerinde taşıyan kimselerden cin, insan ve şeytanlardan gelecek âfetleri, yer sarsıntılarını ve Allah korkusundan meydana gelen dağ parçalanışlarını, tâun ve vebâ musîbetlerini, kem gözleri, vücut ağrılarını ve diğer felâketleri def eyle! \nBizi bütün şer ve kötülüklerden muhâfaza et. ',
      latin: 'Ve en tasrife annâ ve ammen ullika aleyhi hâzihi’l-esmâü âfete’l-cinni ve’l-insi ve’ş-şeyâtîni ve zelzelete’l-ardi ve dekdekete’l-cibâli min haşyetihî ve âfete’t-tâûni ve’l-vebâi ve ayne’s-sûi ve vecea’l-cevârihi ve sâire’l-âfâti. Ve tahfezanâ min külli şerrin ve sûin ve terzukanâ’s-selâmete ve’l-âfiyete ve’l-hayra fi’d-dünyâ ve’l-âhirati. İnneke alâ külli şey’in kadîr.',
    },
    {
      arab: 'بِرَحْمَتِكَ يَٓا اَرْحَمَ الرَّاحِمِينَ وَ صَلَّى اللّٰهُ عَلٰى سَيِّدِنَا مُحَمَّدٍ وَ اٰلِهِ وَ صَحْبِهِٓ اَجْمَعِينَ وَ الْحَمْدُ لِلّٰهِ رَبِّ الْعَالَمِينَ',
      meal: 'Rahmetinle bize dünyada ve âhirette selâmet, âfiyet ve hayır nasip eyle, ey merhametlilerin en merhametlisi! \nAllah, Efendimiz Hazret-i Muhammed’e (a.s.m.), onun âl ve Ashâbına sallât ve selâm eylesin! \nEzelden ebede her türlü hamd ve övgü, şükür ve minnet Âlemlerin Rabbi olan Allah’a mahsustur. ',
      latin: 'Bi-rahmetike yâ erhame’r-râhimîn ve sallallâhu alâ seyyidinâ Muhammedin ve âlihî ve sahbihî ecmaîn. Ve’l-hamdü lillâhi Rabbi’l-âlemîn.',
    },
  ],
}
